import React from "react";
import PropTypes from "prop-types";

const PatternsAndPrinciplesIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1326.000000,2001.000000 
	C884.000000,2001.000000 442.500000,2001.000000 1.000000,2001.000000 
	C1.000000,1334.333374 1.000000,667.666687 1.000000,1.000000 
	C667.666687,1.000000 1334.333374,1.000000 2001.000000,1.000000 
	C2001.000000,667.666687 2001.000000,1334.333374 2001.000000,2001.000000 
	C1776.166626,2001.000000 1551.333374,2001.000000 1326.000000,2001.000000 
M1405.362061,777.097351 
	C1402.711792,778.181580 1402.129150,779.788818 1404.001465,782.776672 
	C1401.945312,786.851135 1399.889038,790.925537 1397.159912,795.092102 
	C1396.810181,796.409485 1396.460571,797.726929 1396.001465,799.776794 
	C1393.611938,804.517883 1391.222412,809.258972 1388.159790,814.092102 
	C1387.810181,815.409485 1387.460571,816.726929 1387.001465,818.776794 
	C1384.611938,823.517883 1382.222412,828.258911 1379.159912,833.092102 
	C1378.810181,834.409546 1378.460571,835.726929 1378.001465,837.776794 
	C1375.611938,842.517883 1373.222412,847.258972 1370.159790,852.092102 
	C1369.810181,853.409485 1369.460571,854.726929 1368.999756,856.789490 
	C1366.519043,865.830200 1363.796021,874.812805 1361.612061,883.924622 
	C1357.903076,899.398743 1354.470825,914.940430 1351.036987,930.479004 
	C1345.990112,953.316101 1341.007202,976.167542 1336.067993,999.028198 
	C1332.638916,1014.899414 1329.235840,1030.777344 1325.999023,1046.688477 
	C1323.799072,1057.502075 1320.202393,1059.283691 1310.581909,1053.892090 
	C1310.317017,1053.743530 1310.143555,1053.431885 1309.913208,1052.565796 
	C1309.255493,1052.426392 1308.597778,1052.286987 1307.245605,1052.033325 
	C1305.145264,1050.739746 1303.044800,1049.446167 1300.919312,1047.532227 
	C1300.264771,1047.391846 1299.610352,1047.251465 1298.327881,1046.886597 
	C1296.866699,1045.975220 1295.405518,1045.063965 1293.919312,1043.532227 
	C1293.264771,1043.391846 1292.610352,1043.251465 1291.325317,1042.898071 
	C1289.864990,1041.982910 1288.404663,1041.067749 1286.917969,1039.528198 
	C1286.258667,1039.401367 1285.599487,1039.274536 1284.280884,1039.037231 
	C1283.187256,1038.322021 1282.093628,1037.606934 1280.985962,1036.145264 
	C1280.397827,1032.775391 1278.727661,1032.080322 1275.327515,1033.886353 
	C1273.866455,1032.975098 1272.405396,1032.063843 1270.919312,1030.532227 
	C1270.264771,1030.391846 1269.610352,1030.251465 1268.327881,1029.886597 
	C1266.866699,1028.975220 1265.405518,1028.063843 1263.919312,1026.532227 
	C1263.264771,1026.391846 1262.610352,1026.251465 1261.328125,1025.899414 
	C1259.861328,1024.998535 1258.394531,1024.097656 1256.913208,1022.566101 
	C1256.255493,1022.426697 1255.597900,1022.287292 1254.245728,1022.033447 
	C1252.145264,1020.739929 1250.044800,1019.446350 1247.919434,1017.532410 
	C1247.264893,1017.392029 1246.610474,1017.251709 1245.256958,1016.845215 
	C1243.675781,1015.908508 1242.808716,1015.234131 1241.891968,1018.015442 
	C1239.255737,1026.013794 1235.952026,1033.789917 1232.992676,1041.684204 
	C1225.871826,1060.679810 1218.802246,1079.694580 1211.703491,1098.698608 
	C1205.867920,1114.321167 1200.020264,1129.939209 1194.052490,1145.894775 
	C1207.943359,1151.034180 1221.480835,1156.033203 1235.011230,1161.051147 
	C1257.058105,1169.227905 1279.113159,1177.383179 1301.139282,1185.616089 
	C1310.373169,1189.067505 1319.534546,1193.466187 1328.838867,1185.854980 
	C1328.956299,1185.758911 1329.155396,1185.762573 1330.210938,1185.886597 
	C1333.821045,1186.250854 1336.902832,1185.855225 1337.652832,1180.850952 
	C1342.540649,1178.473877 1347.428467,1176.096802 1353.210938,1173.886597 
	C1356.821045,1174.250854 1359.902832,1173.855225 1360.652832,1168.850952 
	C1365.540649,1166.473877 1370.428467,1164.096802 1376.210938,1161.886597 
	C1379.821045,1162.250854 1382.902832,1161.855225 1383.652832,1156.850830 
	C1388.540649,1154.473755 1393.428467,1152.096680 1399.210938,1149.886597 
	C1402.821045,1150.250854 1405.902832,1149.855225 1406.652466,1144.851196 
	C1412.590576,1141.422485 1419.647095,1139.912598 1420.119385,1130.372314 
	C1420.672974,1119.186035 1423.316772,1108.106689 1424.991455,1096.971558 
	C1426.765259,1085.177734 1428.395142,1073.362183 1430.218384,1061.576294 
	C1432.062744,1049.653931 1434.110474,1037.763062 1435.988892,1025.845825 
	C1437.793091,1014.399353 1439.447632,1002.929260 1441.252930,991.482971 
	C1443.794434,975.369019 1446.401245,959.265198 1449.005005,943.161072 
	C1450.617798,933.185425 1452.354980,923.229187 1453.892578,913.242126 
	C1455.359253,903.716858 1456.394653,894.118469 1458.110229,884.640991 
	C1458.910400,880.220581 1460.869385,876.009888 1463.168579,871.879517 
	C1466.012573,872.247375 1468.156738,871.704041 1468.646484,867.855652 
	C1471.531982,866.471802 1474.417480,865.087952 1478.168579,863.879517 
	C1481.012573,864.247375 1483.156738,863.704041 1483.646484,859.855835 
	C1486.533325,858.473511 1489.420166,857.091125 1493.174316,855.881470 
	C1496.040161,856.253662 1498.167480,855.673889 1498.613403,851.780762 
	C1501.505127,850.398865 1504.396729,849.016968 1508.150635,847.860596 
	C1511.033936,848.269226 1513.158081,847.689270 1513.613403,843.780823 
	C1516.507080,842.401428 1519.400879,841.022034 1523.156128,839.863098 
	C1526.037476,840.267761 1528.159180,839.684875 1528.617676,835.777527 
	C1532.184937,834.077881 1535.752319,832.378296 1540.179810,830.875244 
	C1543.051880,831.260681 1545.163940,830.666199 1545.611328,826.781677 
	C1548.519897,825.422546 1551.428589,824.063477 1555.195801,822.883240 
	C1558.061279,823.255493 1560.167480,822.654175 1560.612427,818.781128 
	C1563.504395,817.399109 1566.396484,816.017090 1570.150635,814.860596 
	C1573.033936,815.269226 1575.158081,814.689270 1575.613403,810.780762 
	C1578.505127,809.398865 1581.396729,808.016968 1585.150635,806.860596 
	C1588.033936,807.269226 1590.158081,806.689270 1590.613403,802.780823 
	C1593.509644,801.405518 1596.405762,800.030212 1600.192871,798.869080 
	C1603.837524,799.270447 1606.909424,798.848022 1607.611328,793.781799 
	C1610.514160,792.414124 1613.416870,791.046448 1617.179810,789.875244 
	C1620.051880,790.260681 1622.163940,789.666199 1622.612305,785.781433 
	C1625.520630,784.422424 1628.428955,783.063416 1632.195801,781.883240 
	C1635.061279,782.255493 1637.167480,781.654175 1637.562744,777.819214 
	C1638.906616,776.871826 1640.250610,775.924438 1642.360962,774.951599 
	C1645.750854,772.867676 1649.077393,770.746704 1647.854248,765.170654 
	C1653.405273,757.095032 1658.956299,749.019470 1665.289307,740.946350 
	C1669.419922,735.272644 1673.555054,729.602295 1677.634399,723.891846 
	C1677.691650,723.811523 1677.047485,723.230164 1676.882324,722.186340 
	C1681.756470,715.105469 1686.630615,708.024597 1692.275635,700.946411 
	C1693.850952,700.372070 1696.027832,700.044556 1693.739380,696.998108 
	C1687.971313,696.665283 1682.203125,696.122131 1676.435425,696.128357 
	C1674.714722,696.130188 1672.685181,697.333740 1671.337646,698.574036 
	C1668.104858,701.549683 1665.192627,704.873535 1661.443237,708.033142 
	C1660.790161,708.275208 1660.137085,708.517212 1659.484009,708.759216 
	C1659.760010,709.220337 1660.036011,709.681458 1660.255371,710.833008 
	C1658.901733,712.246582 1657.548218,713.660217 1655.475830,715.041138 
	C1654.814575,715.287292 1654.153320,715.533508 1653.492065,715.779724 
	C1653.784302,716.242859 1654.076660,716.705994 1654.306396,717.884338 
	C1649.254639,723.608521 1644.202881,729.332703 1638.437866,735.033630 
	C1637.785767,735.287170 1637.133667,735.540649 1636.481689,735.794250 
	C1636.777588,736.252502 1637.073364,736.710754 1637.315552,737.892578 
	C1632.293823,743.697205 1627.253784,749.486267 1622.257812,755.312988 
	C1619.634277,758.372864 1616.565552,759.529480 1613.202148,756.843140 
	C1609.972778,754.263855 1609.452759,751.106628 1611.700195,747.269348 
	C1618.186768,736.195007 1624.432739,724.979675 1630.767944,713.816711 
	C1634.547974,707.156250 1638.318237,700.490234 1642.450684,693.195312 
	C1633.374146,693.195312 1625.237793,693.086365 1617.110229,693.302612 
	C1615.757812,693.338623 1614.249390,694.587708 1613.152222,695.632324 
	C1611.038330,697.645020 1609.166748,699.912170 1606.481323,702.040894 
	C1605.819214,702.275574 1605.157104,702.510193 1604.494995,702.744873 
	C1604.767334,703.210754 1605.039673,703.676697 1605.252319,704.841370 
	C1603.579956,706.590637 1601.907593,708.339905 1599.510864,710.048035 
	C1598.841064,710.287476 1598.171143,710.526917 1597.501343,710.766357 
	C1597.790649,711.233948 1598.079834,711.701538 1598.316040,712.890808 
	C1594.608887,716.951843 1590.901855,721.012817 1586.481323,725.040894 
	C1585.819214,725.275513 1585.157104,725.510193 1584.494995,725.744873 
	C1584.767334,726.210754 1585.039673,726.676697 1585.252197,727.841248 
	C1583.579834,729.590515 1581.907471,731.339844 1579.510864,733.048035 
	C1578.841064,733.287476 1578.171143,733.526917 1577.501343,733.766357 
	C1577.790649,734.233948 1578.079834,734.701538 1578.322510,735.864136 
	C1576.932007,737.261780 1575.541626,738.659363 1573.447876,740.032959 
	C1572.794189,740.265625 1572.140625,740.498291 1571.486938,740.730957 
	C1571.746582,741.194092 1572.006226,741.657166 1572.188232,742.860535 
	C1570.512207,744.033142 1568.836182,745.205811 1566.795654,745.758545 
	C1565.197510,746.464600 1563.599365,747.170715 1561.301514,748.193420 
	C1556.921021,749.588379 1552.540649,750.983398 1547.795654,751.758545 
	C1546.197510,752.464661 1544.599365,753.170715 1542.301147,754.193665 
	C1521.757690,760.779480 1501.250000,767.482483 1480.618286,773.779114 
	C1478.432495,774.446167 1474.638306,773.515503 1473.194946,771.895996 
	C1471.789917,770.319641 1471.581787,766.600098 1472.373779,764.361450 
	C1474.130981,759.395142 1476.843872,754.767029 1479.894531,749.987976 
	C1484.939697,747.904175 1486.103516,745.051758 1483.203369,741.299927 
	C1487.857910,731.866943 1492.512451,722.433960 1497.894531,712.987976 
	C1502.939697,710.904175 1504.103516,708.051697 1501.203491,704.299988 
	C1503.420044,699.850403 1505.636597,695.400818 1508.008545,690.639465 
	C1503.129272,691.143555 1498.778198,691.016724 1494.792969,692.162476 
	C1490.573486,693.375732 1485.320190,691.498169 1481.369629,696.032776 
	C1477.443237,696.291931 1476.805664,698.891663 1476.779907,702.722473 
	C1473.224365,706.495728 1469.668823,710.268921 1465.321655,714.018982 
	C1460.678833,714.127075 1458.778564,716.662659 1458.779907,721.722534 
	C1455.224365,725.495728 1451.668823,729.268982 1447.311157,733.019226 
	C1442.986328,732.830017 1441.711792,735.278015 1441.779907,739.722534 
	C1438.224365,743.495789 1434.668823,747.269043 1430.321655,751.018982 
	C1425.678833,751.127075 1423.778564,753.662659 1423.779907,758.722595 
	C1420.224365,762.495850 1416.668823,766.269043 1412.323853,770.018921 
	C1407.480347,769.934937 1406.338013,773.130066 1406.018433,777.009644 
	C1406.018433,777.009644 1406.096069,777.055603 1405.362061,777.097351 
M653.399963,1444.024536 
	C652.756592,1444.273804 652.113159,1444.522949 651.469727,1444.772095 
	C651.747986,1445.228638 652.026245,1445.685303 652.236816,1446.764526 
	C651.847778,1447.182861 651.458740,1447.601196 650.227966,1448.007812 
	C648.547241,1448.668457 646.566528,1449.000977 645.321960,1450.138672 
	C644.762939,1450.649658 645.229675,1453.527344 646.020203,1453.993896 
	C647.392944,1454.803955 650.099854,1455.364624 650.939087,1454.598022 
	C652.213684,1453.433350 652.370483,1451.045288 653.644409,1448.822510 
	C659.605652,1445.508789 659.605652,1445.508789 658.214844,1440.426147 
	C656.833557,1441.638550 655.467102,1442.837891 653.399963,1444.024536 
M1577.847046,716.919617 
	C1577.847046,716.919617 1577.727417,716.788086 1578.540283,716.914917 
	C1580.312256,715.695251 1582.708740,714.829468 1583.662354,713.146118 
	C1584.450928,711.754333 1578.762695,706.964661 1576.303223,706.778687 
	C1573.167725,700.945557 1570.032104,695.112427 1566.956177,688.349792 
	C1566.943726,686.053101 1567.523926,683.524231 1566.741943,681.529114 
	C1566.047607,679.757935 1563.841553,678.579224 1562.302856,677.139038 
	C1561.200317,678.640381 1560.097656,680.141785 1558.074585,681.820740 
	C1551.259155,681.833496 1544.401489,682.324158 1537.639648,681.728394 
	C1530.477783,681.097473 1525.147949,682.392212 1523.281250,690.219238 
	C1523.197998,690.567810 1522.539062,690.779114 1521.421997,691.088257 
	C1518.870850,692.394592 1516.937988,693.936951 1519.053833,697.818054 
	C1517.447266,701.501648 1515.999023,705.264587 1514.199585,708.851440 
	C1510.960083,715.308105 1507.510254,721.659119 1503.421997,728.088257 
	C1500.870850,729.394592 1498.937988,730.936951 1501.053833,734.818054 
	C1500.123291,737.052429 1499.206299,739.292542 1498.259155,741.519897 
	C1496.181274,746.406738 1494.088013,751.287109 1492.132202,756.823120 
	C1494.754028,759.014099 1495.967651,757.294617 1497.651245,754.699951 
	C1514.229980,749.395813 1530.719238,743.785217 1547.421631,738.904541 
	C1557.158325,736.059326 1565.991699,732.519226 1571.383179,723.245117 
	C1572.172852,721.886719 1573.734375,720.976990 1575.375977,720.437439 
	C1579.283325,721.239258 1577.637207,718.409180 1577.847046,716.919617 
M562.030151,1505.592896 
	C562.642761,1508.835938 562.813904,1508.958374 565.819580,1507.815063 
	C571.713074,1512.880737 577.507202,1518.068848 583.540527,1522.962158 
	C586.719177,1525.540161 590.315430,1527.603394 594.343506,1529.904541 
	C594.762817,1529.567993 595.182190,1529.231445 595.601562,1528.895020 
	C595.125244,1528.597046 594.648987,1528.299072 594.178528,1527.256592 
	C596.768860,1518.644287 599.359192,1510.032104 601.899597,1501.585815 
	C579.743591,1483.280273 557.852112,1465.193359 535.979370,1446.246460 
	C536.195740,1442.374268 533.707336,1442.886353 530.681396,1443.070312 
	C523.107788,1436.749023 515.534180,1430.427612 507.979401,1423.246460 
	C508.195923,1419.374023 505.707367,1419.886353 502.681396,1420.070312 
	C495.107788,1413.749023 487.534210,1407.427612 479.979401,1400.246460 
	C480.195923,1396.374023 477.707367,1396.886353 474.681427,1397.070312 
	C470.447662,1393.630371 466.213928,1390.190552 461.980164,1386.750610 
	C461.807556,1386.958374 461.634979,1387.166016 461.462372,1387.373779 
	C462.342438,1389.157715 463.222534,1390.941528 464.057343,1393.517822 
	C464.815399,1394.306274 465.573425,1395.094849 466.908539,1396.228149 
	C467.509491,1396.789062 468.201874,1397.279175 468.697937,1397.921143 
	C479.935303,1412.464233 491.161163,1427.016235 502.362946,1441.586792 
	C504.713776,1444.644653 506.961365,1447.781982 508.708527,1451.247192 
	C509.520264,1451.813477 510.331970,1452.379761 511.753540,1453.209473 
	C513.573730,1455.440796 515.393982,1457.672241 516.675476,1460.277832 
	C517.512512,1460.828247 518.349548,1461.378662 519.782715,1462.209595 
	C522.941345,1465.767822 526.099976,1469.326050 528.698853,1473.228271 
	C529.434570,1477.453735 531.937317,1479.689575 536.807190,1480.212036 
	C539.222839,1482.760254 541.638489,1485.308472 544.029968,1488.606323 
	C545.545044,1493.182007 548.004028,1495.332153 551.807678,1494.850342 
	C555.223145,1498.185669 558.638611,1501.520996 562.030151,1505.592896 
M903.762878,931.008606 
	C914.912292,927.685425 925.987122,924.067017 937.256470,921.218140 
	C940.656799,920.358521 940.978088,918.971252 941.041870,916.212219 
	C941.267456,906.451477 941.802551,896.697083 941.972412,886.935974 
	C942.388550,863.019043 942.625488,839.098999 943.030640,815.181763 
	C943.124695,809.625549 943.602112,804.075806 943.931519,797.999939 
	C941.860229,797.999939 940.075562,798.000610 938.290894,797.999817 
	C930.795898,797.996643 923.294922,798.184570 915.807129,797.950989 
	C898.452087,797.409668 881.104919,796.606873 863.748535,796.132202 
	C862.602295,796.100830 860.639526,797.752502 860.349548,798.937622 
	C857.398987,810.996643 854.783325,823.136902 851.945740,835.224365 
	C846.665710,857.716187 841.526794,880.246094 835.784790,902.620422 
	C834.597412,907.247009 836.454224,907.905579 839.687439,909.058899 
	C849.155457,912.436279 858.532166,916.069031 867.988159,919.481201 
	C878.968323,923.443237 889.994568,927.277222 901.089172,931.727539 
	C901.407288,932.021057 901.725403,932.314636 902.043518,932.608154 
	C902.362061,932.127686 902.680603,931.647278 903.762878,931.008606 
M681.516602,1650.902954 
	C681.970703,1649.824097 682.424866,1648.745117 682.941101,1646.974609 
	C686.538513,1640.984375 690.135925,1634.994141 694.509827,1628.906128 
	C694.971558,1627.843994 695.433289,1626.781860 695.947815,1625.021240 
	C699.543640,1619.014282 703.139465,1613.007324 707.378906,1606.955444 
	C707.549561,1606.289307 707.720215,1605.623047 708.131042,1604.134766 
	C706.311768,1597.328613 704.684509,1590.463989 702.638794,1583.726562 
	C695.051147,1558.736084 687.381042,1533.770142 679.632385,1508.828979 
	C674.468628,1492.208618 669.119141,1475.645874 664.496155,1458.957397 
	C664.547974,1458.137695 664.599792,1457.317871 664.651672,1456.498169 
	C663.781311,1457.369385 662.910889,1458.240723 661.725220,1459.754028 
	C649.701172,1466.125854 637.636108,1472.422729 625.696533,1478.948975 
	C623.869507,1479.947754 621.998962,1481.751465 621.233398,1483.625854 
	C619.545227,1487.759277 618.547424,1492.174927 617.271301,1496.476440 
	C614.344421,1506.341797 611.455933,1516.218628 608.483582,1526.070312 
	C605.559326,1535.762207 601.128662,1545.464111 609.233398,1554.867310 
	C609.413269,1555.076172 609.332153,1555.510132 608.747986,1556.211792 
	C607.331360,1558.883057 608.815674,1559.687744 611.786438,1560.233521 
	C615.238892,1567.135620 618.691284,1574.037598 621.575256,1581.343140 
	C622.448181,1582.538330 623.321167,1583.733521 624.830750,1585.213745 
	C627.935120,1591.455688 631.039429,1597.697754 633.576843,1604.340210 
	C634.434692,1605.541992 635.292480,1606.743652 636.786438,1608.233521 
	C639.981873,1614.435303 643.177368,1620.637207 645.747986,1627.211792 
	C644.331360,1629.883057 645.815674,1630.687744 648.809998,1631.257812 
	C650.544128,1634.075073 652.176575,1636.868896 649.532593,1640.080444 
	C646.771912,1643.433838 643.506592,1643.527100 639.754211,1641.990845 
	C631.237915,1638.503906 622.417908,1635.645264 614.215820,1631.542847 
	C608.346069,1628.606812 604.105408,1628.955200 599.483887,1634.040039 
	C598.821777,1634.265381 598.159668,1634.490723 597.497498,1634.716064 
	C597.752747,1635.183716 598.008057,1635.651245 598.192200,1636.824097 
	C596.192261,1638.906982 594.192322,1640.989868 591.483887,1643.039917 
	C590.821777,1643.265259 590.159607,1643.490723 589.497498,1643.716064 
	C589.752747,1644.183716 590.008057,1644.651245 590.190247,1645.834595 
	C588.109436,1648.249878 586.028564,1650.665039 583.633484,1653.445190 
	C609.651672,1663.673218 635.184204,1673.710449 660.870605,1683.808105 
	C662.248718,1681.766846 663.518860,1679.885620 665.554382,1677.900269 
	C666.001282,1676.840088 666.448120,1675.779907 666.912415,1674.204956 
	C667.186035,1673.804688 667.459717,1673.404419 668.516541,1672.903076 
	C668.970642,1671.824219 669.424744,1670.745239 669.941162,1668.975342 
	C673.538574,1662.984985 677.135986,1656.994507 681.516602,1650.902954 
M517.647827,1246.237183 
	C519.144348,1248.023071 520.640808,1249.809082 522.065369,1252.447876 
	C521.540100,1255.699707 523.436768,1256.236694 526.634705,1256.232056 
	C528.135437,1258.019653 529.636169,1259.807251 531.065247,1262.447998 
	C530.540222,1265.699707 532.436462,1266.236938 535.623474,1266.223877 
	C536.794922,1267.681152 537.966431,1269.138306 539.064392,1271.447266 
	C538.542480,1275.344971 540.705383,1276.304443 544.620972,1276.223755 
	C545.793091,1277.680908 546.965271,1279.137939 548.065369,1281.449585 
	C547.541260,1284.720337 549.455383,1285.236938 552.647827,1285.237183 
	C554.144348,1287.023071 555.640808,1288.809082 557.065369,1291.447876 
	C556.540100,1294.699707 558.436768,1295.236694 561.634827,1295.232056 
	C563.135681,1297.019775 564.636475,1298.807373 566.065247,1301.447998 
	C565.539978,1304.699951 567.436462,1305.236938 570.633362,1305.232910 
	C572.134521,1307.020264 573.635681,1308.807617 575.065247,1311.447998 
	C574.540222,1314.699707 576.436462,1315.236938 579.620972,1315.223755 
	C580.793213,1316.680908 581.965454,1318.138184 583.065613,1320.449707 
	C582.541199,1323.720703 584.455627,1324.236816 587.647827,1324.237183 
	C589.144348,1326.023071 590.640808,1327.808960 592.065430,1330.447754 
	C591.539917,1333.699707 593.436707,1334.236572 596.634827,1334.232056 
	C598.135681,1336.019775 599.636475,1337.807373 601.065247,1340.447998 
	C600.539978,1343.699951 602.436462,1344.236938 605.633362,1344.232910 
	C607.134583,1346.020264 608.635742,1347.807617 610.065247,1350.447998 
	C609.540222,1353.699707 611.436462,1354.236938 614.620972,1354.223755 
	C615.793213,1355.680908 616.965454,1357.138184 618.065613,1359.449707 
	C617.541199,1362.720703 619.455627,1363.236816 622.647827,1363.237183 
	C624.144348,1365.023071 625.640808,1366.808960 627.065430,1369.449341 
	C626.541382,1372.719971 628.455078,1373.237183 631.653687,1373.292725 
	C633.523804,1375.821777 635.393860,1378.350830 636.710327,1381.252563 
	C637.551453,1381.805420 638.392578,1382.358276 639.818054,1383.211304 
	C641.952332,1385.774414 644.086670,1388.337524 645.680176,1391.274414 
	C646.517944,1391.825073 647.355713,1392.375732 648.791321,1393.206543 
	C650.641296,1395.405762 652.491333,1397.604858 653.781860,1400.168701 
	C654.029907,1400.717407 654.277954,1401.266235 654.526062,1401.814941 
	C654.971436,1401.071533 655.416809,1400.328003 655.781799,1398.787231 
	C654.521790,1382.310791 653.203003,1365.838623 652.021545,1349.356445 
	C651.181091,1337.632812 650.625305,1325.888428 649.763306,1314.166504 
	C648.599792,1298.343506 647.178345,1282.539185 646.030151,1266.715088 
	C645.155579,1254.661255 644.656616,1242.580078 643.772522,1230.526978 
	C642.273132,1210.085083 640.579468,1189.657471 639.010193,1169.220459 
	C637.857849,1154.213623 636.774048,1139.201416 636.215027,1123.836426 
	C635.994873,1123.282471 635.774780,1122.728638 635.554565,1122.174683 
	C635.065186,1122.862061 634.575806,1123.549438 634.060059,1124.920166 
	C633.012756,1125.933716 632.039795,1127.040039 630.907043,1127.947021 
	C611.294373,1143.649780 591.662048,1159.328003 571.216736,1175.006836 
	C567.068298,1174.698486 566.734863,1177.273315 566.853943,1180.979736 
	C564.580627,1183.323730 562.307373,1185.667725 559.216736,1188.006836 
	C555.068726,1187.698730 554.734436,1190.272827 554.855957,1193.979248 
	C552.581970,1196.323364 550.307983,1198.667480 547.216736,1201.006836 
	C543.069458,1200.699097 542.733765,1203.271851 542.858826,1206.980469 
	C540.590576,1209.326660 538.322327,1211.672974 535.222168,1214.011597 
	C531.663330,1213.698853 531.895325,1216.048218 531.853943,1218.979736 
	C529.580688,1221.323730 527.307373,1223.667725 524.216736,1226.006836 
	C520.068726,1225.698730 519.734436,1228.272827 519.852905,1231.982056 
	C517.614380,1235.186401 515.375854,1238.390747 513.065369,1242.449585 
	C512.541260,1245.720337 514.455383,1246.236938 517.647827,1246.237183 
M557.777893,1171.988403 
	C561.336731,1172.301270 561.104736,1169.952026 561.154480,1167.010986 
	C562.967957,1164.921631 564.781494,1162.832397 566.594971,1160.743042 
	C566.116333,1160.996826 565.637634,1161.250610 565.158997,1161.504272 
	C536.282959,1132.627808 507.406921,1103.751343 478.472290,1074.816284 
	C437.301117,1142.802246 395.704834,1211.490112 353.981903,1280.387207 
	C356.314789,1282.518311 358.685699,1284.684204 361.032440,1287.548706 
	C361.721039,1287.958374 362.409637,1288.368042 363.821808,1288.812866 
	C367.861786,1292.001465 371.974731,1295.102783 375.922455,1298.401733 
	C380.378021,1302.125122 384.684967,1306.026245 389.032410,1310.548706 
	C389.721008,1310.958374 390.409607,1311.368042 391.821747,1311.812866 
	C395.861725,1315.001465 399.974609,1318.102783 403.922424,1321.401855 
	C408.377991,1325.125122 412.684998,1329.026245 417.032410,1333.548706 
	C417.721008,1333.958374 418.409607,1334.368042 419.821808,1334.812866 
	C423.861816,1338.001465 427.974670,1341.102905 431.922394,1344.401855 
	C436.377991,1348.125122 440.685028,1352.026245 445.032379,1356.548828 
	C445.720978,1356.958496 446.409576,1357.368164 447.821838,1357.812744 
	C451.861816,1361.001343 455.974670,1364.102783 459.922424,1367.401855 
	C464.377960,1371.125122 468.684998,1375.026245 473.032410,1379.548706 
	C473.721008,1379.958374 474.409607,1380.368042 475.821808,1380.812866 
	C479.861786,1384.001465 483.974640,1387.102905 487.922363,1390.401855 
	C492.377991,1394.125122 496.684937,1398.026367 501.032379,1402.548706 
	C501.720978,1402.958374 502.409576,1403.368042 503.821747,1403.812866 
	C507.861755,1407.001465 511.974731,1410.102783 515.922424,1413.401855 
	C520.377930,1417.125244 524.684937,1421.026245 529.032471,1425.548950 
	C529.721008,1425.958496 530.409546,1426.368164 531.821716,1426.812744 
	C535.861755,1430.001465 539.974670,1433.102783 543.922424,1436.401855 
	C548.377930,1440.125244 552.684937,1444.026245 557.032532,1448.548828 
	C557.721069,1448.958374 558.409607,1449.368042 559.821716,1449.812744 
	C563.861755,1453.001465 567.974670,1456.102783 571.922363,1459.401855 
	C576.377930,1463.125244 580.684937,1467.026245 585.032532,1471.548828 
	C585.721069,1471.958374 586.409607,1472.368042 587.821777,1472.812744 
	C592.904419,1477.142456 597.987000,1481.472168 603.103577,1486.467529 
	C603.917297,1486.558594 604.922424,1486.993286 605.504761,1486.668945 
	C606.695801,1486.005371 607.522339,1484.617920 608.742004,1484.087769 
	C612.947815,1482.259033 613.320007,1479.310425 609.777222,1475.173218 
	C610.157532,1474.387695 610.537781,1473.602173 611.326965,1473.392700 
	C615.087280,1474.664429 613.574463,1471.604858 614.599365,1469.792847 
	C620.025330,1463.866577 625.627991,1458.090942 630.837219,1451.979858 
	C639.281677,1442.073486 647.468018,1431.947021 656.447937,1421.890869 
	C656.296204,1420.307007 656.281799,1418.684448 655.858276,1417.176880 
	C655.787292,1416.924194 653.943726,1417.169556 652.320496,1416.897217 
	C650.834412,1415.066284 649.348328,1413.235229 647.935059,1410.573853 
	C647.611084,1406.135742 647.254883,1405.830078 643.333496,1406.873535 
	C641.843140,1405.050537 640.352844,1403.227661 638.933838,1400.583374 
	C638.808411,1396.847900 638.512390,1396.617310 635.303345,1397.912598 
	C633.489807,1395.743408 631.676270,1393.574097 629.934692,1390.552002 
	C630.460083,1387.300049 628.563416,1386.763184 625.365234,1386.767822 
	C623.864441,1384.980225 622.363647,1383.192505 620.934692,1380.552002 
	C621.460083,1377.300049 619.563538,1376.763062 616.366638,1376.766968 
	C614.865417,1374.979614 613.364258,1373.192139 611.934814,1370.551758 
	C612.459961,1367.299927 610.563477,1366.763062 607.379211,1366.776245 
	C606.206970,1365.319092 605.034668,1363.861816 603.934448,1361.550293 
	C604.458923,1358.279175 602.544250,1357.763306 599.352173,1357.762573 
	C597.855713,1355.976685 596.359192,1354.190918 594.934570,1351.552246 
	C595.460205,1348.300171 593.563416,1347.763306 590.365234,1347.767822 
	C588.864441,1345.980225 587.363647,1344.192505 585.934692,1341.552002 
	C586.460083,1338.300049 584.563538,1337.763062 581.366638,1337.766968 
	C579.865417,1335.979614 578.364258,1334.192139 576.934814,1331.551758 
	C577.459961,1328.299927 575.563477,1327.763062 572.379211,1327.776245 
	C571.206909,1326.319092 570.034668,1324.861938 568.934448,1322.550293 
	C569.458923,1319.279175 567.544250,1318.763306 564.352173,1318.762573 
	C562.855652,1316.976685 561.359192,1315.190918 559.934570,1312.552246 
	C560.460205,1309.300171 558.563416,1308.763306 555.365234,1308.767822 
	C553.864441,1306.980225 552.363647,1305.192505 550.934692,1302.552002 
	C551.460083,1299.300049 549.563538,1298.763062 546.366638,1298.766968 
	C544.865479,1296.979614 543.364319,1295.192139 541.934753,1292.551758 
	C542.460022,1289.299805 540.562988,1288.763428 537.379150,1288.776123 
	C536.206787,1287.318848 535.034485,1285.861572 533.935730,1283.552734 
	C534.457275,1279.655518 532.294800,1278.695557 528.384338,1278.765991 
	C527.210449,1277.312256 526.036621,1275.858643 524.934570,1273.550537 
	C525.458740,1270.279785 523.544617,1269.763062 520.353149,1269.761230 
	C518.856384,1267.975830 517.359619,1266.190308 515.934753,1263.552002 
	C516.459961,1260.300049 514.563599,1259.762939 511.366699,1259.766968 
	C509.865448,1257.979614 508.364227,1256.192139 506.934784,1253.551758 
	C507.459839,1250.300049 505.563263,1249.763184 502.379150,1249.776123 
	C501.206818,1248.318726 500.034454,1246.861450 498.927094,1244.602417 
	C498.204651,1243.763306 497.482208,1242.924072 496.309509,1241.565430 
	C496.869232,1239.708984 497.428955,1237.852661 498.803009,1235.996460 
	C502.944000,1236.291870 503.261810,1233.713745 503.143677,1230.021240 
	C505.411102,1227.674438 507.678528,1225.327637 510.765778,1222.990479 
	C514.918152,1223.308716 515.270020,1220.741089 515.139038,1217.021973 
	C517.081360,1215.010742 519.023682,1212.999512 521.783325,1210.993042 
	C525.931335,1211.301270 526.265442,1208.727051 526.145935,1205.020508 
	C528.419312,1202.676392 530.692688,1200.332397 533.783325,1197.993164 
	C537.931274,1198.301270 538.265442,1195.727173 538.143860,1192.020874 
	C540.417908,1189.676636 542.691956,1187.332397 545.783386,1184.993164 
	C549.931030,1185.301147 550.265686,1182.727539 550.141357,1179.019409 
	C552.409546,1176.673096 554.677734,1174.326904 557.777893,1171.988403 
M866.781128,432.673157 
	C860.842834,435.725891 859.319031,441.750854 858.194214,447.301514 
	C855.965759,458.298004 854.398865,469.459076 853.169250,480.619415 
	C851.765564,493.358948 850.440857,506.157745 850.133545,518.956055 
	C849.636963,539.634338 849.870361,560.334412 850.037964,581.023315 
	C850.192749,600.117615 850.614624,619.210449 851.020447,638.301758 
	C851.235107,648.399597 851.697876,658.492004 851.991943,668.588501 
	C852.358582,681.176086 852.611328,693.767273 853.022400,706.353271 
	C853.243225,713.113892 853.589478,719.874390 854.064636,726.621826 
	C854.676758,735.313965 855.543762,743.988098 856.174377,752.679138 
	C856.873474,762.313904 857.429810,771.959045 858.039246,781.457581 
	C862.794617,782.027344 866.838867,782.773376 870.907715,782.949219 
	C881.996521,783.428284 893.095886,783.660706 904.190735,784.001587 
	C914.786194,784.327026 925.380920,784.674072 935.976440,784.997009 
	C947.237793,785.340271 958.500061,785.656982 969.761353,786.002686 
	C980.190308,786.322876 990.616577,786.758362 1001.047546,786.979065 
	C1020.138916,787.383057 1039.234497,787.593628 1058.324585,788.044250 
	C1064.046509,788.179321 1069.755737,788.843689 1075.751343,789.286316 
	C1092.204102,675.634949 1108.566162,562.610229 1125.002686,449.071136 
	C1110.007446,446.366119 1095.247314,443.441681 1080.395020,441.102905 
	C1067.304688,439.041595 1054.104980,437.680389 1040.964966,435.924683 
	C1029.123779,434.342590 1017.316650,432.492249 1005.459045,431.051727 
	C997.610596,430.098297 989.707458,429.540924 981.815002,429.013153 
	C960.910095,427.615356 940.007690,426.124786 919.082947,425.110596 
	C911.687561,424.752167 904.173218,425.204620 896.816223,426.117218 
	C887.820129,427.233185 878.932312,429.221954 869.873596,430.184784 
	C868.924194,430.005768 867.974854,429.826721 867.025452,429.647705 
	C867.052490,430.448212 867.079529,431.248749 866.781128,432.673157 
M1128.274170,1664.375366 
	C1128.849487,1663.932617 1129.424683,1663.489868 1130.802856,1662.896240 
	C1144.664551,1659.569092 1158.560669,1656.377197 1172.376465,1652.869019 
	C1182.260986,1650.359253 1192.038086,1647.425781 1202.241577,1645.291626 
	C1203.827759,1644.520386 1205.413818,1643.749023 1207.596313,1642.616211 
	C1208.698364,1642.335815 1209.800293,1642.055420 1211.335938,1642.385498 
	C1214.131226,1643.401855 1216.288696,1643.121460 1217.353516,1639.127441 
	C1234.826660,1632.092285 1252.307007,1625.075073 1269.768799,1618.011719 
	C1275.516479,1615.686890 1281.216187,1613.243652 1287.380615,1611.442383 
	C1294.291382,1611.345337 1299.552490,1607.613403 1304.592041,1603.494995 
	C1305.058716,1603.113647 1304.879517,1601.941528 1305.620239,1600.775269 
	C1315.757080,1595.116699 1325.934448,1589.529297 1336.016479,1583.774902 
	C1342.855103,1579.871704 1349.560059,1575.734253 1357.157349,1571.876831 
	C1362.814819,1569.979492 1368.624512,1568.290527 1371.244141,1561.206421 
	C1377.005371,1557.130127 1382.874634,1553.196899 1388.505493,1548.947632 
	C1399.911743,1540.339722 1411.188965,1531.560669 1423.394165,1522.927979 
	C1426.755737,1523.463501 1427.255005,1521.509033 1427.166748,1518.303833 
	C1427.975464,1517.823120 1428.784302,1517.342407 1430.455566,1516.934570 
	C1433.819336,1517.451416 1434.234985,1515.452148 1434.189209,1512.281982 
	C1435.323975,1511.475220 1436.458740,1510.668457 1438.450806,1509.935425 
	C1442.450073,1510.449219 1443.323730,1508.203003 1443.206543,1504.242798 
	C1445.668823,1502.115845 1448.130981,1499.988892 1451.425659,1497.935181 
	C1456.262329,1498.023193 1458.211060,1495.455200 1458.206055,1490.242554 
	C1463.437500,1485.087524 1468.668945,1479.932495 1474.295410,1475.368408 
	C1479.276978,1475.678589 1480.283936,1472.723267 1480.147705,1468.015137 
	C1482.744263,1465.295166 1485.340698,1462.575195 1488.372803,1460.441528 
	C1493.226562,1461.481689 1491.618530,1457.871826 1491.926025,1454.952515 
	C1493.262939,1453.586792 1494.599976,1452.221191 1496.386230,1451.440430 
	C1500.396973,1452.208008 1498.529907,1449.193604 1498.920654,1446.964600 
	C1499.926025,1445.928223 1500.931519,1444.891846 1502.389771,1444.442627 
	C1506.438354,1445.160767 1504.510132,1442.128540 1504.942139,1439.867920 
	C1510.286499,1433.150391 1515.761597,1426.532104 1520.944824,1419.692505 
	C1528.904175,1409.189575 1536.662720,1398.534546 1545.288818,1387.946411 
	C1550.235352,1384.479126 1553.696167,1380.108643 1553.956543,1373.067139 
	C1558.547363,1365.712769 1563.138184,1358.358398 1568.513428,1350.903198 
	C1568.968262,1349.822998 1569.423096,1348.742798 1569.936035,1346.972290 
	C1574.601807,1338.601440 1579.267456,1330.230591 1584.303467,1322.392456 
	C1585.029785,1322.252319 1586.186157,1322.350708 1586.416504,1321.935425 
	C1588.979370,1317.316162 1591.487549,1312.659302 1593.742310,1307.885986 
	C1594.016846,1307.304932 1592.720703,1305.981812 1592.219604,1304.300781 
	C1595.811768,1296.570557 1599.666260,1288.949585 1602.939697,1281.086670 
	C1609.166138,1266.130859 1615.060547,1251.036621 1621.796997,1235.909302 
	C1624.253052,1234.003052 1626.869141,1232.128540 1623.161987,1228.347900 
	C1623.661133,1227.191772 1624.160278,1226.035645 1625.389526,1224.876099 
	C1627.210083,1223.500122 1629.812744,1222.248779 1626.183594,1219.260254 
	C1630.123535,1205.373901 1634.218628,1191.529053 1637.950684,1177.587158 
	C1640.572266,1167.793335 1642.699219,1157.867065 1645.624634,1147.925537 
	C1645.947266,1147.620239 1646.270020,1147.315063 1646.592651,1147.009766 
	C1646.117432,1146.673462 1645.642090,1146.337158 1645.039551,1145.206299 
	C1646.705811,1135.123291 1648.864990,1125.092407 1649.939941,1114.946655 
	C1652.500366,1090.779419 1655.324341,1066.597168 1656.555420,1042.345459 
	C1657.522949,1023.284607 1656.594238,1004.098877 1655.888794,984.991516 
	C1655.394409,971.602966 1654.324585,958.194641 1652.666260,944.900574 
	C1650.625854,928.542786 1647.706299,912.294678 1645.737305,895.904846 
	C1646.020264,895.570435 1646.303345,895.235962 1646.586304,894.901550 
	C1646.073242,894.601257 1645.560181,894.300964 1644.592285,893.350830 
	C1638.450562,869.566833 1632.308716,845.782837 1626.865356,821.835632 
	C1626.951172,820.222046 1627.436035,818.504456 1627.047974,817.014282 
	C1625.890015,812.568298 1624.078247,808.276550 1623.141846,803.794922 
	C1622.595337,801.178528 1622.697876,798.771973 1619.101562,799.029419 
	C1615.644897,799.276855 1616.014160,801.790405 1615.727295,804.757141 
	C1611.868652,806.523743 1608.010132,808.290344 1603.359131,810.025635 
	C1601.919800,811.055481 1600.480469,812.085327 1598.727173,813.757080 
	C1595.522583,815.185486 1592.318115,816.613953 1588.326050,818.019348 
	C1586.897827,819.051270 1585.469604,820.083191 1583.726196,821.757996 
	C1579.838013,823.554077 1575.949707,825.350220 1571.700928,826.617188 
	C1570.814331,827.449829 1569.927856,828.282410 1568.726807,829.757324 
	C1564.838379,831.553650 1560.949951,833.349976 1556.701050,834.617249 
	C1555.814453,835.449890 1554.927856,836.282471 1553.727051,837.757324 
	C1549.868530,839.523865 1546.010010,841.290405 1541.359131,843.025574 
	C1539.919800,844.055420 1538.480469,845.085266 1536.726318,846.757874 
	C1533.534668,848.190918 1530.343140,849.623901 1526.359131,851.025635 
	C1524.919800,852.055420 1523.480591,853.085266 1521.727417,854.757019 
	C1518.522827,856.185486 1515.318115,857.613953 1511.326050,859.019287 
	C1509.897827,860.051208 1508.469482,861.083130 1506.726685,862.757446 
	C1502.838257,864.553772 1498.949951,866.350037 1494.700928,867.617249 
	C1493.814453,868.449829 1492.927856,869.282471 1491.726807,870.757385 
	C1487.838379,872.553711 1483.949951,874.350037 1479.700928,875.617188 
	C1478.814331,876.449829 1477.927856,877.282410 1476.715210,878.767395 
	C1475.188232,880.170715 1472.602661,881.382629 1472.308594,883.008789 
	C1470.582642,892.553467 1469.490845,902.210327 1467.995117,911.799683 
	C1466.091064,924.007751 1463.950684,936.178711 1462.016357,948.382202 
	C1460.537109,957.714722 1459.277832,967.081970 1457.815674,976.417358 
	C1455.955444,988.293335 1453.951660,1000.146790 1452.081177,1012.021179 
	C1450.586060,1021.513733 1449.258301,1031.032715 1447.747437,1040.522705 
	C1445.549561,1054.329468 1443.257935,1068.121338 1440.998291,1081.918091 
	C1439.369995,1091.859009 1437.671875,1101.788696 1436.109375,1111.739868 
	C1434.669678,1120.909546 1433.097168,1130.071533 1432.100220,1139.292847 
	C1431.398682,1145.780396 1429.597778,1148.709351 1422.609375,1150.537231 
	C1419.179565,1149.280396 1417.628052,1150.947021 1416.731934,1154.753174 
	C1411.169800,1157.538696 1405.607788,1160.324219 1399.609375,1162.537231 
	C1396.179565,1161.280396 1394.628052,1162.947021 1393.731323,1166.753540 
	C1388.169434,1169.538940 1382.607544,1172.324341 1376.609375,1174.537231 
	C1373.179565,1173.280396 1371.628052,1174.947021 1370.731323,1178.753662 
	C1365.169434,1181.539062 1359.607544,1184.324463 1353.609375,1186.537231 
	C1350.179565,1185.280396 1348.628052,1186.947021 1347.731323,1190.753662 
	C1342.169434,1193.539062 1336.607544,1196.324463 1330.609375,1198.537231 
	C1327.179565,1197.280396 1325.628052,1198.947021 1324.728882,1202.755615 
	C1320.604004,1205.763062 1316.380859,1205.718872 1311.645386,1203.952148 
	C1273.788208,1189.828491 1235.875488,1175.853638 1197.719604,1161.447510 
	C1197.492310,1161.218994 1197.219238,1161.080444 1196.134521,1160.991211 
	C1193.997681,1160.302612 1191.860718,1159.614014 1189.378052,1158.813965 
	C1188.199463,1161.841553 1187.103760,1164.701538 1185.974365,1167.547852 
	C1183.849487,1172.902832 1180.366333,1174.241455 1174.710693,1171.425781 
	C1174.483032,1171.207397 1174.213135,1171.076172 1173.172485,1170.975464 
	C1170.773071,1169.916260 1168.373779,1168.857056 1165.699341,1167.423096 
	C1165.462402,1167.205200 1165.183838,1167.079346 1164.132080,1166.995361 
	C1161.746094,1165.929565 1159.360229,1164.863647 1156.699341,1163.423096 
	C1156.462402,1163.205200 1156.183838,1163.079346 1155.144409,1162.997437 
	C1153.421143,1162.264160 1151.697998,1161.530884 1149.710693,1160.425781 
	C1149.483032,1160.207397 1149.213135,1160.076172 1148.172485,1159.975464 
	C1145.773193,1158.916138 1143.373779,1157.856934 1140.699341,1156.423096 
	C1140.462402,1156.205200 1140.183838,1156.079346 1139.132080,1155.995239 
	C1136.746216,1154.929443 1134.360352,1153.863525 1131.699341,1152.423096 
	C1131.462402,1152.205200 1131.183838,1152.079346 1130.144409,1151.997437 
	C1128.421143,1151.264160 1126.697998,1150.530884 1124.710693,1149.425781 
	C1124.483032,1149.207397 1124.213135,1149.076172 1123.172485,1148.975464 
	C1120.773071,1147.916260 1118.373779,1146.856934 1115.699341,1145.423096 
	C1115.462402,1145.205200 1115.183838,1145.079346 1114.132080,1144.995361 
	C1111.746216,1143.929443 1109.360229,1142.863647 1106.699341,1141.423096 
	C1106.462402,1141.205200 1106.183838,1141.079346 1105.144409,1140.997437 
	C1103.421265,1140.264160 1101.697998,1139.530884 1099.710693,1138.425781 
	C1099.483032,1138.207397 1099.213135,1138.076172 1098.172485,1137.975464 
	C1095.773071,1136.916260 1093.373779,1135.857056 1090.699341,1134.423096 
	C1090.462402,1134.205200 1090.183838,1134.079346 1089.132080,1133.995361 
	C1086.746216,1132.929443 1084.360229,1131.863647 1081.699341,1130.423096 
	C1081.462402,1130.205200 1081.183838,1130.079346 1080.144409,1129.997437 
	C1078.421143,1129.264160 1076.697998,1128.531006 1074.710693,1127.425781 
	C1074.483032,1127.207397 1074.213135,1127.076172 1073.134155,1126.969604 
	C1069.736084,1125.325684 1067.646484,1125.693237 1068.088623,1130.167603 
	C1068.185425,1131.146606 1068.088257,1132.163086 1067.950562,1133.144043 
	C1066.707520,1142.004028 1065.430176,1150.859009 1064.173340,1159.717041 
	C1062.935791,1168.439209 1061.683594,1177.159424 1060.486450,1185.887207 
	C1059.023926,1196.549805 1057.644287,1207.223999 1056.167847,1217.884644 
	C1054.959229,1226.611572 1053.608276,1235.318726 1052.418213,1244.047974 
	C1051.272827,1252.449219 1050.294312,1260.873169 1049.166748,1269.276978 
	C1048.080933,1277.370728 1046.919312,1285.454590 1045.752197,1293.537109 
	C1044.541504,1301.920532 1043.234009,1310.290161 1042.059204,1318.678589 
	C1040.452637,1330.150269 1038.953125,1341.637085 1037.365601,1353.111450 
	C1036.292358,1360.868408 1035.063354,1368.604248 1034.053467,1376.369019 
	C1032.600220,1387.542358 1031.347534,1398.741699 1029.886963,1409.914062 
	C1028.746582,1418.636963 1027.392456,1427.331665 1026.184570,1436.046021 
	C1025.017944,1444.463135 1023.949890,1452.893921 1022.779114,1461.310547 
	C1021.275635,1472.118164 1019.710632,1482.917114 1018.176453,1493.720581 
	C1016.936707,1502.450195 1015.712219,1511.181885 1014.464478,1519.910400 
	C1013.334717,1527.814209 1012.098267,1535.703979 1011.062988,1543.619995 
	C1009.918762,1552.369629 1009.041992,1561.154297 1007.881409,1569.901611 
	C1006.403137,1581.043823 1004.831848,1592.174927 1003.154175,1603.288818 
	C1002.209167,1609.548828 1000.969849,1615.764404 999.102539,1622.015991 
	C998.107300,1623.454712 997.112061,1624.893555 995.408569,1626.789551 
	C987.965759,1627.192993 980.527283,1627.725708 973.079346,1627.975586 
	C951.195740,1628.709839 929.309998,1629.389404 907.422119,1629.983032 
	C880.543945,1630.712036 853.662720,1631.326782 826.783020,1632.002441 
	C812.346008,1632.365234 797.909790,1632.763062 783.472534,1633.117188 
	C780.654663,1633.186279 777.833557,1633.127197 775.013977,1633.127197 
	C774.999878,1633.500122 774.985840,1633.873169 774.971802,1634.246094 
	C780.648254,1636.528320 786.324707,1638.810547 792.128174,1641.787231 
	C795.766907,1642.821045 799.405701,1643.854858 803.862122,1644.875977 
	C810.350586,1646.790649 816.774902,1648.968262 823.339722,1650.569580 
	C841.583069,1655.019287 859.842590,1659.421753 878.180298,1663.458374 
	C888.256409,1665.676514 898.464783,1667.390869 908.683899,1668.834106 
	C918.519958,1670.223389 928.442200,1671.017700 938.334900,1671.987793 
	C949.095825,1673.043335 959.848999,1674.508789 970.636902,1674.875854 
	C985.289734,1675.374390 999.973694,1675.128418 1014.641602,1674.960327 
	C1026.881104,1674.820068 1039.135254,1674.638794 1051.347900,1673.898682 
	C1060.634277,1673.335815 1069.875366,1671.943481 1079.118774,1670.778564 
	C1087.968872,1669.663086 1096.799316,1668.388184 1105.632202,1667.140503 
	C1113.077637,1666.088867 1120.514404,1664.975464 1128.274170,1664.375366 
M722.019104,1604.499756 
	C722.026917,1604.703735 722.034668,1604.907593 722.072632,1605.864502 
	C719.477539,1610.907593 716.882507,1615.950684 713.982971,1621.585449 
	C716.064758,1621.772827 717.333557,1622.036987 718.585999,1621.974121 
	C724.019897,1621.701538 729.445068,1621.235840 734.880615,1621.020874 
	C745.126038,1620.615723 755.375671,1620.308228 765.625000,1620.009277 
	C778.065491,1619.646362 790.508057,1619.358765 802.948364,1618.992310 
	C812.883179,1618.699585 822.815247,1618.313354 832.749817,1618.012329 
	C844.680786,1617.650635 856.613525,1617.347168 868.544800,1616.996460 
	C879.308960,1616.680054 890.072083,1616.326538 900.836060,1616.002808 
	C921.708557,1615.375000 942.580261,1614.718262 963.454590,1614.156128 
	C970.282166,1613.972168 977.122498,1614.181030 983.943359,1613.890381 
	C985.409058,1613.827881 987.651489,1612.686768 988.078003,1611.512695 
	C988.999512,1608.976685 988.984070,1606.098389 989.336487,1603.358032 
	C990.375122,1595.281738 991.349670,1587.196899 992.455566,1579.129761 
	C993.672485,1570.252808 995.084229,1561.402344 996.267822,1552.521240 
	C997.323853,1544.597412 998.053528,1536.629395 999.162964,1528.713745 
	C1000.679565,1517.893555 1002.535217,1507.120728 1004.031250,1496.297852 
	C1005.529236,1485.460327 1006.651733,1474.570923 1008.145325,1463.732666 
	C1009.636047,1452.915649 1011.492310,1442.149170 1012.986816,1431.332642 
	C1014.485107,1420.488281 1015.664917,1409.600220 1017.111694,1398.748291 
	C1018.664307,1387.102905 1020.389771,1375.480713 1021.992859,1363.842041 
	C1023.107300,1355.751221 1024.086670,1347.641479 1025.227173,1339.554565 
	C1026.774780,1328.579956 1028.488892,1317.628662 1029.997803,1306.649048 
	C1031.133545,1298.384399 1031.966431,1290.078125 1033.101196,1281.813354 
	C1034.653076,1270.511963 1036.410278,1259.238892 1037.990479,1247.941162 
	C1039.121582,1239.854736 1040.016235,1231.734985 1041.177002,1223.653076 
	C1043.054199,1210.584106 1045.167358,1197.548462 1046.984985,1184.471558 
	C1048.492188,1173.628174 1049.651489,1162.736938 1051.084229,1151.882690 
	C1052.709106,1139.572632 1054.466797,1127.279907 1056.552368,1114.719238 
	C1056.780884,1114.492065 1056.919434,1114.219116 1057.018677,1113.120850 
	C1058.700928,1108.711060 1062.040771,1107.556274 1067.285645,1109.771606 
	C1075.234985,1113.129150 1083.164673,1116.535522 1091.055664,1120.027710 
	C1114.728882,1130.504395 1138.365967,1141.062988 1162.050903,1151.513428 
	C1166.309082,1153.392456 1170.727539,1154.908447 1175.083618,1156.596436 
	C1176.000488,1154.564331 1176.583496,1153.271973 1177.552490,1151.719360 
	C1177.781250,1151.492188 1177.919678,1151.219238 1178.017700,1150.143311 
	C1178.734009,1148.088745 1179.450317,1146.034302 1180.552490,1143.719360 
	C1180.781250,1143.492188 1180.919678,1143.219238 1181.017700,1142.143311 
	C1181.734009,1140.088745 1182.450317,1138.034302 1183.552490,1135.719360 
	C1183.781250,1135.492188 1183.919678,1135.219238 1184.017700,1134.143311 
	C1184.734009,1132.088745 1185.450317,1130.034302 1186.552490,1127.719360 
	C1186.781250,1127.492188 1186.919678,1127.219238 1187.017700,1126.143311 
	C1187.734009,1124.088745 1188.450317,1122.034302 1189.552490,1119.719360 
	C1189.781250,1119.492188 1189.919678,1119.219238 1190.017700,1118.143311 
	C1190.734009,1116.088745 1191.450317,1114.034302 1192.552490,1111.719360 
	C1192.781250,1111.492188 1192.919678,1111.219238 1193.017700,1110.143311 
	C1193.734009,1108.088745 1194.450317,1106.034302 1195.552490,1103.719360 
	C1195.781250,1103.492188 1195.919678,1103.219238 1196.017700,1102.143311 
	C1196.734009,1100.088745 1197.450317,1098.034302 1198.552490,1095.719360 
	C1198.781250,1095.492188 1198.919678,1095.219238 1199.017700,1094.143311 
	C1199.734009,1092.088745 1200.450317,1090.034302 1201.552490,1087.719360 
	C1201.781250,1087.492188 1201.919678,1087.219238 1202.017944,1086.121582 
	C1205.532959,1076.380371 1208.955444,1066.604614 1212.581177,1056.904785 
	C1221.657715,1032.623047 1230.826294,1008.375549 1239.971680,983.339172 
	C1239.462158,979.978638 1237.951050,978.873413 1234.234009,981.003296 
	C1229.822754,978.623352 1225.411377,976.243347 1220.986572,973.118408 
	C1219.963257,969.028503 1217.731567,967.763855 1213.242676,970.003418 
	C1209.495239,967.956726 1205.747681,965.910095 1201.986816,963.118469 
	C1200.962891,959.029785 1198.732056,957.763062 1194.234009,960.003296 
	C1189.822754,957.623291 1185.411377,955.243347 1180.986572,952.118408 
	C1179.963257,948.028503 1177.731567,946.763855 1173.242676,949.003418 
	C1169.495239,946.956726 1165.747681,944.910095 1161.986816,942.118469 
	C1160.962891,938.029785 1158.732056,936.763062 1154.234009,939.003296 
	C1149.822754,936.623352 1145.411377,934.243408 1140.986572,931.118408 
	C1139.963257,927.028503 1137.731567,925.763855 1133.242676,928.003418 
	C1129.495239,925.956787 1125.747681,923.910095 1121.986816,921.118469 
	C1120.962891,917.029785 1118.732056,915.763062 1114.234009,918.003296 
	C1109.822754,915.623352 1105.411377,913.243347 1100.986572,910.118408 
	C1099.963257,906.028503 1097.731567,904.763855 1093.242676,907.003418 
	C1089.495239,904.956726 1085.747681,902.910034 1081.986816,900.118469 
	C1080.962891,896.029785 1078.732056,894.763062 1074.233643,897.003296 
	C1072.672119,896.132568 1071.156738,895.162537 1069.539307,894.412292 
	C1066.417480,892.964294 1063.226929,890.435730 1060.084473,890.464844 
	C1042.542480,890.627502 1025.008423,891.500854 1007.467346,891.977356 
	C990.381226,892.441650 973.290100,892.718933 956.201660,893.099487 
	C955.921021,893.105774 955.646362,893.380920 955.370178,893.544373 
	C954.913452,903.434753 954.114258,913.325989 954.137390,923.215332 
	C954.149902,928.546143 951.771606,931.054077 947.179871,932.360352 
	C933.438049,936.269714 919.759583,940.435120 905.903076,943.884949 
	C902.268433,944.789795 897.986816,943.873535 894.165894,943.041870 
	C890.058594,942.147888 886.118835,940.437134 882.149231,938.965820 
	C863.495239,932.051636 844.845154,925.126587 826.218384,918.139709 
	C820.678162,916.061523 819.681763,913.961914 820.926392,908.156250 
	C822.139099,902.499451 823.289978,896.829529 824.623413,890.418396 
	C821.666016,890.253540 818.752502,890.242126 815.877441,889.903809 
	C805.316772,888.661072 794.775635,887.252319 784.214233,886.016357 
	C774.767700,884.910889 765.295898,884.021362 755.850403,882.907532 
	C745.454224,881.681702 735.080444,880.266846 724.687195,879.014832 
	C718.013184,878.210876 711.314636,877.612183 704.639771,876.814453 
	C694.405884,875.591248 684.187134,874.241455 673.953979,873.012024 
	C667.122742,872.191284 660.278687,871.475952 653.438354,870.731873 
	C645.308899,869.847473 637.177307,868.982605 628.650757,867.564636 
	C627.925354,867.578613 627.200012,867.592529 626.474609,867.606445 
	C626.686523,868.419495 626.898438,869.232605 626.840271,870.654846 
	C625.264893,871.783997 623.689453,872.913147 621.340759,874.020081 
	C619.521851,874.235779 616.514282,873.575256 618.835571,877.661255 
	C616.928467,879.121643 615.021301,880.582031 612.340759,882.020081 
	C610.521851,882.235779 607.514282,881.575256 609.840271,885.654785 
	C608.264893,886.783936 606.689514,887.913147 604.340759,889.020081 
	C602.521851,889.235779 599.514282,888.575256 601.835571,892.661255 
	C599.928406,894.121582 598.021240,895.581970 595.340759,897.020081 
	C593.521851,897.235779 590.514282,896.575256 592.840332,900.654846 
	C591.264954,901.783997 589.689514,902.913147 587.340759,904.020081 
	C585.521851,904.235779 582.514282,903.575256 584.835571,907.661255 
	C582.928467,909.121643 581.021301,910.582031 578.340759,912.020081 
	C576.521851,912.235779 573.514282,911.575256 575.840332,915.654846 
	C574.264954,916.784058 572.689575,917.913208 570.340759,919.020081 
	C568.521851,919.235779 565.514282,918.575256 567.835571,922.661255 
	C565.928406,924.121582 564.021240,925.581970 561.340759,927.020081 
	C559.521851,927.235779 556.514282,926.575256 558.820618,930.677856 
	C557.164612,932.006531 555.186401,933.081604 553.906982,934.706726 
	C547.631470,942.677673 541.502991,950.765686 535.394592,958.866699 
	C523.677795,974.405212 512.086670,990.038940 500.297821,1005.522400 
	C490.217041,1018.762573 479.932709,1031.847656 469.644867,1045.121948 
	C505.911224,1080.981812 541.853943,1116.521729 577.864014,1152.128174 
	C580.372009,1150.182129 582.611877,1148.466919 584.827759,1146.721191 
	C602.098022,1133.115356 619.357849,1119.496338 636.634888,1105.899048 
	C640.590759,1102.785645 646.800598,1103.719849 647.855225,1107.822754 
	C648.786560,1111.446289 649.087585,1115.271484 649.311279,1119.028687 
	C649.691406,1125.414551 649.565186,1131.834473 650.059998,1138.208496 
	C650.947144,1149.636108 652.324585,1161.026855 653.148376,1172.458130 
	C653.985657,1184.076416 654.376038,1195.726562 655.013855,1207.359863 
	C655.301453,1212.606079 655.617676,1217.854126 656.094055,1223.085693 
	C656.762695,1230.428711 657.762817,1237.744751 658.302307,1245.095703 
	C658.770264,1251.473022 658.570801,1257.900391 659.063721,1264.274780 
	C659.960083,1275.868652 661.330872,1287.426636 662.168518,1299.023804 
	C662.995667,1310.475830 663.382324,1321.959351 664.014404,1333.426147 
	C664.303589,1338.672241 664.622437,1343.920166 665.098267,1349.151733 
	C665.766235,1356.494873 666.761536,1363.811035 667.300720,1371.161987 
	C667.768555,1377.539429 667.574768,1383.966309 668.067871,1390.340820 
	C668.964783,1401.934570 670.637939,1413.487793 671.067505,1425.092041 
	C671.405884,1434.232422 672.835510,1442.862183 675.860413,1451.542969 
	C681.260925,1467.041138 685.823059,1482.834595 690.606934,1498.543823 
	C696.330444,1517.338257 701.845703,1536.196167 707.593018,1554.983276 
	C711.073120,1566.359009 714.926453,1577.620728 718.401062,1588.998047 
	C719.891113,1593.876953 720.844727,1598.919678 722.019104,1604.499756 
M1505.330566,602.857849 
	C1500.507568,597.040771 1495.684570,591.223694 1490.934692,584.575867 
	C1490.611694,580.135376 1490.255127,579.829407 1486.321167,580.865479 
	C1483.834595,578.045837 1481.348022,575.226196 1478.934692,571.585876 
	C1478.427734,566.255066 1474.645142,562.788696 1470.298828,563.911255 
	C1467.180176,560.658081 1464.061646,557.404968 1460.974487,553.360840 
	C1460.229370,548.141052 1457.915405,546.146790 1452.015869,545.852722 
	C1449.324951,543.285706 1446.634033,540.718750 1443.974365,537.319458 
	C1444.347778,533.137085 1441.800903,532.713135 1437.934082,533.066528 
	C1427.651001,524.443909 1417.720703,515.351624 1407.004883,507.305328 
	C1389.587891,494.227417 1371.656982,481.834076 1353.963867,468.396667 
	C1353.306152,465.417633 1351.906250,464.065552 1348.304688,465.873749 
	C1337.184570,459.300232 1326.064331,452.726715 1314.919434,445.532715 
	C1314.264893,445.392426 1313.610352,445.252136 1312.285156,444.892517 
	C1267.166382,420.890045 1220.096191,401.849640 1170.602295,388.890106 
	C1141.231567,381.199707 1111.575317,375.023621 1081.343018,372.041260 
	C1061.755493,370.108978 1042.116211,367.637299 1022.483826,367.484039 
	C995.956421,367.276947 969.361145,368.334686 942.894592,370.235809 
	C923.302856,371.643066 903.801208,374.841614 884.388367,378.028137 
	C869.209473,380.519684 854.228638,384.217834 838.861816,386.823669 
	C838.241211,387.222656 837.620605,387.621643 836.312317,388.361786 
	C813.774353,395.671631 791.134399,402.685455 768.738708,410.407898 
	C756.297058,414.698029 744.263184,420.170624 731.655396,424.561401 
	C730.437195,425.349030 729.218933,426.136658 727.320129,427.197357 
	C726.511047,427.682007 725.732605,428.229340 724.888245,428.641815 
	C714.284912,433.821289 703.672119,438.981262 692.700989,443.617157 
	C691.814514,444.449768 690.927979,445.282379 689.727661,446.756805 
	C673.139465,456.707825 656.118164,466.014496 640.084534,476.790619 
	C623.978882,487.615082 608.864380,499.913116 593.299316,511.543671 
	C588.928894,514.809326 584.501221,517.998474 579.730652,520.683105 
	C579.172913,521.505737 578.615173,522.328430 577.775024,523.759766 
	C576.216675,524.914062 574.658325,526.068359 572.730530,526.683044 
	C572.172852,527.505737 571.615173,528.328430 570.795654,529.762207 
	C568.563538,531.582642 566.331421,533.403015 563.722961,534.662048 
	C562.834473,535.825073 561.945984,536.988098 560.798157,538.759583 
	C556.898438,542.247681 552.998657,545.735718 548.754517,548.674927 
	C548.158325,548.664124 547.303589,548.389038 547.004333,548.681763 
	C541.575623,553.992249 536.188477,559.346497 530.898926,564.794800 
	C530.571533,565.132019 531.124756,566.324280 531.195618,567.830627 
	C527.528809,571.578369 523.862000,575.326172 519.441650,579.039307 
	C516.098755,579.673462 515.953064,579.893616 517.318359,582.876953 
	C515.290771,584.947754 513.263184,587.018555 510.511200,589.048096 
	C509.841278,589.287537 509.171356,589.526917 508.501434,589.766357 
	C508.790771,590.234009 509.080078,590.701660 509.323364,591.862488 
	C507.947327,593.266296 506.571320,594.670166 504.476196,596.041199 
	C503.814758,596.287415 503.153320,596.533630 502.491882,596.779785 
	C502.784393,597.242920 503.076904,597.706055 503.307281,598.883728 
	C497.607300,605.987488 491.820007,613.023376 486.229950,620.212524 
	C479.560547,628.789917 473.060059,637.498596 465.671448,646.148560 
	C465.155029,647.211487 464.638641,648.274414 464.182220,650.032776 
	C460.235168,655.728699 456.288116,661.424561 451.533142,667.153809 
	C451.071411,668.262390 450.609680,669.371033 450.277496,671.166870 
	C446.691803,677.017334 443.091888,682.859131 439.524170,688.720459 
	C435.400299,695.495483 431.304810,702.287781 426.566376,709.087036 
	C426.426910,709.744751 426.287476,710.402466 426.035370,711.787964 
	C422.408844,719.104736 418.820007,726.440491 415.141785,733.731201 
	C412.882965,738.208435 410.487366,742.616638 407.528625,747.082336 
	C407.401794,747.741577 407.274933,748.400879 407.077423,749.824158 
	C406.653412,751.226135 406.324066,752.665161 405.791077,754.024353 
	C398.485199,772.654175 390.562073,791.068176 383.997467,809.954651 
	C377.980347,827.266113 373.039307,844.983215 368.338776,862.711060 
	C364.386475,877.617188 361.333405,892.768616 358.143402,907.866638 
	C356.772125,914.356689 355.929352,920.969360 355.087128,927.557068 
	C354.241638,934.170349 353.743469,940.827209 353.006378,947.455322 
	C352.049377,956.060974 350.640747,964.633972 350.093262,973.263245 
	C349.403015,984.142334 349.091614,995.065552 349.140625,1005.967285 
	C349.236115,1027.208740 349.282104,1048.465698 350.168701,1069.681885 
	C350.657257,1081.373047 352.732269,1093.005005 354.237274,1104.644897 
	C355.774597,1116.534424 357.044189,1128.484253 359.243774,1140.255859 
	C361.781403,1153.836548 364.985748,1167.306274 368.317688,1180.720581 
	C371.084686,1191.860474 374.456238,1202.850098 377.764252,1214.634277 
	C379.157166,1212.555054 380.102234,1211.251587 380.937683,1209.881226 
	C395.542816,1185.927002 410.134460,1161.964355 425.506683,1137.906494 
	C425.969086,1136.843140 426.431488,1135.779663 426.954102,1134.030762 
	C433.879089,1122.688354 440.804077,1111.346069 448.506653,1099.906494 
	C448.969055,1098.843140 449.431458,1097.779663 449.954041,1096.030762 
	C455.738464,1086.403442 461.453339,1076.733154 467.352661,1067.176880 
	C468.977203,1064.545288 469.282532,1062.638672 466.648773,1060.435425 
	C463.848877,1058.093018 461.417419,1055.309937 458.828278,1052.716064 
	C452.965454,1046.842896 452.927917,1045.146118 457.993500,1038.489380 
	C470.423126,1022.155212 482.741425,1005.736267 495.197449,989.422363 
	C504.014648,977.874390 512.983765,966.442383 522.609009,954.880493 
	C523.058472,953.882446 523.507935,952.884460 524.227905,951.262390 
	C526.780273,948.161133 529.332642,945.059875 532.609009,941.880493 
	C533.058472,940.882446 533.507935,939.884460 534.091675,938.429565 
	C534.275940,938.137390 534.540405,937.980408 535.609009,937.880493 
	C536.058533,936.882507 536.507996,935.884460 537.091675,934.429565 
	C537.275940,934.137390 537.540405,933.980408 538.614380,933.878784 
	C539.077698,932.865967 539.541016,931.853088 540.123413,930.428772 
	C540.289062,930.165588 540.526978,930.024048 541.571228,929.906311 
	C542.033264,928.899658 542.495361,927.893066 543.211975,926.286011 
	C545.239136,924.423096 547.266296,922.560181 550.191772,920.877869 
	C553.535034,921.517273 554.296570,919.721008 554.191101,916.309265 
	C555.558533,915.105286 556.926025,913.901306 559.191772,912.877869 
	C562.535034,913.517273 563.296570,911.721008 563.171448,908.330566 
	C564.212097,907.452820 565.252747,906.575012 567.191772,905.877869 
	C570.535034,906.517273 571.296570,904.721008 571.191040,901.309204 
	C572.558533,900.105225 573.926025,898.901245 576.191772,897.877869 
	C579.535034,898.517273 580.296570,896.721008 580.171570,893.330688 
	C581.212219,892.452881 582.252869,891.575073 584.191772,890.877869 
	C587.535034,891.517273 588.296570,889.721008 588.191040,886.309204 
	C589.558533,885.105225 590.925964,883.901245 593.191772,882.877869 
	C596.535034,883.517273 597.296570,881.721008 597.171448,878.330566 
	C598.212097,877.452820 599.252747,876.575012 601.191772,875.877869 
	C604.535034,876.517273 605.296570,874.721008 605.191040,871.309204 
	C606.558472,870.105225 607.925964,868.901245 610.191772,867.877869 
	C613.535034,868.517273 614.296570,866.721008 614.171570,863.330688 
	C615.212219,862.452881 616.252869,861.575134 618.191772,860.877869 
	C621.535034,861.517273 622.296570,859.721008 622.094238,856.422485 
	C622.497437,856.180786 622.900635,855.939087 624.094543,855.872009 
	C625.062683,855.303650 626.030884,854.735229 627.870789,854.025330 
	C632.293518,854.374573 636.732727,854.583557 641.135681,855.101257 
	C651.523804,856.322754 661.889343,857.736023 672.274536,858.984375 
	C678.945190,859.786194 685.642578,860.365540 692.313599,861.164368 
	C702.537964,862.388794 712.743469,863.771484 722.969116,864.984314 
	C732.403564,866.103271 741.861450,867.024597 751.295471,868.146667 
	C761.519958,869.362793 771.728455,870.712585 781.944519,871.999634 
	C789.080505,872.898682 796.210388,873.851929 803.355896,874.668884 
	C811.321777,875.579590 819.302246,876.363220 827.536865,877.229614 
	C828.085266,875.214905 828.594421,873.539307 828.996216,871.838318 
	C833.325317,853.515503 837.699951,835.202942 841.925232,816.856140 
	C843.744385,808.957153 845.244812,800.984802 847.437744,792.650085 
	C846.680786,791.766418 845.923828,790.882751 845.025391,789.095703 
	C843.689758,771.170166 842.206726,753.254028 841.065491,735.316101 
	C840.160889,721.097290 839.575317,706.855713 839.028015,692.617310 
	C838.264282,672.748230 837.645569,652.873474 837.016602,632.999512 
	C836.863953,628.175171 836.873596,623.344360 836.878052,618.516663 
	C836.907593,586.457092 837.009705,554.397461 836.979553,522.337952 
	C836.959412,500.898834 838.605713,479.584045 842.122070,458.460571 
	C843.443054,450.525208 846.112305,442.814270 848.957031,434.979309 
	C853.401184,434.212585 851.756958,430.931183 851.915588,427.709290 
	C854.381592,425.711029 856.847595,423.712799 860.177917,421.883087 
	C862.525208,422.085754 864.771973,422.128052 865.343018,418.232941 
	C877.843506,413.981079 890.847412,412.118011 903.898376,412.161377 
	C925.255737,412.232300 946.614014,413.219543 967.962952,414.051178 
	C977.498840,414.422638 987.050354,415.025879 996.528259,416.107178 
	C1011.463806,417.811127 1026.347168,419.977448 1041.245239,422.003723 
	C1055.811279,423.984863 1070.413940,425.755371 1084.916626,428.130554 
	C1101.133179,430.786499 1117.226074,434.195862 1133.436646,436.893005 
	C1138.383057,437.716003 1139.494995,440.387299 1139.125244,444.562073 
	C1138.850952,447.659698 1138.413086,450.744293 1137.994995,453.827545 
	C1136.612427,464.026978 1135.252319,474.229858 1133.794922,484.418701 
	C1132.249268,495.225952 1130.600342,506.018433 1128.999756,516.817810 
	C1127.444702,527.310730 1125.871338,537.801086 1124.346680,548.298462 
	C1122.541504,560.725586 1120.763550,573.156738 1119.005005,585.590515 
	C1117.541016,595.941895 1116.170288,606.306641 1114.669312,616.652466 
	C1113.170410,626.984741 1111.514526,637.294250 1110.012817,647.626038 
	C1108.509155,657.971008 1107.155518,668.337708 1105.654541,678.683105 
	C1104.155396,689.015869 1102.513306,699.327881 1101.011475,709.660278 
	C1099.508057,720.004639 1098.131226,730.367432 1096.642090,740.713989 
	C1095.131104,751.213257 1093.523315,761.698669 1092.009399,772.197571 
	C1090.889893,779.960815 1090.036865,787.767578 1088.709717,795.493896 
	C1087.930054,800.032043 1085.199951,802.497253 1080.101807,802.260193 
	C1067.519165,801.675049 1054.922729,801.375305 1042.330444,801.008789 
	C1029.737549,800.642212 1017.144226,800.261353 1004.548523,800.026001 
	C996.554016,799.876648 988.549622,800.157959 980.559143,799.922607 
	C972.854370,799.695740 965.161804,799.053101 955.999756,798.505676 
	C955.999756,819.863892 956.001404,840.247803 955.998169,860.631714 
	C955.997681,863.963623 956.341370,867.345825 955.892334,870.617737 
	C954.719604,879.161011 954.579102,879.114746 962.752136,879.005371 
	C988.674683,878.658508 1014.597717,878.344727 1040.519897,877.973511 
	C1042.140015,877.950256 1043.759155,877.318359 1045.370972,877.351379 
	C1054.386719,877.536072 1063.854370,874.444031 1072.110107,881.684082 
	C1073.970093,882.358704 1075.830078,883.033325 1078.322144,883.938049 
	C1082.561890,886.253662 1086.801514,888.569275 1091.089844,891.637268 
	C1092.173706,895.403748 1095.194946,895.071960 1098.842041,895.012512 
	C1103.241821,897.303284 1107.641479,899.594055 1112.110107,902.684082 
	C1113.970093,903.358704 1115.830078,904.033325 1118.322144,904.938049 
	C1122.561890,907.253662 1126.801514,909.569275 1131.089844,912.637268 
	C1132.173706,916.403748 1135.194946,916.071960 1138.842041,916.012512 
	C1143.241821,918.303284 1147.641479,920.594116 1152.110107,923.684082 
	C1153.970093,924.358704 1155.830078,925.033325 1158.322144,925.938049 
	C1162.561890,928.253662 1166.801514,930.569275 1171.089844,933.637268 
	C1172.173706,937.403748 1175.194946,937.071960 1178.842041,937.012451 
	C1183.241821,939.303284 1187.641479,941.594055 1192.110107,944.684082 
	C1193.970093,945.358643 1195.830078,946.033264 1198.322144,946.938049 
	C1202.561890,949.253662 1206.801514,951.569275 1211.089844,954.637268 
	C1212.173706,958.403748 1215.194946,958.071960 1218.842041,958.012512 
	C1223.241821,960.303284 1227.641479,962.594055 1232.110107,965.684082 
	C1233.970093,966.358643 1235.830078,967.033264 1238.322266,967.938232 
	C1242.370972,970.002197 1246.421143,972.063416 1250.468140,974.130676 
	C1254.796143,976.341370 1256.038940,979.412109 1254.374634,984.203308 
	C1253.059937,987.988342 1251.686890,991.760010 1250.155151,995.461182 
	C1247.119629,1002.796204 1247.286377,1002.913513 1254.413940,1006.847046 
	C1265.038696,1012.710632 1275.506592,1018.858337 1286.097290,1025.643799 
	C1287.769409,1026.415039 1289.441528,1027.186401 1291.837646,1028.011963 
	C1298.920532,1031.861938 1306.003418,1035.711914 1313.456665,1039.763184 
	C1313.889404,1037.271973 1314.098022,1035.667847 1314.451660,1034.096313 
	C1317.946655,1018.568848 1321.526733,1003.060364 1324.963013,987.520020 
	C1329.592773,966.582825 1334.125854,945.624268 1338.684204,924.671387 
	C1342.137939,908.795715 1345.630127,892.927979 1348.984985,877.031311 
	C1351.404541,865.566406 1353.606934,854.053223 1360.900024,843.987000 
	C1365.502563,842.038757 1365.915894,840.947571 1363.038696,837.269226 
	C1365.081299,833.179810 1367.124023,829.090393 1369.883545,824.987427 
	C1370.867676,824.298767 1371.851929,823.610046 1372.836182,822.921387 
	C1372.279785,822.281738 1371.723389,821.642090 1371.038818,820.268860 
	C1373.414795,815.512878 1375.790771,810.756958 1378.883545,805.987549 
	C1379.867798,805.298828 1380.852051,804.610168 1381.836182,803.921387 
	C1381.279785,803.281738 1380.723389,802.642090 1380.038696,801.268799 
	C1382.414673,796.512878 1384.790771,791.756897 1387.883545,786.987549 
	C1388.867798,786.298828 1389.852051,785.610168 1390.836182,784.921448 
	C1390.279785,784.281799 1389.723389,783.642151 1389.038696,782.268799 
	C1391.677124,777.476013 1394.315552,772.683228 1397.363647,768.452698 
	C1402.880371,768.630554 1403.123657,764.909668 1403.219604,760.277466 
	C1407.130981,756.481812 1411.042480,752.686096 1415.375244,749.458923 
	C1420.812622,749.993958 1419.902954,746.103882 1420.219604,742.277466 
	C1424.131104,738.481812 1428.042480,734.686157 1432.363403,731.452759 
	C1437.880127,731.630554 1438.123779,727.909912 1438.219604,723.277405 
	C1442.130981,719.481750 1446.042358,715.686096 1450.375244,712.458923 
	C1455.812622,712.993958 1454.902954,709.103882 1455.219604,705.277466 
	C1459.130981,701.481812 1463.042480,697.686096 1467.363403,694.452759 
	C1472.880127,694.630554 1473.123779,690.909912 1473.225464,686.270630 
	C1476.090454,684.183350 1478.694214,681.001343 1481.876099,680.242249 
	C1488.037476,678.772156 1494.522705,678.651550 1500.876465,677.999146 
	C1507.180786,677.351929 1507.796631,676.705261 1507.797852,670.495178 
	C1507.800659,657.336731 1507.737183,644.177673 1507.848877,631.020203 
	C1507.872314,628.253357 1508.856689,625.488831 1508.829590,622.728760 
	C1508.778198,617.483765 1508.315796,612.242676 1508.734253,606.917236 
	C1511.551270,605.814941 1511.550659,604.080872 1509.605225,602.207092 
	C1508.056396,600.715332 1506.493286,600.261047 1505.330566,602.857849 
M1672.144287,649.502625 
	C1672.144287,644.407104 1672.144287,639.311646 1672.144287,634.280640 
	C1659.825806,634.280640 1648.142456,634.280640 1636.528320,634.280640 
	C1636.528320,646.271545 1636.528320,657.834839 1636.528320,669.558777 
	C1648.438354,669.558777 1660.009644,669.558777 1672.144409,669.558777 
	C1672.144409,663.048035 1672.144409,656.774536 1672.144287,649.502625 
M1605.441650,669.803772 
	C1608.214966,669.803772 1610.988281,669.803772 1613.739502,669.803772 
	C1613.739502,657.458618 1613.739502,645.755615 1613.739502,634.255676 
	C1601.619629,634.255676 1589.903198,634.255676 1578.297363,634.255676 
	C1578.297363,646.230835 1578.297363,657.808594 1578.297363,669.803711 
	C1587.214111,669.803711 1595.834351,669.803711 1605.441650,669.803772 
M1528.561279,669.803833 
	C1537.640015,669.803833 1546.718872,669.803833 1555.730835,669.803833 
	C1555.730835,657.439392 1555.730835,645.847778 1555.730835,634.145508 
	C1543.733887,634.145508 1532.011475,634.145508 1520.260864,634.145508 
	C1520.260864,646.122437 1520.260864,657.809875 1520.260864,669.803711 
	C1522.967163,669.803711 1525.276001,669.803711 1528.561279,669.803833 
M1648.511475,612.378845 
	C1656.254395,612.378845 1663.997192,612.378845 1671.814697,612.378845 
	C1671.814697,600.011597 1671.814697,588.313049 1671.814697,576.605469 
	C1659.802246,576.605469 1648.124146,576.605469 1636.452637,576.605469 
	C1636.452637,588.604980 1636.452637,600.187378 1636.452637,612.379089 
	C1640.307617,612.379089 1643.912720,612.379089 1648.511475,612.378845 
M1610.422852,612.371887 
	C1611.653809,611.696045 1613.943481,611.041321 1613.957397,610.341187 
	C1614.181519,599.102112 1614.115723,587.857178 1614.115723,576.511230 
	C1601.773560,576.511230 1590.063965,576.511230 1578.289795,576.511230 
	C1578.289795,588.558044 1578.289795,600.287598 1578.289795,612.373108 
	C1588.865723,612.373108 1599.151611,612.373108 1610.422852,612.371887 
M1519.860474,587.521179 
	C1519.860474,595.627380 1519.860474,603.733521 1519.860474,612.101807 
	C1532.081421,612.101807 1543.788086,612.101807 1555.581909,612.101807 
	C1555.581909,600.066589 1555.581909,588.236328 1555.581909,576.452087 
	C1543.573853,576.452087 1531.989502,576.452087 1519.860352,576.452087 
	C1519.860352,579.971069 1519.860352,583.250244 1519.860474,587.521179 
M1671.980103,554.301697 
	C1671.980103,542.696838 1671.980103,531.091980 1671.980103,519.321167 
	C1659.977783,519.321167 1648.277222,519.321167 1636.539429,519.321167 
	C1636.539429,531.372864 1636.539429,543.096191 1636.539429,554.983093 
	C1648.349976,554.983093 1659.818848,554.983093 1671.980103,554.301697 
M1600.493286,555.134705 
	C1604.927002,555.134705 1609.360840,555.134705 1613.817749,555.134705 
	C1613.817749,542.773621 1613.817749,531.053772 1613.817749,519.300415 
	C1601.771240,519.300415 1590.043823,519.300415 1578.300171,519.300415 
	C1578.300171,531.336365 1578.300171,543.069641 1578.300171,555.134766 
	C1585.563599,555.134766 1592.530029,555.134766 1600.493286,555.134705 
M1525.600098,519.000000 
	C1523.820312,519.000000 1522.040527,519.000000 1520.155762,519.000000 
	C1520.155762,531.269165 1520.155762,542.994629 1520.155762,554.846313 
	C1532.169800,554.846313 1543.891724,554.846313 1555.724609,554.846313 
	C1555.724609,542.827026 1555.724609,531.097778 1555.724609,519.000000 
	C1545.827393,519.000000 1536.202026,519.000000 1525.600098,519.000000 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1232.041260,964.884888 
	C1227.641479,962.594055 1223.241821,960.303284 1218.329590,957.665649 
	C1215.558472,956.174194 1213.299805,955.029541 1211.041260,953.884888 
	C1206.801514,951.569275 1202.561890,949.253662 1197.785278,946.530151 
	C1195.512695,945.376526 1193.776978,944.630737 1192.041260,943.884888 
	C1187.641479,941.594055 1183.241821,939.303284 1178.329590,936.665649 
	C1175.558472,935.174194 1173.299805,934.029541 1171.041260,932.884888 
	C1166.801514,930.569275 1162.561890,928.253662 1157.785278,925.530151 
	C1155.512695,924.376465 1153.776978,923.630676 1152.041260,922.884888 
	C1147.641479,920.594116 1143.241821,918.303284 1138.329590,915.665710 
	C1135.558472,914.174255 1133.299805,913.029602 1131.041260,911.884888 
	C1126.801514,909.569275 1122.561890,907.253662 1117.785278,904.530151 
	C1115.512695,903.376526 1113.776978,902.630676 1112.041260,901.884888 
	C1107.641479,899.594055 1103.241821,897.303284 1098.329590,894.665649 
	C1095.558472,893.174194 1093.299805,892.029541 1091.041260,890.884888 
	C1086.801514,888.569275 1082.561890,886.253662 1077.785278,883.530151 
	C1075.512695,882.376526 1073.776978,881.630737 1072.041260,880.884888 
	C1063.854370,874.444031 1054.386719,877.536072 1045.370972,877.351379 
	C1043.759155,877.318359 1042.140015,877.950256 1040.519897,877.973511 
	C1014.597717,878.344727 988.674683,878.658508 962.752136,879.005371 
	C954.579102,879.114746 954.719604,879.161011 955.892334,870.617737 
	C956.341370,867.345825 955.997681,863.963623 955.998169,860.631714 
	C956.001404,840.247803 955.999756,819.863892 955.999756,798.505676 
	C965.161804,799.053101 972.854370,799.695740 980.559143,799.922607 
	C988.549622,800.157959 996.554016,799.876648 1004.548523,800.026001 
	C1017.144226,800.261353 1029.737549,800.642212 1042.330444,801.008789 
	C1054.922729,801.375305 1067.519165,801.675049 1080.101807,802.260193 
	C1085.199951,802.497253 1087.930054,800.032043 1088.709717,795.493896 
	C1090.036865,787.767578 1090.889893,779.960815 1092.009399,772.197571 
	C1093.523315,761.698669 1095.131104,751.213257 1096.642090,740.713989 
	C1098.131226,730.367432 1099.508057,720.004639 1101.011475,709.660278 
	C1102.513306,699.327881 1104.155396,689.015869 1105.654541,678.683105 
	C1107.155518,668.337708 1108.509155,657.971008 1110.012817,647.626038 
	C1111.514526,637.294250 1113.170410,626.984741 1114.669312,616.652466 
	C1116.170288,606.306641 1117.541016,595.941895 1119.005005,585.590515 
	C1120.763550,573.156738 1122.541504,560.725586 1124.346680,548.298462 
	C1125.871338,537.801086 1127.444702,527.310730 1128.999756,516.817810 
	C1130.600342,506.018433 1132.249268,495.225952 1133.794922,484.418701 
	C1135.252319,474.229858 1136.612427,464.026978 1137.994995,453.827545 
	C1138.413086,450.744293 1138.850952,447.659698 1139.125244,444.562073 
	C1139.494995,440.387299 1138.383057,437.716003 1133.436646,436.893005 
	C1117.226074,434.195862 1101.133179,430.786499 1084.916626,428.130554 
	C1070.413940,425.755371 1055.811279,423.984863 1041.245239,422.003723 
	C1026.347168,419.977448 1011.463806,417.811127 996.528259,416.107178 
	C987.050354,415.025879 977.498840,414.422638 967.962952,414.051178 
	C946.614014,413.219543 925.255737,412.232300 903.898376,412.161377 
	C890.847412,412.118011 877.843506,413.981079 864.792969,418.614594 
	C862.599792,419.902344 860.956665,420.808441 859.313599,421.714539 
	C856.847595,423.712799 854.381592,425.711029 851.520508,428.226624 
	C850.139282,430.829620 849.153076,432.915314 848.166870,435.001007 
	C846.112305,442.814270 843.443054,450.525208 842.122070,458.460571 
	C838.605713,479.584045 836.959412,500.898834 836.979553,522.337952 
	C837.009705,554.397461 836.907593,586.457092 836.878052,618.516663 
	C836.873596,623.344360 836.863953,628.175171 837.016602,632.999512 
	C837.645569,652.873474 838.264282,672.748230 839.028015,692.617310 
	C839.575317,706.855713 840.160889,721.097290 841.065491,735.316101 
	C842.206726,753.254028 843.689758,771.170166 845.095703,789.859497 
	C845.740662,791.430847 846.315369,792.238281 846.890076,793.045776 
	C845.244812,800.984802 843.744385,808.957153 841.925232,816.856140 
	C837.699951,835.202942 833.325317,853.515503 828.996216,871.838318 
	C828.594421,873.539307 828.085266,875.214905 827.536865,877.229614 
	C819.302246,876.363220 811.321777,875.579590 803.355896,874.668884 
	C796.210388,873.851929 789.080505,872.898682 781.944519,871.999634 
	C771.728455,870.712585 761.519958,869.362793 751.295471,868.146667 
	C741.861450,867.024597 732.403564,866.103271 722.969116,864.984314 
	C712.743469,863.771484 702.537964,862.388794 692.313599,861.164368 
	C685.642578,860.365540 678.945190,859.786194 672.274536,858.984375 
	C661.889343,857.736023 651.523804,856.322754 641.135681,855.101257 
	C636.732727,854.583557 632.293518,854.374573 627.082031,854.031311 
	C625.296814,854.590637 624.300293,855.144043 623.303833,855.697388 
	C622.900635,855.939087 622.497437,856.180786 621.718018,856.792114 
	C619.992310,858.340210 618.642883,859.518738 617.293457,860.697327 
	C616.252869,861.575134 615.212219,862.452881 613.756653,863.746155 
	C611.992310,865.340149 610.642883,866.518677 609.293457,867.697266 
	C607.925964,868.901245 606.558472,870.105225 604.766357,871.735413 
	C602.992310,873.340149 601.642883,874.518738 600.293457,875.697266 
	C599.252747,876.575012 598.212097,877.452820 596.756592,878.746094 
	C594.992371,880.340210 593.642944,881.518799 592.293457,882.697266 
	C590.925964,883.901245 589.558533,885.105225 587.766357,886.735413 
	C585.992310,888.340149 584.642883,889.518677 583.293457,890.697266 
	C582.252869,891.575073 581.212219,892.452881 579.756653,893.746216 
	C577.992310,895.340210 576.642883,896.518738 575.293457,897.697266 
	C573.926025,898.901245 572.558533,900.105225 570.766418,901.735474 
	C568.992371,903.340210 567.642944,904.518799 566.293457,905.697266 
	C565.252747,906.575012 564.212097,907.452820 562.756592,908.746094 
	C560.992310,910.340149 559.642883,911.518738 558.293457,912.697266 
	C556.926025,913.901306 555.558533,915.105286 553.766418,916.735474 
	C551.992310,918.340210 550.642883,919.518738 549.293457,920.697266 
	C547.266296,922.560181 545.239136,924.423096 542.778931,926.722595 
	C541.843018,928.107544 541.340088,929.055847 540.837219,930.004211 
	C540.526978,930.024048 540.289062,930.165588 539.757812,930.775574 
	C538.889832,932.067749 538.387451,933.013184 537.885071,933.958618 
	C537.540405,933.980408 537.275940,934.137390 536.721924,934.791748 
	C535.863159,936.088806 535.374146,937.023743 534.885132,937.958618 
	C534.540405,937.980408 534.275940,938.137390 533.721924,938.791748 
	C532.863098,940.088745 532.374084,941.023682 531.885010,941.958618 
	C529.332642,945.059875 526.780273,948.161133 523.789978,951.708069 
	C522.863037,953.088684 522.374084,954.023682 521.885071,954.958618 
	C512.983765,966.442383 504.014648,977.874390 495.197449,989.422363 
	C482.741425,1005.736267 470.423126,1022.155212 457.993500,1038.489380 
	C452.927917,1045.146118 452.965454,1046.842896 458.828278,1052.716064 
	C461.417419,1055.309937 463.848877,1058.093018 466.648773,1060.435425 
	C469.282532,1062.638672 468.977203,1064.545288 467.352661,1067.176880 
	C461.453339,1076.733154 455.738464,1086.403442 449.629700,1096.547852 
	C448.779877,1098.044434 448.254425,1099.024048 447.729004,1100.003662 
	C440.804077,1111.346069 433.879089,1122.688354 426.629761,1134.547852 
	C425.779968,1136.044556 425.254517,1137.024048 424.729065,1138.003662 
	C410.134460,1161.964355 395.542816,1185.927002 380.937683,1209.881226 
	C380.102234,1211.251587 379.157166,1212.555054 377.764252,1214.634277 
	C374.456238,1202.850098 371.084686,1191.860474 368.317688,1180.720581 
	C364.985748,1167.306274 361.781403,1153.836548 359.243774,1140.255859 
	C357.044189,1128.484253 355.774597,1116.534424 354.237274,1104.644897 
	C352.732269,1093.005005 350.657257,1081.373047 350.168701,1069.681885 
	C349.282104,1048.465698 349.236115,1027.208740 349.140625,1005.967285 
	C349.091614,995.065552 349.403015,984.142334 350.093262,973.263245 
	C350.640747,964.633972 352.049377,956.060974 353.006378,947.455322 
	C353.743469,940.827209 354.241638,934.170349 355.087128,927.557068 
	C355.929352,920.969360 356.772125,914.356689 358.143402,907.866638 
	C361.333405,892.768616 364.386475,877.617188 368.338776,862.711060 
	C373.039307,844.983215 377.980347,827.266113 383.997467,809.954651 
	C390.562073,791.068176 398.485199,772.654175 405.791077,754.024353 
	C406.324066,752.665161 406.653412,751.226135 407.392120,749.317261 
	C407.855591,748.225525 408.004364,747.640686 408.153137,747.055847 
	C410.487366,742.616638 412.882965,738.208435 415.141785,733.731201 
	C418.820007,726.440491 422.408844,719.104736 426.371185,711.300659 
	C426.870331,710.233093 427.033661,709.652832 427.197021,709.072571 
	C431.304810,702.287781 435.400299,695.495483 439.524170,688.720459 
	C443.091888,682.859131 446.691803,677.017334 450.508911,670.629028 
	C451.273865,669.100952 451.807434,668.110718 452.341034,667.120483 
	C456.288116,661.424561 460.235168,655.728699 464.452087,649.504272 
	C465.310120,648.033997 465.898285,647.092224 466.486450,646.150452 
	C473.060059,637.498596 479.560547,628.789917 486.229950,620.212524 
	C491.820007,613.023376 497.607300,605.987488 503.594055,598.397888 
	C504.318970,597.299377 504.757111,596.686707 505.195282,596.073975 
	C506.571320,594.670166 507.947327,593.266296 509.603027,591.386353 
	C510.333679,590.303223 510.784607,589.696289 511.235535,589.089355 
	C513.263184,587.018555 515.290771,584.947754 517.612305,582.378418 
	C518.669312,580.944580 519.432251,580.009277 520.195251,579.073975 
	C523.862000,575.326172 527.528809,571.578369 531.531128,567.342041 
	C537.610657,560.976868 543.354797,555.100342 549.098938,549.223816 
	C552.998657,545.735718 556.898438,542.247681 561.216675,538.342651 
	C562.456604,537.024902 563.277954,536.124146 564.099304,535.223389 
	C566.331421,533.403015 568.563538,531.582642 571.203003,529.359863 
	C572.106934,528.379150 572.603394,527.800903 573.099854,527.222656 
	C574.658325,526.068359 576.216675,524.914062 578.189697,523.354004 
	C579.102844,522.373108 579.601318,521.797913 580.099854,521.222717 
	C584.501221,517.998474 588.928894,514.809326 593.299316,511.543671 
	C608.864380,499.913116 623.978882,487.615082 640.084534,476.790619 
	C656.118164,466.014496 673.139465,456.707825 690.206299,446.392517 
	C691.477234,445.400909 692.269470,444.773590 693.061707,444.146271 
	C703.672119,438.981262 714.284912,433.821289 724.888245,428.641815 
	C725.732605,428.229340 726.511047,427.682007 727.990234,427.178223 
	C729.788696,426.476135 730.917114,425.793213 732.045532,425.110291 
	C744.263184,420.170624 756.297058,414.698029 768.738708,410.407898 
	C791.134399,402.685455 813.774353,395.671631 836.954346,388.226379 
	C838.117554,387.853912 838.638672,387.616852 839.159790,387.379822 
	C854.228638,384.217834 869.209473,380.519684 884.388367,378.028137 
	C903.801208,374.841614 923.302856,371.643066 942.894592,370.235809 
	C969.361145,368.334686 995.956421,367.276947 1022.483826,367.484039 
	C1042.116211,367.637299 1061.755493,370.108978 1081.343018,372.041260 
	C1111.575317,375.023621 1141.231567,381.199707 1170.602295,388.890106 
	C1220.096191,401.849640 1267.166382,420.890045 1312.743774,445.281372 
	C1313.782959,445.831207 1314.363647,445.992218 1314.944214,446.153198 
	C1326.064331,452.726715 1337.184570,459.300232 1348.776123,466.291595 
	C1350.812744,467.523560 1352.377808,468.337646 1353.942993,469.151764 
	C1371.656982,481.834076 1389.587891,494.227417 1407.004883,507.305328 
	C1417.720703,515.351624 1427.651001,524.443909 1438.423340,533.404053 
	C1440.589355,535.211670 1442.266235,536.681763 1443.943115,538.151794 
	C1446.634033,540.718750 1449.324951,543.285706 1452.485352,546.290527 
	C1455.617554,549.202881 1458.280273,551.677368 1460.943115,554.151855 
	C1464.061646,557.404968 1467.180176,560.658081 1470.732300,564.366821 
	C1473.730957,567.350403 1476.296143,569.878479 1478.861450,572.406494 
	C1481.348022,575.226196 1483.834595,578.045837 1486.740601,581.308594 
	C1488.393921,582.969971 1489.627808,584.188232 1490.861572,585.406555 
	C1495.684570,591.223694 1500.507568,597.040771 1505.752441,603.303101 
	C1506.790894,604.832275 1507.407471,605.916138 1508.024170,607.000000 
	C1508.315796,612.242676 1508.778198,617.483765 1508.829590,622.728760 
	C1508.856689,625.488831 1507.872314,628.253357 1507.848877,631.020203 
	C1507.737183,644.177673 1507.800659,657.336731 1507.797852,670.495178 
	C1507.796631,676.705261 1507.180786,677.351929 1500.876465,677.999146 
	C1494.522705,678.651550 1488.037476,678.772156 1481.876099,680.242249 
	C1478.694214,681.001343 1476.090454,684.183350 1472.779785,686.720032 
	C1470.540771,689.409790 1468.747314,691.650085 1466.953857,693.890442 
	C1463.042480,697.686096 1459.130981,701.481812 1454.779541,705.721191 
	C1452.877686,708.073486 1451.415771,709.981995 1449.953857,711.890442 
	C1446.042358,715.686096 1442.130981,719.481750 1437.776855,723.723389 
	C1435.540771,726.409729 1433.747314,728.650085 1431.953857,730.890442 
	C1428.042480,734.686157 1424.131104,738.481812 1419.779541,742.721191 
	C1417.877563,745.073425 1416.415649,746.981934 1414.953857,748.890442 
	C1411.042480,752.686096 1407.130981,756.481812 1402.776855,760.723389 
	C1400.540771,763.409729 1398.747314,765.650085 1396.953857,767.890442 
	C1394.315552,772.683228 1391.677124,777.476013 1388.964111,782.935669 
	C1388.315186,784.735413 1387.740967,785.868164 1387.166748,787.000977 
	C1384.790771,791.756897 1382.414673,796.512878 1379.964111,801.935669 
	C1379.315186,803.735413 1378.740967,804.868164 1378.166748,806.000977 
	C1375.790771,810.756958 1373.414795,815.512878 1370.964111,820.935730 
	C1370.315186,822.735413 1369.740967,823.868164 1369.166748,825.000977 
	C1367.124023,829.090393 1365.081299,833.179810 1362.953369,837.949707 
	C1361.967651,840.420532 1361.067261,842.210754 1360.166748,844.000977 
	C1353.606934,854.053223 1351.404541,865.566406 1348.984985,877.031311 
	C1345.630127,892.927979 1342.137939,908.795715 1338.684204,924.671387 
	C1334.125854,945.624268 1329.592773,966.582825 1324.963013,987.520020 
	C1321.526733,1003.060364 1317.946655,1018.568848 1314.451660,1034.096313 
	C1314.098022,1035.667847 1313.889404,1037.271973 1313.456665,1039.763184 
	C1306.003418,1035.711914 1298.920532,1031.861938 1291.331299,1027.669922 
	C1289.230347,1026.513672 1287.635864,1025.699341 1286.041260,1024.885132 
	C1275.506592,1018.858337 1265.038696,1012.710632 1254.413940,1006.847046 
	C1247.286377,1002.913513 1247.119629,1002.796204 1250.155151,995.461182 
	C1251.686890,991.760010 1253.059937,987.988342 1254.374634,984.203308 
	C1256.038940,979.412109 1254.796143,976.341370 1250.468140,974.130676 
	C1246.421143,972.063416 1242.370972,970.002197 1237.785400,967.530273 
	C1235.512695,966.376526 1233.776978,965.630676 1232.041260,964.884888 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1189.166626,1119.979736 
	C1188.450317,1122.034302 1187.734009,1124.088745 1186.744385,1126.606934 
	C1186.369629,1127.373657 1186.268066,1127.676758 1186.166626,1127.979736 
	C1185.450317,1130.034302 1184.734009,1132.088745 1183.744385,1134.606934 
	C1183.369751,1135.373657 1183.268188,1135.676758 1183.166626,1135.979736 
	C1182.450317,1138.034302 1181.734009,1140.088745 1180.744385,1142.606934 
	C1180.369629,1143.373657 1180.268188,1143.676758 1180.166626,1143.979736 
	C1179.450317,1146.034302 1178.734009,1148.088745 1177.744385,1150.606934 
	C1177.369751,1151.373657 1177.268188,1151.676758 1177.166626,1151.979736 
	C1176.583496,1153.271973 1176.000488,1154.564331 1175.083618,1156.596436 
	C1170.727539,1154.908447 1166.309082,1153.392456 1162.050903,1151.513428 
	C1138.365967,1141.062988 1114.728882,1130.504395 1091.055664,1120.027710 
	C1083.164673,1116.535522 1075.234985,1113.129150 1067.285645,1109.771606 
	C1062.040771,1107.556274 1058.700928,1108.711060 1056.745117,1113.595703 
	C1056.369873,1114.373657 1056.268188,1114.676758 1056.166626,1114.979736 
	C1054.466797,1127.279907 1052.709106,1139.572632 1051.084229,1151.882690 
	C1049.651489,1162.736938 1048.492188,1173.628174 1046.984985,1184.471558 
	C1045.167358,1197.548462 1043.054199,1210.584106 1041.177002,1223.653076 
	C1040.016235,1231.734985 1039.121582,1239.854736 1037.990479,1247.941162 
	C1036.410278,1259.238892 1034.653076,1270.511963 1033.101196,1281.813354 
	C1031.966431,1290.078125 1031.133545,1298.384399 1029.997803,1306.649048 
	C1028.488892,1317.628662 1026.774780,1328.579956 1025.227173,1339.554565 
	C1024.086670,1347.641479 1023.107300,1355.751221 1021.992859,1363.842041 
	C1020.389771,1375.480713 1018.664307,1387.102905 1017.111694,1398.748291 
	C1015.664917,1409.600220 1014.485107,1420.488281 1012.986816,1431.332642 
	C1011.492310,1442.149170 1009.636047,1452.915649 1008.145325,1463.732666 
	C1006.651733,1474.570923 1005.529236,1485.460327 1004.031250,1496.297852 
	C1002.535217,1507.120728 1000.679565,1517.893555 999.162964,1528.713745 
	C998.053528,1536.629395 997.323853,1544.597412 996.267822,1552.521240 
	C995.084229,1561.402344 993.672485,1570.252808 992.455566,1579.129761 
	C991.349670,1587.196899 990.375122,1595.281738 989.336487,1603.358032 
	C988.984070,1606.098389 988.999512,1608.976685 988.078003,1611.512695 
	C987.651489,1612.686768 985.409058,1613.827881 983.943359,1613.890381 
	C977.122498,1614.181030 970.282166,1613.972168 963.454590,1614.156128 
	C942.580261,1614.718262 921.708557,1615.375000 900.836060,1616.002808 
	C890.072083,1616.326538 879.308960,1616.680054 868.544800,1616.996460 
	C856.613525,1617.347168 844.680786,1617.650635 832.749817,1618.012329 
	C822.815247,1618.313354 812.883179,1618.699585 802.948364,1618.992310 
	C790.508057,1619.358765 778.065491,1619.646362 765.625000,1620.009277 
	C755.375671,1620.308228 745.126038,1620.615723 734.880615,1621.020874 
	C729.445068,1621.235840 724.019897,1621.701538 718.585999,1621.974121 
	C717.333557,1622.036987 716.064758,1621.772827 713.982971,1621.585449 
	C716.882507,1615.950684 719.477539,1610.907593 722.308105,1605.392090 
	C722.376404,1604.575928 722.209167,1604.231934 722.041992,1603.888062 
	C720.844727,1598.919678 719.891113,1593.876953 718.401062,1588.998047 
	C714.926453,1577.620728 711.073120,1566.359009 707.593018,1554.983276 
	C701.845703,1536.196167 696.330444,1517.338257 690.606934,1498.543823 
	C685.823059,1482.834595 681.260925,1467.041138 675.860413,1451.542969 
	C672.835510,1442.862183 671.405884,1434.232422 671.067505,1425.092041 
	C670.637939,1413.487793 668.964783,1401.934570 668.067871,1390.340820 
	C667.574768,1383.966309 667.768555,1377.539429 667.300720,1371.161987 
	C666.761536,1363.811035 665.766235,1356.494873 665.098267,1349.151733 
	C664.622437,1343.920166 664.303589,1338.672241 664.014404,1333.426147 
	C663.382324,1321.959351 662.995667,1310.475830 662.168518,1299.023804 
	C661.330872,1287.426636 659.960083,1275.868652 659.063721,1264.274780 
	C658.570801,1257.900391 658.770264,1251.473022 658.302307,1245.095703 
	C657.762817,1237.744751 656.762695,1230.428711 656.094055,1223.085693 
	C655.617676,1217.854126 655.301453,1212.606079 655.013855,1207.359863 
	C654.376038,1195.726562 653.985657,1184.076416 653.148376,1172.458130 
	C652.324585,1161.026855 650.947144,1149.636108 650.059998,1138.208496 
	C649.565186,1131.834473 649.691406,1125.414551 649.311279,1119.028687 
	C649.087585,1115.271484 648.786560,1111.446289 647.855225,1107.822754 
	C646.800598,1103.719849 640.590759,1102.785645 636.634888,1105.899048 
	C619.357849,1119.496338 602.098022,1133.115356 584.827759,1146.721191 
	C582.611877,1148.466919 580.372009,1150.182129 577.864014,1152.128174 
	C541.853943,1116.521729 505.911224,1080.981812 469.644867,1045.121948 
	C479.932709,1031.847656 490.217041,1018.762573 500.297821,1005.522400 
	C512.086670,990.038940 523.677795,974.405212 535.394592,958.866699 
	C541.502991,950.765686 547.631470,942.677673 553.906982,934.706726 
	C555.186401,933.081604 557.164612,932.006531 559.253174,930.246216 
	C560.495178,928.890503 561.304688,927.966431 562.114136,927.042358 
	C564.021240,925.581970 565.928406,924.121582 568.260620,922.237915 
	C569.495239,920.890503 570.304688,919.966431 571.114136,919.042358 
	C572.689575,917.913208 574.264954,916.784058 576.263000,915.234680 
	C577.495117,913.890442 578.304626,912.966431 579.114136,912.042358 
	C581.021301,910.582031 582.928467,909.121643 585.260620,907.237915 
	C586.495178,905.890503 587.304688,904.966431 588.114136,904.042358 
	C589.689514,902.913147 591.264954,901.783997 593.262939,900.234619 
	C594.495117,898.890442 595.304626,897.966370 596.114136,897.042358 
	C598.021240,895.581970 599.928406,894.121582 602.260620,892.237915 
	C603.495178,890.890442 604.304626,889.966431 605.114136,889.042358 
	C606.689514,887.913147 608.264893,886.783936 610.262939,885.234619 
	C611.495178,883.890503 612.304688,882.966431 613.114136,882.042358 
	C615.021301,880.582031 616.928467,879.121643 619.260620,877.237915 
	C620.495239,875.890503 621.304688,874.966431 622.114136,874.042358 
	C623.689453,872.913147 625.264893,871.783997 627.242676,870.252808 
	C628.112244,869.270325 628.579468,868.689819 629.046631,868.109253 
	C637.177307,868.982605 645.308899,869.847473 653.438354,870.731873 
	C660.278687,871.475952 667.122742,872.191284 673.953979,873.012024 
	C684.187134,874.241455 694.405884,875.591248 704.639771,876.814453 
	C711.314636,877.612183 718.013184,878.210876 724.687195,879.014832 
	C735.080444,880.266846 745.454224,881.681702 755.850403,882.907532 
	C765.295898,884.021362 774.767700,884.910889 784.214233,886.016357 
	C794.775635,887.252319 805.316772,888.661072 815.877441,889.903809 
	C818.752502,890.242126 821.666016,890.253540 824.623413,890.418396 
	C823.289978,896.829529 822.139099,902.499451 820.926392,908.156250 
	C819.681763,913.961914 820.678162,916.061523 826.218384,918.139709 
	C844.845154,925.126587 863.495239,932.051636 882.149231,938.965820 
	C886.118835,940.437134 890.058594,942.147888 894.165894,943.041870 
	C897.986816,943.873535 902.268433,944.789795 905.903076,943.884949 
	C919.759583,940.435120 933.438049,936.269714 947.179871,932.360352 
	C951.771606,931.054077 954.149902,928.546143 954.137390,923.215332 
	C954.114258,913.325989 954.913452,903.434753 955.369507,893.537476 
	C955.646362,893.380920 955.921021,893.105774 956.201660,893.099487 
	C973.290100,892.718933 990.381226,892.441650 1007.467346,891.977356 
	C1025.008423,891.500854 1042.542480,890.627502 1060.084473,890.464844 
	C1063.226929,890.435730 1066.417480,892.964294 1069.539307,894.412292 
	C1071.156738,895.162537 1072.672119,896.132568 1074.751587,897.363525 
	C1077.513062,898.770264 1079.756714,899.816833 1082.000244,900.863403 
	C1085.747681,902.910034 1089.495239,904.956726 1093.756348,907.363647 
	C1096.513306,908.770447 1098.756714,909.816895 1101.000122,910.863403 
	C1105.411377,913.243347 1109.822754,915.623352 1114.751709,918.363525 
	C1117.513062,919.770264 1119.756714,920.816833 1122.000244,921.863403 
	C1125.747681,923.910095 1129.495239,925.956787 1133.756348,928.363647 
	C1136.513306,929.770447 1138.756714,930.816895 1141.000122,931.863403 
	C1145.411377,934.243408 1149.822754,936.623352 1154.751709,939.363525 
	C1157.513062,940.770264 1159.756714,941.816833 1162.000244,942.863403 
	C1165.747681,944.910095 1169.495239,946.956726 1173.756348,949.363647 
	C1176.513306,950.770447 1178.756714,951.816895 1181.000122,952.863403 
	C1185.411377,955.243347 1189.822754,957.623291 1194.751709,960.363525 
	C1197.513062,961.770264 1199.756714,962.816833 1202.000244,963.863403 
	C1205.747681,965.910095 1209.495239,967.956726 1213.756348,970.363647 
	C1216.513306,971.770386 1218.756714,972.816895 1221.000122,973.863403 
	C1225.411377,976.243347 1229.822754,978.623352 1234.743652,981.357117 
	C1236.821411,982.512024 1238.389526,983.313110 1239.957764,984.114258 
	C1230.826294,1008.375549 1221.657715,1032.623047 1212.581177,1056.904785 
	C1208.955444,1066.604614 1205.532959,1076.380371 1201.744629,1086.596191 
	C1201.369751,1087.373657 1201.268188,1087.676758 1201.166626,1087.979736 
	C1200.450317,1090.034302 1199.734009,1092.088745 1198.744385,1094.606934 
	C1198.369629,1095.373657 1198.268066,1095.676758 1198.166626,1095.979736 
	C1197.450317,1098.034302 1196.734009,1100.088745 1195.744385,1102.606934 
	C1195.369629,1103.373657 1195.268066,1103.676636 1195.166504,1103.979736 
	C1194.450317,1106.034302 1193.734009,1108.088745 1192.744385,1110.606934 
	C1192.369629,1111.373657 1192.268066,1111.676758 1192.166626,1111.979736 
	C1191.450317,1114.034302 1190.734009,1116.088745 1189.744385,1118.606934 
	C1189.369751,1119.373657 1189.268188,1119.676758 1189.166626,1119.979736 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1589.113525,818.042419 
	C1592.318115,816.613953 1595.522583,815.185486 1599.234863,813.393311 
	C1601.212280,812.038635 1602.681885,811.047791 1604.151489,810.057007 
	C1608.010132,808.290344 1611.868652,806.523743 1616.249268,804.386230 
	C1618.581909,802.997437 1619.787598,802.949951 1620.549194,805.419922 
	C1622.267944,810.993652 1624.276245,816.478088 1626.166870,821.998840 
	C1632.308716,845.782837 1638.450562,869.566833 1644.774414,894.010254 
	C1645.026611,895.112793 1645.096680,895.555969 1645.166748,895.999146 
	C1647.706299,912.294678 1650.625854,928.542786 1652.666260,944.900574 
	C1654.324585,958.194641 1655.394409,971.602966 1655.888794,984.991516 
	C1656.594238,1004.098877 1657.522949,1023.284607 1656.555420,1042.345459 
	C1655.324341,1066.597168 1652.500366,1090.779419 1649.939941,1114.946655 
	C1648.864990,1125.092407 1646.705811,1135.123291 1645.024658,1145.931885 
	C1645.022095,1147.104980 1645.034668,1147.552490 1645.047119,1148.000000 
	C1642.699219,1157.867065 1640.572266,1167.793335 1637.950684,1177.587158 
	C1634.218628,1191.529053 1630.123535,1205.373901 1626.068848,1219.983154 
	C1625.522705,1222.097168 1625.091064,1223.488281 1624.659424,1224.879395 
	C1624.160278,1226.035645 1623.661133,1227.191772 1623.056885,1229.031006 
	C1622.332275,1231.809448 1621.712646,1233.904785 1621.092773,1236.000000 
	C1615.060547,1251.036621 1609.166138,1266.130859 1602.939697,1281.086670 
	C1599.666260,1288.949585 1595.811768,1296.570557 1592.016602,1304.969971 
	C1589.186890,1311.046143 1586.560059,1316.452881 1583.933105,1321.859741 
	C1579.267456,1330.230591 1574.601807,1338.601440 1569.616943,1347.503052 
	C1568.774780,1349.023804 1568.251831,1350.013916 1567.729004,1351.004028 
	C1563.138184,1358.358398 1558.547363,1365.712769 1553.626953,1373.589233 
	C1550.367065,1378.722290 1547.436768,1383.333130 1544.506470,1387.944092 
	C1536.662720,1398.534546 1528.904175,1409.189575 1520.944824,1419.692505 
	C1515.761597,1426.532104 1510.286499,1433.150391 1504.615479,1440.358032 
	C1503.504883,1441.850586 1502.720947,1442.853027 1501.937012,1443.855469 
	C1500.931519,1444.891846 1499.926025,1445.928223 1498.607178,1447.429932 
	C1497.508179,1448.881958 1496.722656,1449.868774 1495.937012,1450.855591 
	C1494.599976,1452.221191 1493.262939,1453.586792 1491.599365,1455.425903 
	C1490.160889,1457.217896 1489.049072,1458.536499 1487.937256,1459.855225 
	C1485.340698,1462.575195 1482.744263,1465.295166 1479.709717,1468.475586 
	C1477.481201,1470.883179 1475.690796,1472.830200 1473.900391,1474.777344 
	C1468.668945,1479.932495 1463.437500,1485.087524 1457.765015,1490.679077 
	C1455.080444,1493.364380 1452.836914,1495.613281 1450.593262,1497.862061 
	C1448.130981,1499.988892 1445.668823,1502.115845 1442.770752,1504.682617 
	C1440.754395,1506.702148 1439.173950,1508.281860 1437.593506,1509.861572 
	C1436.458740,1510.668457 1435.323975,1511.475220 1433.764526,1512.699951 
	C1432.090942,1514.365967 1430.842041,1515.613892 1429.593140,1516.861816 
	C1428.784302,1517.342407 1427.975464,1517.823120 1426.752441,1518.711548 
	C1425.065186,1520.363525 1423.792236,1521.607910 1422.519531,1522.852295 
	C1411.188965,1531.560669 1399.911743,1540.339722 1388.505493,1548.947632 
	C1382.874634,1553.196899 1377.005371,1557.130127 1370.757568,1561.621338 
	C1365.622192,1565.257935 1360.973511,1568.479736 1356.324829,1571.701660 
	C1349.560059,1575.734253 1342.855103,1579.871704 1336.016479,1583.774902 
	C1325.934448,1589.529297 1315.757080,1595.116699 1304.964600,1600.995361 
	C1298.518677,1604.428589 1292.728271,1607.641602 1286.937866,1610.854492 
	C1281.216187,1613.243652 1275.516479,1615.686890 1269.768799,1618.011719 
	C1252.307007,1625.075073 1234.826660,1632.092285 1216.750610,1639.428467 
	C1214.399292,1640.411377 1212.650879,1641.093262 1210.902344,1641.774902 
	C1209.800293,1642.055420 1208.698364,1642.335815 1206.947754,1642.745361 
	C1204.820435,1643.476807 1203.341797,1644.078979 1201.863037,1644.681274 
	C1192.038086,1647.425781 1182.260986,1650.359253 1172.376465,1652.869019 
	C1158.560669,1656.377197 1144.664551,1659.569092 1130.092773,1662.925781 
	C1128.906738,1663.266724 1128.430908,1663.578125 1127.954956,1663.889404 
	C1120.514404,1664.975464 1113.077637,1666.088867 1105.632202,1667.140503 
	C1096.799316,1668.388184 1087.968872,1669.663086 1079.118774,1670.778564 
	C1069.875366,1671.943481 1060.634277,1673.335815 1051.347900,1673.898682 
	C1039.135254,1674.638794 1026.881104,1674.820068 1014.641602,1674.960327 
	C999.973694,1675.128418 985.289734,1675.374390 970.636902,1674.875854 
	C959.848999,1674.508789 949.095825,1673.043335 938.334900,1671.987793 
	C928.442200,1671.017700 918.519958,1670.223389 908.683899,1668.834106 
	C898.464783,1667.390869 888.256409,1665.676514 878.180298,1663.458374 
	C859.842590,1659.421753 841.583069,1655.019287 823.339722,1650.569580 
	C816.774902,1648.968262 810.350586,1646.790649 803.296021,1644.526855 
	C799.153625,1643.149292 795.577454,1642.121094 792.001221,1641.092773 
	C786.324707,1638.810547 780.648254,1636.528320 774.971802,1634.246094 
	C774.985840,1633.873169 774.999878,1633.500122 775.013977,1633.127197 
	C777.833557,1633.127197 780.654663,1633.186279 783.472534,1633.117188 
	C797.909790,1632.763062 812.346008,1632.365234 826.783020,1632.002441 
	C853.662720,1631.326782 880.543945,1630.712036 907.422119,1629.983032 
	C929.309998,1629.389404 951.195740,1628.709839 973.079346,1627.975586 
	C980.527283,1627.725708 987.965759,1627.192993 996.119263,1626.503296 
	C997.841064,1624.811401 998.852112,1623.405640 999.863159,1622.000000 
	C1000.969849,1615.764404 1002.209167,1609.548828 1003.154175,1603.288818 
	C1004.831848,1592.174927 1006.403137,1581.043823 1007.881409,1569.901611 
	C1009.041992,1561.154297 1009.918762,1552.369629 1011.062988,1543.619995 
	C1012.098267,1535.703979 1013.334717,1527.814209 1014.464478,1519.910400 
	C1015.712219,1511.181885 1016.936707,1502.450195 1018.176453,1493.720581 
	C1019.710632,1482.917114 1021.275635,1472.118164 1022.779114,1461.310547 
	C1023.949890,1452.893921 1025.017944,1444.463135 1026.184570,1436.046021 
	C1027.392456,1427.331665 1028.746582,1418.636963 1029.886963,1409.914062 
	C1031.347534,1398.741699 1032.600220,1387.542358 1034.053467,1376.369019 
	C1035.063354,1368.604248 1036.292358,1360.868408 1037.365601,1353.111450 
	C1038.953125,1341.637085 1040.452637,1330.150269 1042.059204,1318.678589 
	C1043.234009,1310.290161 1044.541504,1301.920532 1045.752197,1293.537109 
	C1046.919312,1285.454590 1048.080933,1277.370728 1049.166748,1269.276978 
	C1050.294312,1260.873169 1051.272827,1252.449219 1052.418213,1244.047974 
	C1053.608276,1235.318726 1054.959229,1226.611572 1056.167847,1217.884644 
	C1057.644287,1207.223999 1059.023926,1196.549805 1060.486450,1185.887207 
	C1061.683594,1177.159424 1062.935791,1168.439209 1064.173340,1159.717041 
	C1065.430176,1150.859009 1066.707520,1142.004028 1067.950562,1133.144043 
	C1068.088257,1132.163086 1068.185425,1131.146606 1068.088623,1130.167603 
	C1067.646484,1125.693237 1069.736084,1125.325684 1073.602295,1127.248291 
	C1074.371948,1127.617188 1074.673340,1127.707397 1074.974731,1127.797607 
	C1076.697998,1128.531006 1078.421143,1129.264160 1080.594971,1130.269897 
	C1081.355103,1130.627441 1081.664795,1130.712646 1081.974365,1130.797729 
	C1084.360229,1131.863647 1086.746216,1132.929443 1089.588867,1134.268799 
	C1090.355103,1134.627441 1090.664795,1134.712646 1090.974365,1134.797729 
	C1093.373779,1135.857056 1095.773071,1136.916260 1098.621582,1138.251221 
	C1099.371948,1138.617310 1099.673340,1138.707520 1099.974731,1138.797729 
	C1101.697998,1139.530884 1103.421265,1140.264160 1105.594971,1141.269897 
	C1106.355103,1141.627441 1106.664795,1141.712646 1106.974365,1141.797729 
	C1109.360229,1142.863647 1111.746216,1143.929443 1114.588867,1145.268921 
	C1115.355103,1145.627563 1115.664673,1145.712646 1115.974365,1145.797852 
	C1118.373779,1146.856934 1120.773071,1147.916260 1123.621582,1149.251221 
	C1124.371948,1149.617310 1124.673340,1149.707520 1124.974731,1149.797729 
	C1126.697998,1150.530884 1128.421143,1151.264160 1130.594971,1152.269897 
	C1131.355103,1152.627441 1131.664795,1152.712646 1131.974365,1152.797607 
	C1134.360352,1153.863525 1136.746216,1154.929443 1139.588867,1156.268799 
	C1140.355103,1156.627563 1140.664795,1156.712646 1140.974365,1156.797729 
	C1143.373779,1157.856934 1145.773193,1158.916138 1148.621582,1160.251221 
	C1149.371948,1160.617310 1149.673340,1160.707520 1149.974731,1160.797729 
	C1151.697998,1161.530884 1153.421143,1162.264160 1155.594971,1163.269897 
	C1156.355103,1163.627563 1156.664795,1163.712646 1156.974365,1163.797729 
	C1159.360229,1164.863647 1161.746094,1165.929565 1164.588867,1167.268799 
	C1165.355103,1167.627441 1165.664795,1167.712524 1165.974365,1167.797729 
	C1168.373779,1168.857056 1170.773071,1169.916260 1173.621582,1171.251221 
	C1174.371948,1171.617310 1174.673340,1171.707520 1174.974731,1171.797729 
	C1180.366333,1174.241455 1183.849487,1172.902832 1185.974365,1167.547852 
	C1187.103760,1164.701538 1188.199463,1161.841553 1189.378052,1158.813965 
	C1191.860718,1159.614014 1193.997681,1160.302612 1196.602783,1161.259766 
	C1197.373901,1161.630005 1197.676880,1161.731567 1197.979858,1161.833252 
	C1235.875488,1175.853638 1273.788208,1189.828491 1311.645386,1203.952148 
	C1316.380859,1205.718872 1320.604004,1205.763062 1325.240723,1202.392822 
	C1327.516968,1201.056519 1329.281250,1200.083130 1331.045654,1199.109863 
	C1336.607544,1196.324463 1342.169434,1193.539062 1348.239868,1190.385254 
	C1350.514160,1189.047974 1352.279907,1188.078857 1354.045654,1187.109863 
	C1359.607544,1184.324463 1365.169434,1181.539062 1371.239868,1178.385376 
	C1373.514160,1177.047974 1375.279907,1176.078979 1377.045654,1175.109863 
	C1382.607544,1172.324341 1388.169434,1169.538940 1394.239868,1166.385254 
	C1396.514160,1165.048096 1398.279907,1164.078979 1400.045654,1163.109863 
	C1405.607788,1160.324219 1411.169800,1157.538696 1417.240234,1154.385132 
	C1419.514160,1153.048096 1421.279907,1152.078979 1423.045654,1151.109863 
	C1429.597778,1148.709351 1431.398682,1145.780396 1432.100220,1139.292847 
	C1433.097168,1130.071533 1434.669678,1120.909546 1436.109375,1111.739868 
	C1437.671875,1101.788696 1439.369995,1091.859009 1440.998291,1081.918091 
	C1443.257935,1068.121338 1445.549561,1054.329468 1447.747437,1040.522705 
	C1449.258301,1031.032715 1450.586060,1021.513733 1452.081177,1012.021179 
	C1453.951660,1000.146790 1455.955444,988.293335 1457.815674,976.417358 
	C1459.277832,967.081970 1460.537109,957.714722 1462.016357,948.382202 
	C1463.950684,936.178711 1466.091064,924.007751 1467.995117,911.799683 
	C1469.490845,902.210327 1470.582642,892.553467 1472.308594,883.008789 
	C1472.602661,881.382629 1475.188232,880.170715 1477.197754,878.392700 
	C1478.473999,877.394104 1479.267822,876.770203 1480.061523,876.146362 
	C1483.949951,874.350037 1487.838379,872.553711 1492.203613,870.387695 
	C1493.473999,869.394104 1494.267822,868.770203 1495.061523,868.146362 
	C1498.949951,866.350037 1502.838257,864.553772 1507.231934,862.387268 
	C1509.196045,861.025574 1510.654785,860.033997 1512.113525,859.042419 
	C1515.318115,857.613953 1518.522827,856.185486 1522.232910,854.387024 
	C1524.209351,853.030334 1525.680420,852.043640 1527.151489,851.056885 
	C1530.343140,849.623901 1533.534668,848.190918 1537.234375,846.393677 
	C1539.212158,845.038574 1540.681885,844.047729 1542.151489,843.057007 
	C1546.010010,841.290405 1549.868530,839.523865 1554.203613,837.387695 
	C1555.473999,836.394104 1556.267822,835.770264 1557.061523,835.146362 
	C1560.949951,833.349976 1564.838379,831.553650 1569.203613,829.387695 
	C1570.473999,828.394104 1571.267822,827.770264 1572.061523,827.146362 
	C1575.949707,825.350220 1579.838013,823.554077 1584.231689,821.387573 
	C1586.196045,820.025574 1587.654785,819.033997 1589.113525,818.042419 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M869.997681,430.833313 
	C878.932312,429.221954 887.820129,427.233185 896.816223,426.117218 
	C904.173218,425.204620 911.687561,424.752167 919.082947,425.110596 
	C940.007690,426.124786 960.910095,427.615356 981.815002,429.013153 
	C989.707458,429.540924 997.610596,430.098297 1005.459045,431.051727 
	C1017.316650,432.492249 1029.123779,434.342590 1040.964966,435.924683 
	C1054.104980,437.680389 1067.304688,439.041595 1080.395020,441.102905 
	C1095.247314,443.441681 1110.007446,446.366119 1125.002686,449.071136 
	C1108.566162,562.610229 1092.204102,675.634949 1075.751343,789.286316 
	C1069.755737,788.843689 1064.046509,788.179321 1058.324585,788.044250 
	C1039.234497,787.593628 1020.138916,787.383057 1001.047546,786.979065 
	C990.616577,786.758362 980.190308,786.322876 969.761353,786.002686 
	C958.500061,785.656982 947.237793,785.340271 935.976440,784.997009 
	C925.380920,784.674072 914.786194,784.327026 904.190735,784.001587 
	C893.095886,783.660706 881.996521,783.428284 870.907715,782.949219 
	C866.838867,782.773376 862.794617,782.027344 858.039246,781.457581 
	C857.429810,771.959045 856.873474,762.313904 856.174377,752.679138 
	C855.543762,743.988098 854.676758,735.313965 854.064636,726.621826 
	C853.589478,719.874390 853.243225,713.113892 853.022400,706.353271 
	C852.611328,693.767273 852.358582,681.176086 851.991943,668.588501 
	C851.697876,658.492004 851.235107,648.399597 851.020447,638.301758 
	C850.614624,619.210449 850.192749,600.117615 850.037964,581.023315 
	C849.870361,560.334412 849.636963,539.634338 850.133545,518.956055 
	C850.440857,506.157745 851.765564,493.358948 853.169250,480.619415 
	C854.398865,469.459076 855.965759,458.298004 858.194214,447.301514 
	C859.319031,441.750854 860.842834,435.725891 867.268616,432.335175 
	C868.503296,431.609222 869.250488,431.221283 869.997681,430.833313 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1584.288452,806.635071 
	C1581.396729,808.016968 1578.505127,809.398865 1574.967651,810.993286 
	C1572.644043,812.348816 1570.966309,813.491943 1569.288452,814.635010 
	C1566.396484,816.017090 1563.504395,817.399109 1559.967773,818.992981 
	C1557.661133,820.371399 1555.999146,821.537903 1554.337280,822.704346 
	C1551.428589,824.063477 1548.519897,825.422546 1544.965820,826.986572 
	C1542.653320,828.353882 1540.986450,829.516235 1539.319580,830.678589 
	C1535.752319,832.378296 1532.184937,834.077881 1527.969971,835.991455 
	C1525.646484,837.351196 1523.970581,838.496948 1522.294556,839.642700 
	C1519.400879,841.022034 1516.507080,842.401428 1512.967651,843.993286 
	C1510.644043,845.348877 1508.966309,846.492004 1507.288452,847.635071 
	C1504.396729,849.016968 1501.505127,850.398865 1497.968262,851.992859 
	C1495.651001,853.372925 1493.979004,854.540833 1492.307007,855.708801 
	C1489.420166,857.091125 1486.533325,858.473511 1482.983154,860.039429 
	C1480.647461,861.383423 1478.975342,862.543823 1477.303101,863.704102 
	C1474.417480,865.087952 1471.531982,866.471802 1467.983154,868.039368 
	C1465.647583,869.383484 1463.975342,870.543823 1462.303101,871.704224 
	C1460.869385,876.009888 1458.910400,880.220581 1458.110229,884.640991 
	C1456.394653,894.118469 1455.359253,903.716858 1453.892578,913.242126 
	C1452.354980,923.229187 1450.617798,933.185425 1449.005005,943.161072 
	C1446.401245,959.265198 1443.794434,975.369019 1441.252930,991.482971 
	C1439.447632,1002.929260 1437.793091,1014.399353 1435.988892,1025.845825 
	C1434.110474,1037.763062 1432.062744,1049.653931 1430.218384,1061.576294 
	C1428.395142,1073.362183 1426.765259,1085.177734 1424.991455,1096.971558 
	C1423.316772,1108.106689 1420.672974,1119.186035 1420.119385,1130.372314 
	C1419.647095,1139.912598 1412.590576,1141.422485 1405.984131,1145.041260 
	C1402.982788,1146.727539 1400.649536,1148.223633 1398.316284,1149.719727 
	C1393.428467,1152.096680 1388.540649,1154.473755 1382.984375,1157.041016 
	C1379.982666,1158.727417 1377.649414,1160.223511 1375.316284,1161.719727 
	C1370.428467,1164.096802 1365.540649,1166.473877 1359.984375,1169.041138 
	C1356.982666,1170.727539 1354.649536,1172.223633 1352.316284,1173.719727 
	C1347.428467,1176.096802 1342.540649,1178.473877 1336.984375,1181.041138 
	C1333.982666,1182.727417 1331.649536,1184.223633 1329.316284,1185.719727 
	C1329.155396,1185.762573 1328.956299,1185.758911 1328.838867,1185.854980 
	C1319.534546,1193.466187 1310.373169,1189.067505 1301.139282,1185.616089 
	C1279.113159,1177.383179 1257.058105,1169.227905 1235.011230,1161.051147 
	C1221.480835,1156.033203 1207.943359,1151.034180 1194.052490,1145.894775 
	C1200.020264,1129.939209 1205.867920,1114.321167 1211.703491,1098.698608 
	C1218.802246,1079.694580 1225.871826,1060.679810 1232.992676,1041.684204 
	C1235.952026,1033.789917 1239.255737,1026.013794 1241.891968,1018.015442 
	C1242.808716,1015.234131 1243.675781,1015.908508 1245.729736,1017.257507 
	C1246.783081,1017.830750 1247.363770,1017.991760 1247.944336,1018.152771 
	C1250.044800,1019.446350 1252.145264,1020.739929 1254.722168,1022.364746 
	C1255.775024,1022.862976 1256.351440,1023.029907 1256.927734,1023.196777 
	C1258.394531,1024.097656 1259.861328,1024.998535 1261.765259,1026.284424 
	C1262.783081,1026.830566 1263.363647,1026.991577 1263.944336,1027.152588 
	C1265.405518,1028.063843 1266.866699,1028.975220 1268.765137,1030.278076 
	C1269.783081,1030.830566 1270.363647,1030.991577 1270.944336,1031.152588 
	C1272.405396,1032.063843 1273.866455,1032.975098 1275.789185,1034.297241 
	C1277.833862,1035.436035 1279.416992,1036.163818 1281.000000,1036.891724 
	C1282.093628,1037.606934 1283.187256,1038.322021 1284.740967,1039.366455 
	C1285.782227,1039.848022 1286.363281,1040.000366 1286.944336,1040.152588 
	C1288.404663,1041.067749 1289.864990,1041.982910 1291.763916,1043.283813 
	C1292.783081,1043.830566 1293.363647,1043.991577 1293.944336,1044.152588 
	C1295.405518,1045.063965 1296.866699,1045.975220 1298.765137,1047.278076 
	C1299.783081,1047.830566 1300.363647,1047.991577 1300.944336,1048.152588 
	C1303.044800,1049.446167 1305.145264,1050.739746 1307.722046,1052.364624 
	C1308.774780,1052.862671 1309.351196,1053.029419 1309.927490,1053.196289 
	C1310.143555,1053.431885 1310.317017,1053.743530 1310.581909,1053.892090 
	C1320.202393,1059.283691 1323.799072,1057.502075 1325.999023,1046.688477 
	C1329.235840,1030.777344 1332.638916,1014.899414 1336.067993,999.028198 
	C1341.007202,976.167542 1345.990112,953.316101 1351.036987,930.479004 
	C1354.470825,914.940430 1357.903076,899.398743 1361.612061,883.924622 
	C1363.796021,874.812805 1366.519043,865.830200 1369.357910,856.262390 
	C1370.088379,854.490173 1370.460571,853.245056 1370.832764,852.000000 
	C1373.222412,847.258972 1375.611938,842.517883 1378.358887,837.256042 
	C1379.088501,835.490234 1379.460693,834.245117 1379.832886,833.000000 
	C1382.222412,828.258911 1384.611938,823.517883 1387.358887,818.256042 
	C1388.088501,816.490173 1388.460693,815.245117 1388.832886,814.000000 
	C1391.222412,809.258972 1393.611938,804.517883 1396.358887,799.256042 
	C1397.088379,797.490173 1397.460693,796.245117 1397.832764,795.000000 
	C1399.889038,790.925537 1401.945312,786.851135 1404.367676,782.244019 
	C1405.187988,780.159424 1405.641968,778.607483 1406.096069,777.055603 
	C1406.096069,777.055603 1406.018433,777.009644 1406.344849,776.917297 
	C1408.818604,774.564026 1410.965942,772.303162 1413.113281,770.042297 
	C1416.668823,766.269043 1420.224365,762.495850 1424.217529,758.281433 
	C1426.807861,755.574280 1428.960571,753.308289 1431.113281,751.042236 
	C1434.668823,747.269043 1438.224365,743.495789 1442.215820,739.282654 
	C1444.472290,736.909241 1446.292847,734.975769 1448.113281,733.042236 
	C1451.668823,729.268982 1455.224365,725.495728 1459.217529,721.281372 
	C1461.807861,718.574219 1463.960571,716.308228 1466.113281,714.042236 
	C1469.668823,710.268921 1473.224365,706.495728 1477.219482,702.279785 
	C1479.156738,699.910034 1480.654419,697.983093 1482.152100,696.056091 
	C1485.320190,691.498169 1490.573486,693.375732 1494.792969,692.162476 
	C1498.778198,691.016724 1503.129272,691.143555 1508.008545,690.639465 
	C1505.636597,695.400818 1503.420044,699.850403 1501.012695,704.964478 
	C1499.603516,708.086304 1498.385254,710.543640 1497.166992,713.000977 
	C1492.512451,722.433960 1487.857910,731.866943 1483.012695,741.964478 
	C1481.603638,745.086365 1480.385254,747.543640 1479.166992,750.000977 
	C1476.843872,754.767029 1474.130981,759.395142 1472.373779,764.361450 
	C1471.581787,766.600098 1471.789917,770.319641 1473.194946,771.895996 
	C1474.638306,773.515503 1478.432495,774.446167 1480.618286,773.779114 
	C1501.250000,767.482483 1521.757690,760.779480 1542.993286,754.120483 
	C1545.177002,753.491028 1546.668579,752.934692 1548.160156,752.378296 
	C1552.540649,750.983398 1556.921021,749.588379 1561.993408,748.120483 
	C1564.177002,747.491150 1565.668579,746.934753 1567.160156,746.378418 
	C1568.836182,745.205811 1570.512207,744.033142 1572.498047,742.386230 
	C1573.255737,741.293579 1573.703369,740.675232 1574.151123,740.057007 
	C1575.541626,738.659363 1576.932007,737.261780 1578.602417,735.386963 
	C1579.333252,734.302917 1579.784180,733.696045 1580.235107,733.089111 
	C1581.907471,731.339844 1583.579834,729.590515 1585.547607,727.377075 
	C1586.293457,726.299866 1586.744141,725.686890 1587.194702,725.073853 
	C1590.901855,721.012817 1594.608887,716.951843 1598.599243,712.400330 
	C1599.333374,711.302979 1599.784302,710.696106 1600.235107,710.089233 
	C1601.907593,708.339905 1603.579956,706.590637 1605.547607,704.377136 
	C1606.293457,703.299866 1606.744141,702.686829 1607.194702,702.073853 
	C1609.166748,699.912170 1611.038330,697.645020 1613.152222,695.632324 
	C1614.249390,694.587708 1615.757812,693.338623 1617.110229,693.302612 
	C1625.237793,693.086365 1633.374146,693.195312 1642.450684,693.195312 
	C1638.318237,700.490234 1634.547974,707.156250 1630.767944,713.816711 
	C1624.432739,724.979675 1618.186768,736.195007 1611.700195,747.269348 
	C1609.452759,751.106628 1609.972778,754.263855 1613.202148,756.843140 
	C1616.565552,759.529480 1619.634277,758.372864 1622.257812,755.312988 
	C1627.253784,749.486267 1632.293823,743.697205 1637.597168,737.403076 
	C1638.302856,736.294739 1638.727051,735.675842 1639.151123,735.056885 
	C1644.202881,729.332703 1649.254639,723.608521 1654.593262,717.398071 
	C1655.318481,716.299194 1655.756592,715.686523 1656.194702,715.073853 
	C1657.548218,713.660217 1658.901733,712.246582 1660.548096,710.373840 
	C1661.277710,709.295410 1661.714478,708.676208 1662.151123,708.057007 
	C1665.192627,704.873535 1668.104858,701.549683 1671.337646,698.574036 
	C1672.685181,697.333740 1674.714722,696.130188 1676.435425,696.128357 
	C1682.203125,696.122131 1687.971313,696.665283 1693.404419,697.604980 
	C1692.547974,699.122498 1692.026367,700.033142 1691.504761,700.943787 
	C1686.630615,708.024597 1681.756470,715.105469 1676.519043,722.705688 
	C1672.272827,729.131287 1668.390015,735.037598 1664.507324,740.943909 
	C1658.956299,749.019470 1653.405273,757.095032 1647.492554,765.700867 
	C1645.285400,769.146423 1643.439941,772.061707 1641.594482,774.977051 
	C1640.250610,775.924438 1638.906616,776.871826 1636.942871,778.011963 
	C1634.661011,779.371277 1632.999146,780.537842 1631.337280,781.704407 
	C1628.428955,783.063416 1625.520630,784.422424 1621.966309,785.986450 
	C1619.653320,787.353882 1617.986450,788.516235 1616.319580,789.678650 
	C1613.416870,791.046448 1610.514160,792.414124 1606.961914,793.989685 
	C1603.975708,795.683411 1601.638916,797.169189 1599.302002,798.654968 
	C1596.405762,800.030212 1593.509644,801.405518 1589.967651,802.993286 
	C1587.644043,804.348877 1585.966309,805.491943 1584.288452,806.635071 
z"
      />
      <path
        fill="#F39201"
        opacity="1.000000"
        stroke="none"
        d="
M501.056580,1401.850098 
	C496.684937,1398.026367 492.377991,1394.125122 487.922363,1390.401855 
	C483.974640,1387.102905 479.861786,1384.001465 475.348022,1380.527588 
	C474.268341,1379.778198 473.662476,1379.314087 473.056610,1378.850098 
	C468.684998,1375.026245 464.377960,1371.125122 459.922424,1367.401855 
	C455.974670,1364.102783 451.861816,1361.001343 447.348022,1357.527588 
	C446.268341,1356.778198 445.662476,1356.314087 445.056641,1355.850098 
	C440.685028,1352.026245 436.377991,1348.125122 431.922394,1344.401855 
	C427.974670,1341.102905 423.861816,1338.001465 419.347961,1334.527588 
	C418.268280,1333.778320 417.662415,1333.314209 417.056580,1332.850098 
	C412.684998,1329.026245 408.377991,1325.125122 403.922424,1321.401855 
	C399.974609,1318.102783 395.861725,1315.001465 391.347961,1311.527588 
	C390.268341,1310.778198 389.662445,1310.314209 389.056580,1309.850098 
	C384.684967,1306.026245 380.378021,1302.125122 375.922455,1298.401733 
	C371.974731,1295.102783 367.861786,1292.001465 363.347992,1288.527588 
	C362.268280,1287.778320 361.662415,1287.314209 361.056580,1286.850098 
	C358.685699,1284.684204 356.314789,1282.518311 353.981903,1280.387207 
	C395.704834,1211.490112 437.301117,1142.802246 478.472290,1074.816284 
	C507.406921,1103.751343 536.282959,1132.627808 565.158997,1161.504272 
	C565.637634,1161.250610 566.116333,1160.996826 566.594971,1160.743042 
	C564.781494,1162.832397 562.967957,1164.921631 560.721558,1167.475098 
	C559.174377,1169.286499 558.060181,1170.633667 556.945923,1171.980713 
	C554.677734,1174.326904 552.409546,1176.673096 549.704590,1179.472656 
	C547.833923,1181.613403 546.399963,1183.300781 544.966003,1184.988281 
	C542.691956,1187.332397 540.417908,1189.676636 537.709473,1192.478516 
	C535.838806,1194.620239 534.402466,1196.304321 532.966064,1197.988281 
	C530.692688,1200.332397 528.419312,1202.676392 525.714111,1205.483887 
	C523.843567,1207.627563 522.404846,1209.307983 520.966064,1210.988281 
	C519.023682,1212.999512 517.081360,1215.010742 514.699463,1217.468506 
	C512.821899,1219.603638 511.383881,1221.292236 509.945923,1222.980713 
	C507.678528,1225.327637 505.411102,1227.674438 502.705811,1230.473511 
	C500.841553,1232.615967 499.415131,1234.306030 497.988678,1235.996216 
	C497.428955,1237.852661 496.869232,1239.708984 496.559937,1242.168457 
	C497.494263,1243.649048 498.178192,1244.526611 498.862122,1245.404053 
	C500.034454,1246.861450 501.206818,1248.318726 502.789276,1250.199951 
	C504.420593,1251.884033 505.641785,1253.144409 506.862976,1254.404785 
	C508.364227,1256.192139 509.865448,1257.979614 511.778290,1260.197754 
	C513.414246,1261.887207 514.638550,1263.146118 515.862854,1264.404907 
	C517.359619,1266.190308 518.856384,1267.975830 520.756226,1270.201538 
	C522.393799,1271.896240 523.628296,1273.150635 524.862793,1274.405029 
	C526.036621,1275.858643 527.210449,1277.312256 528.799805,1279.195068 
	C530.764282,1281.217529 532.313232,1282.810913 533.862183,1284.404297 
	C535.034485,1285.861572 536.206787,1287.318848 537.789307,1289.199951 
	C539.420654,1290.884033 540.641846,1292.144409 541.863098,1293.404785 
	C543.364319,1295.192139 544.865479,1296.979614 546.783020,1299.195312 
	C548.420532,1300.884155 549.641663,1302.144531 550.862854,1303.404907 
	C552.363647,1305.192505 553.864441,1306.980225 555.777588,1309.198242 
	C557.414185,1310.887329 558.638428,1312.146240 559.862671,1313.405029 
	C561.359192,1315.190918 562.855652,1316.976685 564.755859,1319.202393 
	C566.393860,1320.896362 567.628113,1322.150513 568.862427,1323.404663 
	C570.034668,1324.861938 571.206909,1326.319092 572.794922,1328.197510 
	C574.428101,1329.880737 575.645569,1331.142700 576.863098,1332.404785 
	C578.364258,1334.192139 579.865417,1335.979614 581.782959,1338.195312 
	C583.420532,1339.884155 584.641663,1341.144531 585.862793,1342.404907 
	C587.363647,1344.192505 588.864441,1345.980225 590.777588,1348.198242 
	C592.414185,1349.887329 593.638428,1351.146240 594.862671,1352.405029 
	C596.359192,1354.190918 597.855713,1355.976685 599.755920,1358.202393 
	C601.393921,1359.896362 602.628174,1361.150513 603.862427,1362.404663 
	C605.034668,1363.861816 606.206970,1365.319092 607.794922,1367.197510 
	C609.428162,1368.880737 610.645630,1370.142700 611.863098,1371.404785 
	C613.364258,1373.192139 614.865417,1374.979614 616.783020,1377.195312 
	C618.420593,1378.884155 619.641724,1380.144531 620.862854,1381.404907 
	C622.363647,1383.192505 623.864441,1384.980225 625.777588,1387.198120 
	C627.414185,1388.887207 628.638428,1390.146118 629.862732,1391.404907 
	C631.676270,1393.574097 633.489807,1395.743408 635.724426,1398.355957 
	C637.051147,1399.667725 637.956848,1400.536255 638.862488,1401.404663 
	C640.352844,1403.227661 641.843140,1405.050537 643.747437,1407.312012 
	C645.395020,1408.968506 646.628601,1410.186401 647.862183,1411.404297 
	C649.348328,1413.235229 650.834412,1415.066284 652.736938,1417.336670 
	C654.023376,1419.155273 654.893372,1420.534424 655.763306,1421.913452 
	C647.468018,1431.947021 639.281677,1442.073486 630.837219,1451.979858 
	C625.627991,1458.090942 620.025330,1463.866577 613.992981,1469.975220 
	C612.563782,1471.043945 611.740967,1471.930298 610.918091,1472.816650 
	C610.537781,1473.602173 610.157532,1474.387695 609.456787,1475.764893 
	C607.114075,1479.505005 605.091797,1482.653442 603.069580,1485.801880 
	C597.987000,1481.472168 592.904419,1477.142456 587.347900,1472.527588 
	C586.268250,1471.778198 585.662415,1471.314087 585.056519,1470.850098 
	C580.684937,1467.026245 576.377930,1463.125244 571.922363,1459.401855 
	C567.974670,1456.102783 563.861755,1453.001465 559.347900,1449.527466 
	C558.268311,1448.778198 557.662415,1448.314087 557.056519,1447.850098 
	C552.684937,1444.026245 548.377930,1440.125244 543.922424,1436.401855 
	C539.974670,1433.102783 535.861755,1430.001465 531.347900,1426.527588 
	C530.268250,1425.778198 529.662415,1425.314209 529.056519,1424.850098 
	C524.684937,1421.026245 520.377930,1417.125244 515.922424,1413.401855 
	C511.974731,1410.102783 507.861755,1407.001465 503.347961,1403.527588 
	C502.268341,1402.778198 501.662476,1402.314209 501.056580,1401.850098 
z"
      />
      <path
        fill="#F39201"
        opacity="1.000000"
        stroke="none"
        d="
M536.054077,1214.019287 
	C538.322327,1211.672974 540.590576,1209.326660 543.299316,1206.532715 
	C545.171204,1204.393921 546.602600,1202.702881 548.034058,1201.011719 
	C550.307983,1198.667480 552.581970,1196.323364 555.290405,1193.521729 
	C557.161255,1191.380005 558.597656,1189.695923 560.034058,1188.011719 
	C562.307373,1185.667725 564.580627,1183.323730 567.285828,1180.516479 
	C569.156494,1178.372681 570.595276,1176.692261 572.034058,1175.011719 
	C591.662048,1159.328003 611.294373,1143.649780 630.907043,1127.947021 
	C632.039795,1127.040039 633.012756,1125.933716 634.335327,1124.553955 
	C634.960327,1124.189087 635.309998,1124.190308 635.659729,1124.191650 
	C636.774048,1139.201416 637.857849,1154.213623 639.010193,1169.220459 
	C640.579468,1189.657471 642.273132,1210.085083 643.772522,1230.526978 
	C644.656616,1242.580078 645.155579,1254.661255 646.030151,1266.715088 
	C647.178345,1282.539185 648.599792,1298.343506 649.763306,1314.166504 
	C650.625305,1325.888428 651.181091,1337.632812 652.021545,1349.356445 
	C653.203003,1365.838623 654.521790,1382.310791 655.566772,1399.213867 
	C655.014954,1399.694946 654.678162,1399.749512 654.341370,1399.803955 
	C652.491333,1397.604858 650.641296,1395.405762 648.388184,1392.791504 
	C647.396973,1391.884521 646.809021,1391.392578 646.221008,1390.900635 
	C644.086670,1388.337524 641.952332,1385.774414 639.419312,1382.787842 
	C638.435059,1381.869507 637.849548,1381.374634 637.263916,1380.879761 
	C635.393860,1378.350830 633.523804,1375.821777 631.247192,1372.825439 
	C629.606201,1371.103760 628.371765,1369.849243 627.137329,1368.594849 
	C625.640808,1366.808960 624.144348,1365.023071 622.244141,1362.797363 
	C620.606140,1361.103516 619.371948,1359.849365 618.137695,1358.595337 
	C616.965454,1357.138184 615.793213,1355.680908 614.205200,1353.802490 
	C612.571960,1352.119141 611.354431,1350.857056 610.136902,1349.594971 
	C608.635742,1347.807617 607.134583,1346.020264 605.216919,1343.804443 
	C603.579468,1342.115723 602.358398,1340.855469 601.137268,1339.595093 
	C599.636475,1337.807373 598.135681,1336.019775 596.222473,1333.801758 
	C594.585876,1332.112549 593.361633,1330.853638 592.137329,1329.594849 
	C590.640808,1327.808960 589.144348,1326.023071 587.244080,1323.797363 
	C585.606140,1322.103516 584.371887,1320.849487 583.137695,1319.595337 
	C581.965454,1318.138184 580.793213,1316.680908 579.205200,1314.802490 
	C577.571960,1313.119141 576.354431,1311.857056 575.136902,1310.594971 
	C573.635681,1308.807617 572.134521,1307.020264 570.216919,1304.804443 
	C568.579468,1303.115723 567.358398,1301.855469 566.137268,1300.595093 
	C564.636475,1298.807373 563.135681,1297.019775 561.222534,1294.801758 
	C559.585938,1293.112671 558.361633,1291.853882 557.137268,1290.594971 
	C555.640808,1288.809082 554.144348,1287.023071 552.244263,1284.797607 
	C550.606262,1283.103760 549.371826,1281.849365 548.137390,1280.595093 
	C546.965271,1279.137939 545.793091,1277.680908 544.202881,1275.799805 
	C542.235840,1273.782471 540.686890,1272.188965 539.137878,1270.595581 
	C537.966431,1269.138306 536.794922,1267.681152 535.212036,1265.800049 
	C533.579407,1264.115723 532.358154,1262.855347 531.136902,1261.594971 
	C529.636169,1259.807251 528.135437,1258.019653 526.222534,1255.801758 
	C524.585999,1254.112671 523.361633,1252.853882 522.137268,1251.594971 
	C520.640808,1249.809082 519.144348,1248.023071 517.244263,1245.797607 
	C515.606262,1244.103638 514.371826,1242.849365 513.137329,1241.595093 
	C515.375854,1238.390747 517.614380,1235.186401 520.288818,1231.523071 
	C522.161133,1229.379883 523.597595,1227.695801 525.034058,1226.011719 
	C527.307373,1223.667725 529.580688,1221.323730 532.282715,1218.520264 
	C533.825623,1216.713745 534.939819,1215.366455 536.054077,1214.019287 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M663.852783,1459.057373 
	C669.119141,1475.645874 674.468628,1492.208618 679.632385,1508.828979 
	C687.381042,1533.770142 695.051147,1558.736084 702.638794,1583.726562 
	C704.684509,1590.463989 706.311768,1597.328613 707.724792,1604.676758 
	C707.124146,1605.812744 706.929749,1606.406616 706.735291,1607.000488 
	C703.139465,1613.007324 699.543640,1619.014282 695.627502,1625.544678 
	C694.782593,1627.046753 694.257996,1628.025391 693.733398,1629.003906 
	C690.135925,1634.994141 686.538513,1640.984375 682.620422,1647.506104 
	C681.777588,1649.026367 681.255432,1650.015259 680.733398,1651.004150 
	C677.135986,1656.994507 673.538574,1662.984985 669.616455,1669.501221 
	C668.772339,1671.019531 668.252869,1672.011841 667.733398,1673.004150 
	C667.459717,1673.404419 667.186035,1673.804688 666.610474,1674.635864 
	C665.802063,1676.046021 665.295532,1677.025269 664.789062,1678.004395 
	C663.518860,1679.885620 662.248718,1681.766846 660.870605,1683.808105 
	C635.184204,1673.710449 609.651672,1663.673218 583.633484,1653.445190 
	C586.028564,1650.665039 588.109436,1648.249878 590.498596,1645.371338 
	C591.268799,1644.296265 591.730591,1643.684570 592.192444,1643.072754 
	C594.192322,1640.989868 596.192261,1638.906982 598.499512,1636.365967 
	C599.268677,1635.296143 599.730530,1634.684448 600.192383,1634.072754 
	C604.105408,1628.955200 608.346069,1628.606812 614.215820,1631.542847 
	C622.417908,1635.645264 631.237915,1638.503906 639.754211,1641.990845 
	C643.506592,1643.527100 646.771912,1643.433838 649.532593,1640.080444 
	C652.176575,1636.868896 650.544128,1634.075073 648.429016,1630.771484 
	C647.489624,1629.136475 646.931213,1627.987793 646.372803,1626.838989 
	C643.177368,1620.637207 639.981873,1614.435303 636.416748,1607.753906 
	C635.412659,1606.162720 634.778198,1605.051147 634.143738,1603.939697 
	C631.039429,1597.697754 627.935120,1591.455688 624.456299,1584.736816 
	C623.435852,1583.153076 622.789795,1582.046387 622.143738,1580.939697 
	C618.691284,1574.037598 615.238892,1567.135620 611.417236,1559.759399 
	C610.489624,1558.136475 609.931213,1556.987793 609.372803,1555.838989 
	C609.332153,1555.510132 609.413269,1555.076172 609.233398,1554.867310 
	C601.128662,1545.464111 605.559326,1535.762207 608.483582,1526.070312 
	C611.455933,1516.218628 614.344421,1506.341797 617.271301,1496.476440 
	C618.547424,1492.174927 619.545227,1487.759277 621.233398,1483.625854 
	C621.998962,1481.751465 623.869507,1479.947754 625.696533,1478.948975 
	C637.636108,1472.422729 649.701172,1466.125854 662.182861,1459.388428 
	C663.044556,1459.034424 663.448669,1459.045898 663.852783,1459.057373 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M901.000854,931.166809 
	C889.994568,927.277222 878.968323,923.443237 867.988159,919.481201 
	C858.532166,916.069031 849.155457,912.436279 839.687439,909.058899 
	C836.454224,907.905579 834.597412,907.247009 835.784790,902.620422 
	C841.526794,880.246094 846.665710,857.716187 851.945740,835.224365 
	C854.783325,823.136902 857.398987,810.996643 860.349548,798.937622 
	C860.639526,797.752502 862.602295,796.100830 863.748535,796.132202 
	C881.104919,796.606873 898.452087,797.409668 915.807129,797.950989 
	C923.294922,798.184570 930.795898,797.996643 938.290894,797.999817 
	C940.075562,798.000610 941.860229,797.999939 943.931519,797.999939 
	C943.602112,804.075806 943.124695,809.625549 943.030640,815.181763 
	C942.625488,839.098999 942.388550,863.019043 941.972412,886.935974 
	C941.802551,896.697083 941.267456,906.451477 941.041870,916.212219 
	C940.978088,918.971252 940.656799,920.358521 937.256470,921.218140 
	C925.987122,924.067017 914.912292,927.685425 903.050293,931.018921 
	C901.892151,931.075073 901.446472,931.120911 901.000854,931.166809 
z"
      />
      <path
        fill="#F39405"
        opacity="1.000000"
        stroke="none"
        d="
M593.723083,1529.899048 
	C590.315430,1527.603394 586.719177,1525.540161 583.540527,1522.962158 
	C577.507202,1518.068848 571.713074,1512.880737 565.347412,1507.510986 
	C563.934814,1506.423462 562.994446,1505.639893 562.054077,1504.856445 
	C558.638611,1501.520996 555.223145,1498.185669 551.327881,1494.513916 
	C548.583435,1492.070557 546.318787,1489.963623 544.054077,1487.856567 
	C541.638489,1485.308472 539.222839,1482.760254 536.379517,1479.753906 
	C533.720764,1477.158691 531.489685,1475.021484 529.258606,1472.884399 
	C526.099976,1469.326050 522.941345,1465.767822 519.379761,1461.794922 
	C518.389282,1460.888062 517.801697,1460.395874 517.214111,1459.903564 
	C515.393982,1457.672241 513.573730,1455.440796 511.349365,1452.804932 
	C510.382324,1451.894409 509.819458,1451.388550 509.256592,1450.882690 
	C506.961365,1447.781982 504.713776,1444.644653 502.362946,1441.586792 
	C491.161163,1427.016235 479.935303,1412.464233 468.697937,1397.921143 
	C468.201874,1397.279175 467.509491,1396.789062 466.576538,1395.716187 
	C465.530548,1394.377930 464.816589,1393.551758 464.102600,1392.725464 
	C463.222534,1390.941528 462.342438,1389.157715 461.462372,1387.373779 
	C461.634979,1387.166016 461.807556,1386.958374 461.980164,1386.750610 
	C466.213928,1390.190552 470.447662,1393.630371 475.156586,1397.489746 
	C477.074677,1398.974854 478.517639,1400.040527 479.960602,1401.106323 
	C487.534210,1407.427612 495.107788,1413.749023 503.156586,1420.489746 
	C505.074738,1421.974731 506.517700,1423.040527 507.960632,1424.106323 
	C515.534180,1430.427612 523.107788,1436.749023 531.156555,1443.489624 
	C533.074707,1444.974731 534.517700,1446.040527 535.960693,1447.106323 
	C557.852112,1465.193359 579.743591,1483.280273 601.899597,1501.585815 
	C599.359192,1510.032104 596.768860,1518.644287 594.088989,1527.942139 
	C593.907288,1529.051514 593.815186,1529.475342 593.723083,1529.899048 
z"
      />
      <path
        fill="#F39303"
        opacity="1.000000"
        stroke="none"
        d="
M1566.896606,689.279297 
	C1570.032104,695.112427 1573.167725,700.945557 1576.645996,707.306641 
	C1578.905762,710.681335 1580.758423,713.533264 1577.727417,716.788086 
	C1577.727417,716.788086 1577.847046,716.919617 1577.533936,716.957886 
	C1576.460083,717.950623 1575.699341,718.905151 1574.938721,719.859680 
	C1573.734375,720.976990 1572.172852,721.886719 1571.383179,723.245117 
	C1565.991699,732.519226 1557.158325,736.059326 1547.421631,738.904541 
	C1530.719238,743.785217 1514.229980,749.395813 1496.957764,754.827454 
	C1494.843262,755.359985 1493.422241,755.765076 1492.001099,756.170166 
	C1494.088013,751.287109 1496.181274,746.406738 1498.259155,741.519897 
	C1499.206299,739.292542 1500.123291,737.052429 1501.404785,734.276489 
	C1502.553223,731.841431 1503.350708,729.947815 1504.148193,728.054260 
	C1507.510254,721.659119 1510.960083,715.308105 1514.199585,708.851440 
	C1515.999023,705.264587 1517.447266,701.501648 1519.404785,697.276489 
	C1520.553345,694.841431 1521.350830,692.947876 1522.148193,691.054321 
	C1522.539062,690.779114 1523.197998,690.567810 1523.281250,690.219238 
	C1525.147949,682.392212 1530.477783,681.097473 1537.639648,681.728394 
	C1544.401489,682.324158 1551.259155,681.833496 1558.904663,681.821411 
	C1562.122070,684.307800 1564.509277,686.793518 1566.896606,689.279297 
z"
      />
      <path
        fill="#F39404"
        opacity="1.000000"
        stroke="none"
        d="
M1672.144287,650.001831 
	C1672.144409,656.774536 1672.144409,663.048035 1672.144409,669.558777 
	C1660.009644,669.558777 1648.438354,669.558777 1636.528320,669.558777 
	C1636.528320,657.834839 1636.528320,646.271545 1636.528320,634.280640 
	C1648.142456,634.280640 1659.825806,634.280640 1672.144287,634.280640 
	C1672.144287,639.311646 1672.144287,644.407104 1672.144287,650.001831 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M1604.948120,669.803711 
	C1595.834351,669.803711 1587.214111,669.803711 1578.297363,669.803711 
	C1578.297363,657.808594 1578.297363,646.230835 1578.297363,634.255676 
	C1589.903198,634.255676 1601.619629,634.255676 1613.739502,634.255676 
	C1613.739502,645.755615 1613.739502,657.458618 1613.739502,669.803772 
	C1610.988281,669.803772 1608.214966,669.803772 1604.948120,669.803711 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M1528.072998,669.803772 
	C1525.276001,669.803711 1522.967163,669.803711 1520.260864,669.803711 
	C1520.260864,657.809875 1520.260864,646.122437 1520.260864,634.145508 
	C1532.011475,634.145508 1543.733887,634.145508 1555.730835,634.145508 
	C1555.730835,645.847778 1555.730835,657.439392 1555.730835,669.803833 
	C1546.718872,669.803833 1537.640015,669.803833 1528.072998,669.803772 
z"
      />
      <path
        fill="#F39404"
        opacity="1.000000"
        stroke="none"
        d="
M1648.014648,612.378967 
	C1643.912720,612.379089 1640.307617,612.379089 1636.452637,612.379089 
	C1636.452637,600.187378 1636.452637,588.604980 1636.452637,576.605469 
	C1648.124146,576.605469 1659.802246,576.605469 1671.814697,576.605469 
	C1671.814697,588.313049 1671.814697,600.011597 1671.814697,612.378845 
	C1663.997192,612.378845 1656.254395,612.378845 1648.014648,612.378967 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M1609.930176,612.372498 
	C1599.151611,612.373108 1588.865723,612.373108 1578.289795,612.373108 
	C1578.289795,600.287598 1578.289795,588.558044 1578.289795,576.511230 
	C1590.063965,576.511230 1601.773560,576.511230 1614.115723,576.511230 
	C1614.115723,587.857178 1614.181519,599.102112 1613.957397,610.341187 
	C1613.943481,611.041321 1611.653809,611.696045 1609.930176,612.372498 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M1519.860352,587.025269 
	C1519.860352,583.250244 1519.860352,579.971069 1519.860352,576.452087 
	C1531.989502,576.452087 1543.573853,576.452087 1555.581909,576.452087 
	C1555.581909,588.236328 1555.581909,600.066589 1555.581909,612.101807 
	C1543.788086,612.101807 1532.081421,612.101807 1519.860474,612.101807 
	C1519.860474,603.733521 1519.860474,595.627380 1519.860352,587.025269 
z"
      />
      <path
        fill="#F39302"
        opacity="1.000000"
        stroke="none"
        d="
M1671.633911,554.642395 
	C1659.818848,554.983093 1648.349976,554.983093 1636.539429,554.983093 
	C1636.539429,543.096191 1636.539429,531.372864 1636.539429,519.321167 
	C1648.277222,519.321167 1659.977783,519.321167 1671.980103,519.321167 
	C1671.980103,531.091980 1671.980103,542.696838 1671.633911,554.642395 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1599.994873,555.134766 
	C1592.530029,555.134766 1585.563599,555.134766 1578.300171,555.134766 
	C1578.300171,543.069641 1578.300171,531.336365 1578.300171,519.300415 
	C1590.043823,519.300415 1601.771240,519.300415 1613.817749,519.300415 
	C1613.817749,531.053772 1613.817749,542.773621 1613.817749,555.134705 
	C1609.360840,555.134705 1604.927002,555.134705 1599.994873,555.134766 
z"
      />
      <path
        fill="#F39200"
        opacity="1.000000"
        stroke="none"
        d="
M1526.088379,519.000000 
	C1536.202026,519.000000 1545.827393,519.000000 1555.724609,519.000000 
	C1555.724609,531.097778 1555.724609,542.827026 1555.724609,554.846313 
	C1543.891724,554.846313 1532.169800,554.846313 1520.155762,554.846313 
	C1520.155762,542.994629 1520.155762,531.269165 1520.155762,519.000000 
	C1522.040527,519.000000 1523.820312,519.000000 1526.088379,519.000000 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1626.516113,821.917236 
	C1624.276245,816.478088 1622.267944,810.993652 1620.549194,805.419922 
	C1619.787598,802.949951 1618.581909,802.997437 1616.406372,804.065125 
	C1616.014160,801.790405 1615.644897,799.276855 1619.101562,799.029419 
	C1622.697876,798.771973 1622.595337,801.178528 1623.141846,803.794922 
	C1624.078247,808.276550 1625.890015,812.568298 1627.047974,817.014282 
	C1627.436035,818.504456 1626.951172,820.222046 1626.516113,821.917236 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1584.118408,1322.126099 
	C1586.560059,1316.452881 1589.186890,1311.046143 1591.983032,1305.321045 
	C1592.720703,1305.981812 1594.016846,1307.304932 1593.742310,1307.885986 
	C1591.487549,1312.659302 1588.979370,1317.316162 1586.416504,1321.935425 
	C1586.186157,1322.350708 1585.029785,1322.252319 1584.118408,1322.126099 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M548.926758,548.949341 
	C543.354797,555.100342 537.610657,560.976868 531.567444,566.986084 
	C531.124756,566.324280 530.571533,565.132019 530.898926,564.794800 
	C536.188477,559.346497 541.575623,553.992249 547.004333,548.681763 
	C547.303589,548.389038 548.158325,548.664124 548.926758,548.949341 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1566.926392,688.814575 
	C1564.509277,686.793518 1562.122070,684.307800 1559.364990,681.732666 
	C1560.097656,680.141785 1561.200317,678.640381 1562.302856,677.139038 
	C1563.841553,678.579224 1566.047607,679.757935 1566.741943,681.529114 
	C1567.523926,683.524231 1566.943726,686.053101 1566.926392,688.814575 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1287.159180,1611.148438 
	C1292.728271,1607.641602 1298.518677,1604.428589 1304.654663,1601.176025 
	C1304.879517,1601.941528 1305.058716,1603.113647 1304.592041,1603.494995 
	C1299.552490,1607.613403 1294.291382,1611.345337 1287.159180,1611.148438 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M653.002075,1449.176880 
	C652.370483,1451.045288 652.213684,1453.433350 650.939087,1454.598022 
	C650.099854,1455.364624 647.392944,1454.803955 646.020203,1453.993896 
	C645.229675,1453.527344 644.762939,1450.649658 645.321960,1450.138672 
	C646.566528,1449.000977 648.547241,1448.668457 650.701660,1448.331787 
	C651.784302,1448.829346 652.393250,1449.003174 653.002075,1449.176880 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1664.898315,740.945129 
	C1668.390015,735.037598 1672.272827,729.131287 1676.443115,723.053833 
	C1677.047485,723.230164 1677.691650,723.811523 1677.634399,723.891846 
	C1673.555054,729.602295 1669.419922,735.272644 1664.898315,740.945129 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M603.086548,1486.134766 
	C605.091797,1482.653442 607.114075,1479.505005 609.373779,1476.103394 
	C613.320007,1479.310425 612.947815,1482.259033 608.742004,1484.087769 
	C607.522339,1484.617920 606.695801,1486.005371 605.504761,1486.668945 
	C604.922424,1486.993286 603.917297,1486.558594 603.086548,1486.134766 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1578.133789,716.851501 
	C1580.758423,713.533264 1578.905762,710.681335 1576.962036,707.485474 
	C1578.762695,706.964661 1584.450928,711.754333 1583.662354,713.146118 
	C1582.708740,714.829468 1580.312256,715.695251 1578.133789,716.851501 
z"
      />
      <path
        fill="#F59D1D"
        opacity="1.000000"
        stroke="none"
        d="
M653.323242,1448.999756 
	C652.393250,1449.003174 651.784302,1448.829346 651.122559,1448.337646 
	C651.458740,1447.601196 651.847778,1447.182861 652.521484,1446.319580 
	C653.237671,1445.262207 653.669189,1444.649780 654.100647,1444.037231 
	C655.467102,1442.837891 656.833557,1441.638550 658.214844,1440.426147 
	C659.605652,1445.508789 659.605652,1445.508789 653.323242,1448.999756 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1356.741089,1571.789185 
	C1360.973511,1568.479736 1365.622192,1565.257935 1370.598389,1561.920654 
	C1368.624512,1568.290527 1362.814819,1569.979492 1356.741089,1571.789185 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1544.897705,1387.945312 
	C1547.436768,1383.333130 1550.367065,1378.722290 1553.604004,1373.937988 
	C1553.696167,1380.108643 1550.235352,1384.479126 1544.897705,1387.945312 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1478.898071,571.996216 
	C1476.296143,569.878479 1473.730957,567.350403 1471.033447,564.523071 
	C1474.645142,562.788696 1478.427734,566.255066 1478.898071,571.996216 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1460.958740,553.756348 
	C1458.280273,551.677368 1455.617554,549.202881 1452.774170,546.433228 
	C1457.915405,546.146790 1460.229370,548.141052 1460.958740,553.756348 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1479.530762,749.994507 
	C1480.385254,747.543640 1481.603638,745.086365 1482.987305,742.315918 
	C1486.103516,745.051758 1484.939697,747.904175 1479.530762,749.994507 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1497.530762,712.994507 
	C1498.385254,710.543640 1499.603516,708.086304 1500.987305,705.315918 
	C1504.103516,708.051697 1502.939697,710.904175 1497.530762,712.994507 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1467.158691,694.171631 
	C1468.747314,691.650085 1470.540771,689.409790 1472.645996,687.027832 
	C1473.123779,690.909912 1472.880127,694.630554 1467.158691,694.171631 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1432.158691,731.171631 
	C1433.747314,728.650085 1435.540771,726.409729 1437.645996,724.027832 
	C1438.123779,727.909912 1437.880127,731.630554 1432.158691,731.171631 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1397.158691,768.171509 
	C1398.747314,765.650085 1400.540771,763.409729 1402.645996,761.027771 
	C1403.123657,764.909668 1402.880371,768.630554 1397.158691,768.171509 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1641.977783,774.964355 
	C1643.439941,772.061707 1645.285400,769.146423 1647.406982,766.046387 
	C1649.077393,770.746704 1645.750854,772.867676 1641.977783,774.964355 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1451.009521,1497.898682 
	C1452.836914,1495.613281 1455.080444,1493.364380 1457.633545,1490.982056 
	C1458.211060,1495.455200 1456.262329,1498.023193 1451.009521,1497.898682 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M792.064697,1641.439941 
	C795.577454,1642.121094 799.153625,1643.149292 802.887146,1644.533203 
	C799.405701,1643.854858 795.766907,1642.821045 792.064697,1641.439941 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1465.717529,714.030640 
	C1463.960571,716.308228 1461.807861,718.574219 1459.348633,720.976868 
	C1458.778564,716.662659 1460.678833,714.127075 1465.717529,714.030640 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1430.717529,751.030640 
	C1428.960571,753.308289 1426.807861,755.574280 1424.348633,757.976929 
	C1423.778564,753.662659 1425.678833,751.127075 1430.717529,751.030640 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1474.097900,1475.072876 
	C1475.690796,1472.830200 1477.481201,1470.883179 1479.566650,1468.764893 
	C1480.283936,1472.723267 1479.276978,1475.678589 1474.097900,1475.072876 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1412.718506,770.030640 
	C1410.965942,772.303162 1408.818604,774.564026 1406.365234,776.957520 
	C1406.338013,773.130066 1407.480347,769.934937 1412.718506,770.030640 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1508.379150,606.958618 
	C1507.407471,605.916138 1506.790894,604.832275 1506.061523,603.453369 
	C1506.493286,600.261047 1508.056396,600.715332 1509.605225,602.207092 
	C1511.550659,604.080872 1511.551270,605.814941 1508.379150,606.958618 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1220.993408,973.490906 
	C1218.756714,972.816895 1216.513306,971.770386 1214.112549,970.417603 
	C1217.731567,967.763855 1219.963257,969.028503 1220.993408,973.490906 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1201.993530,963.490967 
	C1199.756714,962.816833 1197.513062,961.770264 1195.112305,960.417480 
	C1198.732056,957.763062 1200.962891,959.029785 1201.993530,963.490967 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M544.041992,1488.231445 
	C546.318787,1489.963623 548.583435,1492.070557 550.971313,1494.480469 
	C548.004028,1495.332153 545.545044,1493.182007 544.041992,1488.231445 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1161.993530,942.490967 
	C1159.756714,941.816833 1157.513062,940.770264 1155.112305,939.417480 
	C1158.732056,936.763062 1160.962891,938.029785 1161.993530,942.490967 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M528.978760,1473.056396 
	C531.489685,1475.021484 533.720764,1477.158691 536.089233,1479.604858 
	C531.937317,1479.689575 529.434570,1477.453735 528.978760,1473.056396 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1081.993530,900.490967 
	C1079.756714,899.816833 1077.513062,898.770264 1075.112305,897.417480 
	C1078.732056,894.763062 1080.962891,896.029785 1081.993530,900.490967 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1100.993408,910.490906 
	C1098.756714,909.816895 1096.513306,908.770447 1094.112549,907.417603 
	C1097.731567,904.763855 1099.963257,906.028503 1100.993408,910.490906 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1121.993530,921.490967 
	C1119.756714,920.816833 1117.513062,919.770264 1115.112305,918.417480 
	C1118.732056,915.763062 1120.962891,917.029785 1121.993530,921.490967 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1140.993408,931.490906 
	C1138.756714,930.816895 1136.513306,929.770447 1134.112549,928.417603 
	C1137.731567,925.763855 1139.963257,927.028503 1140.993408,931.490906 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1180.993408,952.490906 
	C1178.756714,951.816895 1176.513306,950.770447 1174.112549,949.417603 
	C1177.731567,946.763855 1179.963257,948.028503 1180.993408,952.490906 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1415.164551,749.174683 
	C1416.415649,746.981934 1417.877563,745.073425 1419.648560,743.025513 
	C1419.902954,746.103882 1420.812622,749.993958 1415.164551,749.174683 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1450.164551,712.174683 
	C1451.415771,709.981995 1452.877686,708.073486 1454.648560,706.025574 
	C1454.902954,709.103882 1455.812622,712.993958 1450.164551,712.174683 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1360.533447,843.994019 
	C1361.067261,842.210754 1361.967651,840.420532 1363.017456,838.316406 
	C1365.915894,840.947571 1365.502563,842.038757 1360.533447,843.994019 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1447.712158,733.030762 
	C1446.292847,734.975769 1444.472290,736.909241 1442.347046,738.978149 
	C1441.711792,735.278015 1442.986328,732.830017 1447.712158,733.030762 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1621.444946,1235.954590 
	C1621.712646,1233.904785 1622.332275,1231.809448 1623.059326,1229.357666 
	C1626.869141,1232.128540 1624.253052,1234.003052 1621.444946,1235.954590 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1329.763672,1185.803223 
	C1331.649536,1184.223633 1333.982666,1182.727417 1336.658447,1181.199219 
	C1336.902832,1185.855225 1333.821045,1186.250854 1329.763672,1185.803223 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1599.747437,798.762024 
	C1601.638916,797.169189 1603.975708,795.683411 1606.656372,794.167297 
	C1606.909424,798.848022 1603.837524,799.270447 1599.747437,798.762024 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1481.760864,696.044434 
	C1480.654419,697.983093 1479.156738,699.910034 1477.350586,701.975281 
	C1476.805664,698.891663 1477.443237,696.291931 1481.760864,696.044434 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1352.763672,1173.803223 
	C1354.649536,1172.223633 1356.982666,1170.727539 1359.658447,1169.199219 
	C1359.902832,1173.855225 1356.821045,1174.250854 1352.763672,1173.803223 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1375.763672,1161.803101 
	C1377.649414,1160.223511 1379.982666,1158.727417 1382.658447,1157.199097 
	C1382.902832,1161.855225 1379.821045,1162.250854 1375.763672,1161.803101 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1398.763672,1149.803223 
	C1400.649536,1148.223633 1402.982788,1146.727539 1405.658447,1145.199219 
	C1405.902832,1149.855225 1402.821045,1150.250854 1398.763672,1149.803223 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1211.065552,954.261108 
	C1213.299805,955.029541 1215.558472,956.174194 1217.965210,957.638184 
	C1215.194946,958.071960 1212.173706,958.403748 1211.065552,954.261108 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1091.065552,891.261108 
	C1093.299805,892.029541 1095.558472,893.174194 1097.965210,894.638184 
	C1095.194946,895.071960 1092.173706,895.403748 1091.065552,891.261108 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1171.065552,933.261108 
	C1173.299805,934.029541 1175.558472,935.174194 1177.965210,936.638184 
	C1175.194946,937.071960 1172.173706,937.403748 1171.065552,933.261108 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1131.065552,912.261108 
	C1133.299805,913.029602 1135.558472,914.174255 1137.965210,915.638184 
	C1135.194946,916.071960 1132.173706,916.403748 1131.065552,912.261108 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1399.827515,1162.823486 
	C1398.279907,1164.078979 1396.514160,1165.048096 1394.394775,1166.065918 
	C1394.628052,1162.947021 1396.179565,1161.280396 1399.827515,1162.823486 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1376.827515,1174.823486 
	C1375.279907,1176.078979 1373.514160,1177.047974 1371.394775,1178.065918 
	C1371.628052,1174.947021 1373.179565,1173.280396 1376.827515,1174.823486 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M656.105591,1421.902100 
	C654.893372,1420.534424 654.023376,1419.155273 653.036377,1417.480469 
	C653.943726,1417.169556 655.787292,1416.924194 655.858276,1417.176880 
	C656.281799,1418.684448 656.296204,1420.307007 656.105591,1421.902100 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1422.827515,1150.823486 
	C1421.279907,1152.078979 1419.514160,1153.048096 1417.394775,1154.065918 
	C1417.628052,1150.947021 1419.179565,1149.280396 1422.827515,1150.823486 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1353.827515,1186.823486 
	C1352.279907,1188.078857 1350.514160,1189.047974 1348.394775,1190.065918 
	C1348.628052,1186.947021 1350.179565,1185.280396 1353.827515,1186.823486 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1330.827515,1198.823486 
	C1329.281250,1200.083130 1327.516968,1201.056519 1325.396973,1202.072388 
	C1325.628052,1198.947021 1327.179565,1197.280396 1330.827515,1198.823486 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M533.898926,1283.978516 
	C532.313232,1282.810913 530.764282,1281.217529 529.090759,1279.317993 
	C532.294800,1278.695557 534.457275,1279.655518 533.898926,1283.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M539.101135,1271.021484 
	C540.686890,1272.188965 542.235840,1273.782471 543.909424,1275.682007 
	C540.705383,1276.304443 538.542480,1275.344971 539.101135,1271.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M498.395844,1235.996338 
	C499.415131,1234.306030 500.841553,1232.615967 502.564941,1230.760986 
	C503.261810,1233.713745 502.944000,1236.291870 498.395844,1235.996338 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1438.022095,1509.898438 
	C1439.173950,1508.281860 1440.754395,1506.702148 1442.638916,1504.985596 
	C1443.323730,1508.203003 1442.450073,1510.449219 1438.022095,1509.898438 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M524.625366,1226.009277 
	C523.597595,1227.695801 522.161133,1229.379883 520.431274,1231.234131 
	C519.734436,1228.272827 520.068726,1225.698730 524.625366,1226.009277 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M510.355835,1222.985596 
	C511.383881,1221.292236 512.821899,1219.603638 514.560791,1217.755737 
	C515.270020,1220.741089 514.918152,1223.308716 510.355835,1222.985596 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M521.374756,1210.990723 
	C522.404846,1209.307983 523.843567,1207.627563 525.572388,1205.771484 
	C526.265442,1208.727051 525.931335,1211.301270 521.374756,1210.990723 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M547.625366,1201.009277 
	C546.602600,1202.702881 545.171204,1204.393921 543.439026,1206.244385 
	C542.733765,1203.271851 543.069458,1200.699097 547.625366,1201.009277 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M533.374695,1197.990723 
	C534.402466,1196.304321 535.838806,1194.620239 537.568726,1192.765991 
	C538.265442,1195.727173 537.931274,1198.301270 533.374695,1197.990723 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M559.625366,1188.009277 
	C558.597656,1189.695923 557.161255,1191.380005 555.431274,1193.234131 
	C554.734436,1190.272827 555.068726,1187.698730 559.625366,1188.009277 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M545.374695,1184.990723 
	C546.399963,1183.300781 547.833923,1181.613403 549.564941,1179.760986 
	C550.265686,1182.727539 549.931030,1185.301147 545.374695,1184.990723 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M571.625366,1175.009277 
	C570.595276,1176.692261 569.156494,1178.372681 567.427551,1180.228760 
	C566.734863,1177.273315 567.068298,1174.698486 571.625366,1175.009277 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1521.785156,691.071289 
	C1521.350830,692.947876 1520.553345,694.841431 1519.449463,696.896851 
	C1516.937988,693.936951 1518.870850,692.394592 1521.785156,691.071289 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M848.561951,434.990173 
	C849.153076,432.915314 850.139282,430.829620 851.418579,428.527039 
	C851.756958,430.931183 853.401184,434.212585 848.561951,434.990173 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1503.785156,728.071289 
	C1503.350708,729.947815 1502.553223,731.841431 1501.449463,733.896851 
	C1498.937988,730.936951 1500.870850,729.394592 1503.785156,728.071289 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1443.958740,537.735596 
	C1442.266235,536.681763 1440.589355,535.211670 1438.753174,533.440063 
	C1441.800903,532.713135 1444.347778,533.137085 1443.958740,537.735596 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M647.898621,1410.989014 
	C646.628601,1410.186401 645.395020,1408.968506 644.049988,1407.447510 
	C647.254883,1405.830078 647.611084,1406.135742 647.898621,1410.989014 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1239.964722,983.726685 
	C1238.389526,983.313110 1236.821411,982.512024 1235.104248,981.411133 
	C1237.951050,978.873413 1239.462158,979.978638 1239.964722,983.726685 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1280.992920,1036.518555 
	C1279.416992,1036.163818 1277.833862,1035.436035 1276.103027,1034.409302 
	C1278.727661,1032.080322 1280.397827,1032.775391 1280.992920,1036.518555 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1488.155029,1460.148438 
	C1489.049072,1458.536499 1490.160889,1457.217896 1491.566895,1455.746582 
	C1491.618530,1457.871826 1493.226562,1461.481689 1488.155029,1460.148438 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1490.898193,584.991211 
	C1489.627808,584.188232 1488.393921,582.969971 1487.048950,581.448730 
	C1490.255127,579.829407 1490.611694,580.135376 1490.898193,584.991211 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1211.119141,1642.080322 
	C1212.650879,1641.093262 1214.399292,1640.411377 1216.513916,1639.693848 
	C1216.288696,1643.121460 1214.131226,1643.401855 1211.119141,1642.080322 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1477.735840,863.791870 
	C1478.975342,862.543823 1480.647461,861.383423 1482.660278,860.195068 
	C1483.156738,863.704041 1481.012573,864.247375 1477.735840,863.791870 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1353.953369,468.774200 
	C1352.377808,468.337646 1350.812744,467.523560 1349.101685,466.410645 
	C1351.906250,464.065552 1353.306152,465.417633 1353.953369,468.774200 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1462.735840,871.791870 
	C1463.975342,870.543823 1465.647583,869.383484 1467.660278,868.195068 
	C1468.156738,871.704041 1466.012573,872.247375 1462.735840,871.791870 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1405.729004,777.076477 
	C1405.641968,778.607483 1405.187988,780.159424 1404.422363,781.877991 
	C1402.129150,779.788818 1402.711792,778.181580 1405.729004,777.076477 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M999.482849,1622.008057 
	C998.852112,1623.405640 997.841064,1624.811401 996.473389,1626.274658 
	C997.112061,1624.893555 998.107300,1623.454712 999.482849,1622.008057 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1369.525146,824.994202 
	C1369.740967,823.868164 1370.315186,822.735413 1371.028076,821.302490 
	C1371.723389,821.642090 1372.279785,822.281738 1372.836182,822.921387 
	C1371.851929,823.610046 1370.867676,824.298767 1369.525146,824.994202 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1616.749756,789.776917 
	C1617.986450,788.516235 1619.653320,787.353882 1621.660156,786.164307 
	C1622.163940,789.666199 1620.051880,790.260681 1616.749756,789.776917 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1625.024414,1224.877686 
	C1625.091064,1223.488281 1625.522705,1222.097168 1626.060547,1220.353516 
	C1629.812744,1222.248779 1627.210083,1223.500122 1625.024414,1224.877686 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1569.719482,814.747803 
	C1570.966309,813.491943 1572.644043,812.348816 1574.661133,811.171387 
	C1575.158081,814.689270 1573.033936,815.269226 1569.719482,814.747803 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1554.766602,822.793823 
	C1555.999146,821.537903 1557.661133,820.371399 1559.661621,819.170898 
	C1560.167480,822.654175 1558.061279,823.255493 1554.766602,822.793823 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1584.719482,806.747803 
	C1585.966309,805.491943 1587.644043,804.348877 1589.661133,803.171387 
	C1590.158081,806.689270 1588.033936,807.269226 1584.719482,806.747803 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1378.525146,805.994263 
	C1378.740967,804.868164 1379.315186,803.735413 1380.028076,802.302490 
	C1380.723389,802.642090 1381.279785,803.281738 1381.836182,803.921448 
	C1380.852051,804.610168 1379.867798,805.298828 1378.525146,805.994263 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1539.749756,830.776917 
	C1540.986450,829.516235 1542.653320,828.353882 1544.660156,827.164307 
	C1545.163940,830.666199 1543.051880,831.260681 1539.749756,830.776917 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1522.725342,839.752930 
	C1523.970581,838.496948 1525.646484,837.351196 1527.661377,836.171265 
	C1528.159180,839.684875 1526.037476,840.267761 1522.725342,839.752930 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1507.719482,847.747803 
	C1508.966309,846.492004 1510.644043,845.348877 1512.661133,844.171387 
	C1513.158081,847.689270 1511.033936,848.269226 1507.719482,847.747803 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1387.525146,786.994263 
	C1387.740967,785.868164 1388.315186,784.735413 1389.028076,783.302551 
	C1389.723389,783.642151 1390.279785,784.281799 1390.836182,784.921509 
	C1389.852051,785.610168 1388.867798,786.298828 1387.525146,786.994263 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1631.766602,781.793823 
	C1632.999146,780.537842 1634.661011,779.371277 1636.661621,778.170898 
	C1637.167480,781.654175 1635.061279,782.255493 1631.766602,781.793823 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1492.740723,855.795166 
	C1493.979004,854.540833 1495.651001,853.372925 1497.661621,852.171021 
	C1498.167480,855.673889 1496.040161,856.253662 1492.740723,855.795166 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M507.970032,1423.676392 
	C506.517700,1423.040527 505.074738,1421.974731 503.445221,1420.621582 
	C505.707367,1419.886353 508.195923,1419.374023 507.970032,1423.676392 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M557.361938,1171.984619 
	C558.060181,1170.633667 559.174377,1169.286499 560.575562,1167.767578 
	C561.104736,1169.952026 561.336731,1172.301270 557.361938,1171.984619 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1541.755371,843.041260 
	C1540.681885,844.047729 1539.212158,845.038574 1537.391846,846.072266 
	C1538.480469,845.085266 1539.919800,844.055420 1541.755371,843.041260 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M535.970032,1446.676392 
	C534.517700,1446.040527 533.074707,1444.974731 531.445190,1443.621582 
	C533.707336,1442.886353 536.195740,1442.374268 535.970032,1446.676392 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1566.977905,746.068481 
	C1565.668579,746.934753 1564.177002,747.491150 1562.343262,747.962158 
	C1563.599365,747.170715 1565.197510,746.464600 1566.977905,746.068481 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M603.898438,1361.977539 
	C602.628174,1361.150513 601.393921,1359.896362 600.052856,1358.330811 
	C602.544250,1357.763306 604.458923,1358.279175 603.898438,1361.977539 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M620.898804,1380.978516 
	C619.641724,1380.144531 618.420593,1378.884155 617.082764,1377.317749 
	C619.563538,1376.763062 621.460083,1377.300049 620.898804,1380.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M479.970001,1400.676392 
	C478.517639,1400.040527 477.074677,1398.974854 475.445190,1397.621582 
	C477.707367,1396.886353 480.195923,1396.374023 479.970001,1400.676392 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M629.898682,1390.978516 
	C628.638428,1390.146118 627.414185,1388.887207 626.078003,1387.320068 
	C628.563416,1386.763184 630.460083,1387.300049 629.898682,1390.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M618.101685,1359.022461 
	C619.371948,1359.849365 620.606140,1361.103516 621.947144,1362.669067 
	C619.455627,1363.236816 617.541199,1362.720703 618.101685,1359.022461 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1422.956787,1522.890137 
	C1423.792236,1521.607910 1425.065186,1520.363525 1426.640381,1518.984009 
	C1427.255005,1521.509033 1426.755737,1523.463501 1422.956787,1522.890137 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M611.898926,1370.978271 
	C610.645630,1370.142700 609.428162,1368.880737 608.088379,1367.315186 
	C610.563477,1366.763062 612.459961,1367.299927 611.898926,1370.978271 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M627.101379,1369.022095 
	C628.371765,1369.849243 629.606201,1371.103760 630.947266,1372.669312 
	C628.455078,1373.237183 626.541382,1372.719971 627.101379,1369.022095 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M557.101318,1291.021484 
	C558.361633,1291.853882 559.585938,1293.112671 560.922119,1294.679932 
	C558.436768,1295.236694 556.540100,1294.699707 557.101318,1291.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M585.898743,1341.978516 
	C584.641663,1341.144531 583.420532,1339.884155 582.082703,1338.317749 
	C584.563538,1337.763062 586.460083,1338.300049 585.898743,1341.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M601.101257,1340.021484 
	C602.358398,1340.855469 603.579468,1342.115723 604.917236,1343.682129 
	C602.436462,1344.236938 600.539978,1343.699951 601.101257,1340.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M592.101379,1330.021240 
	C593.361633,1330.853638 594.585876,1332.112549 595.922058,1333.679810 
	C593.436707,1334.236572 591.539917,1333.699707 592.101379,1330.021240 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M576.898926,1331.978271 
	C575.645569,1331.142700 574.428101,1329.880737 573.088379,1328.315186 
	C575.563477,1327.763062 577.459961,1328.299927 576.898926,1331.978271 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M583.101685,1320.022461 
	C584.371887,1320.849487 585.606140,1322.103516 586.947144,1323.669067 
	C584.455627,1324.236816 582.541199,1323.720703 583.101685,1320.022461 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M568.898438,1322.977539 
	C567.628113,1322.150513 566.393860,1320.896362 565.052856,1319.330811 
	C567.544250,1318.763306 569.458923,1319.279175 568.898438,1322.977539 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M575.101074,1311.021484 
	C576.354431,1311.857056 577.571960,1313.119141 578.911743,1314.684692 
	C576.436462,1315.236938 574.540222,1314.699707 575.101074,1311.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M594.898621,1351.978638 
	C593.638428,1351.146240 592.414185,1349.887329 591.078003,1348.320068 
	C593.563416,1347.763306 595.460205,1348.300171 594.898621,1351.978638 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M559.898621,1312.978638 
	C558.638428,1312.146240 557.414185,1310.887329 556.078003,1309.320068 
	C558.563416,1308.763306 560.460205,1309.300171 559.898621,1312.978638 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M859.745728,421.798798 
	C860.956665,420.808441 862.599792,419.902344 864.600708,418.940674 
	C864.771973,422.128052 862.525208,422.085754 859.745728,421.798798 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M566.101257,1301.021484 
	C567.358398,1301.855469 568.579468,1303.115723 569.917236,1304.682129 
	C567.436462,1305.236938 565.539978,1304.699951 566.101257,1301.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M550.898804,1302.978516 
	C549.641663,1302.144531 548.420532,1300.884155 547.082764,1299.317749 
	C549.563538,1298.763062 551.460083,1299.300049 550.898804,1302.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1202.052246,1644.986450 
	C1203.341797,1644.078979 1204.820435,1643.476807 1206.649658,1642.926270 
	C1205.413818,1643.749023 1203.827759,1644.520386 1202.052246,1644.986450 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M541.898926,1292.978271 
	C540.641846,1292.144409 539.420654,1290.884033 538.082764,1289.317627 
	C540.562988,1288.763428 542.460022,1289.299805 541.898926,1292.978271 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M548.101379,1281.022339 
	C549.371826,1281.849365 550.606262,1283.103760 551.947266,1284.669189 
	C549.455383,1285.236938 547.541260,1284.720337 548.101379,1281.022339 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M524.898682,1273.977783 
	C523.628296,1273.150635 522.393799,1271.896240 521.052734,1270.330566 
	C523.544617,1269.763062 525.458740,1270.279785 524.898682,1273.977783 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M531.101074,1262.021484 
	C532.358154,1262.855347 533.579407,1264.115723 534.917297,1265.682129 
	C532.436462,1266.236938 530.540222,1265.699707 531.101074,1262.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M515.898804,1263.978516 
	C514.638550,1263.146118 513.414246,1261.887207 512.078003,1260.320068 
	C514.563599,1259.762939 516.459961,1260.300049 515.898804,1263.978516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M522.101318,1252.021484 
	C523.361633,1252.853882 524.585999,1254.112671 525.922119,1255.679932 
	C523.436768,1256.236694 521.540100,1255.699707 522.101318,1252.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M506.898865,1253.978271 
	C505.641785,1253.144409 504.420593,1251.884033 503.082764,1250.317749 
	C505.563263,1249.763184 507.459839,1250.300049 506.898865,1253.978271 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M513.101379,1242.022339 
	C514.371826,1242.849365 515.606262,1244.103638 516.947266,1245.669189 
	C514.455383,1246.236938 512.541260,1245.720337 513.101379,1242.022339 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M610.101074,1350.021484 
	C611.354431,1350.857056 612.571960,1352.119141 613.911743,1353.684692 
	C611.436462,1354.236938 609.540222,1353.699707 610.101074,1350.021484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M869.935669,430.509033 
	C869.250488,431.221283 868.503296,431.609222 867.431396,432.023224 
	C867.079529,431.248749 867.052490,430.448212 867.025452,429.647705 
	C867.974854,429.826721 868.924194,430.005768 869.935669,430.509033 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M535.638123,1214.015381 
	C534.939819,1215.366455 533.825623,1216.713745 532.424377,1218.232666 
	C531.895325,1216.048218 531.663330,1213.698853 535.638123,1214.015381 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M592.742676,882.787598 
	C593.642944,881.518799 594.992371,880.340210 596.649658,879.024048 
	C597.296570,881.721008 596.535034,883.517273 592.742676,882.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M558.742615,912.787598 
	C559.642883,911.518738 560.992310,910.340149 562.649597,909.024048 
	C563.296570,911.721008 562.535034,913.517273 558.742615,912.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1112.075684,902.284485 
	C1113.776978,902.630676 1115.512695,903.376526 1117.469238,904.415100 
	C1115.830078,904.033325 1113.970093,903.358704 1112.075684,902.284485 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M566.742676,905.787598 
	C567.642944,904.518799 568.992371,903.340210 570.649658,902.024048 
	C571.296570,904.721008 570.535034,906.517273 566.742676,905.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1192.075684,944.284485 
	C1193.776978,944.630737 1195.512695,945.376526 1197.469238,946.415100 
	C1195.830078,946.033264 1193.970093,945.358643 1192.075684,944.284485 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M575.742615,897.787598 
	C576.642883,896.518738 577.992310,895.340210 579.649597,894.024048 
	C580.296570,896.721008 579.535034,898.517273 575.742615,897.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1232.075684,965.284485 
	C1233.776978,965.630676 1235.512695,966.376526 1237.469238,967.415100 
	C1235.830078,967.033264 1233.970093,966.358643 1232.075684,965.284485 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M549.742615,920.787598 
	C550.642883,919.518738 551.992310,918.340210 553.649597,917.024048 
	C554.296570,919.721008 553.535034,921.517273 549.742615,920.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1603.755371,810.041321 
	C1602.681885,811.047791 1601.212280,812.038635 1599.391846,813.072327 
	C1600.480469,812.085327 1601.919800,811.055481 1603.755371,810.041321 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M583.742615,890.787598 
	C584.642883,889.518677 585.992310,888.340149 587.649597,887.024048 
	C588.296570,889.721008 587.535034,891.517273 583.742615,890.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1152.075684,923.284485 
	C1153.776978,923.630676 1155.512695,924.376465 1157.469238,925.415100 
	C1155.830078,925.033325 1153.970093,924.358704 1152.075684,923.284485 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1072.075684,881.284485 
	C1073.776978,881.630737 1075.512695,882.376526 1077.469238,883.415100 
	C1075.830078,883.033325 1073.970093,882.358704 1072.075684,881.284485 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1286.069336,1025.264404 
	C1287.635864,1025.699341 1289.230347,1026.513672 1290.969238,1027.642822 
	C1289.441528,1027.186401 1287.769409,1026.415039 1286.069336,1025.264404 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1588.719727,818.030884 
	C1587.654785,819.033997 1586.196045,820.025574 1584.389282,821.066101 
	C1585.469604,820.083191 1586.897827,819.051270 1588.719727,818.030884 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1492.066650,756.496643 
	C1493.422241,755.765076 1494.843262,755.359985 1496.631958,755.012695 
	C1495.967651,757.294617 1494.754028,759.014099 1492.066650,756.496643 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M600.742615,875.787598 
	C601.642883,874.518738 602.992310,873.340149 604.649597,872.024048 
	C605.296570,874.721008 604.535034,876.517273 600.742615,875.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M609.742615,867.787598 
	C610.642883,866.518677 611.992310,865.340149 613.649597,864.024048 
	C614.296570,866.721008 613.535034,868.517273 609.742615,867.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1511.719727,859.030884 
	C1510.654785,860.033997 1509.196045,861.025574 1507.389282,862.066040 
	C1508.469482,861.083130 1509.897827,860.051208 1511.719727,859.030884 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M664.174438,1459.007324 
	C663.448669,1459.045898 663.044556,1459.034424 662.340454,1459.067383 
	C662.910889,1458.240723 663.781311,1457.369385 664.651672,1456.498169 
	C664.599792,1457.317871 664.547974,1458.137695 664.174438,1459.007324 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M617.742615,860.787598 
	C618.642883,859.518738 619.992310,858.340210 621.649597,857.024048 
	C622.296570,859.721008 621.535034,861.517273 617.742615,860.787598 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1430.024414,1516.898193 
	C1430.842041,1515.613892 1432.090942,1514.365967 1433.641357,1512.983398 
	C1434.234985,1515.452148 1433.819336,1517.451416 1430.024414,1516.898193 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1526.755371,851.041260 
	C1525.680420,852.043640 1524.209351,853.030334 1522.389771,854.066040 
	C1523.480591,853.085266 1524.919800,852.055420 1526.755371,851.041260 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1547.977905,752.068420 
	C1546.668579,752.934692 1545.177002,753.491028 1543.343262,753.962036 
	C1544.599365,753.170715 1546.197510,752.464661 1547.977905,752.068420 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M561.727417,927.031250 
	C561.304688,927.966431 560.495178,928.890503 559.398071,929.930054 
	C556.514282,926.575256 559.521851,927.235779 561.727417,927.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M570.727478,919.031250 
	C570.304688,919.966431 569.495239,920.890503 568.398071,921.930054 
	C565.514282,918.575256 568.521851,919.235779 570.727478,919.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1496.161621,1451.147949 
	C1496.722656,1449.868774 1497.508179,1448.881958 1498.577637,1447.744385 
	C1498.529907,1449.193604 1500.396973,1452.208008 1496.161621,1451.147949 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M578.727417,912.031250 
	C578.304626,912.966431 577.495117,913.890442 576.398071,914.930054 
	C573.514282,911.575256 576.521851,912.235779 578.727417,912.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M587.727417,904.031250 
	C587.304688,904.966431 586.495178,905.890503 585.398071,906.930054 
	C582.514282,903.575256 585.521851,904.235779 587.727417,904.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M595.727417,897.031189 
	C595.304626,897.966370 594.495117,898.890442 593.398010,899.930054 
	C590.514282,896.575256 593.521851,897.235779 595.727417,897.031189 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1379.496338,833.046021 
	C1379.460693,834.245117 1379.088501,835.490234 1378.413574,836.889832 
	C1378.460571,835.726929 1378.810181,834.409546 1379.496338,833.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M604.727417,889.031250 
	C604.304626,889.966431 603.495178,890.890442 602.398071,891.930054 
	C599.514282,888.575256 602.521851,889.235779 604.727417,889.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M731.850464,424.835846 
	C730.917114,425.793213 729.788696,426.476135 728.330505,427.041687 
	C729.218933,426.136658 730.437195,425.349030 731.850464,424.835846 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M612.727417,882.031250 
	C612.304688,882.966431 611.495178,883.890503 610.398071,884.930054 
	C607.514282,881.575256 610.521851,882.235779 612.727417,882.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M621.727478,874.031250 
	C621.304688,874.966431 620.495239,875.890503 619.398071,876.930054 
	C616.514282,873.575256 619.521851,874.235779 621.727478,874.031250 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1370.496338,852.046021 
	C1370.460571,853.245056 1370.088379,854.490173 1369.413452,855.889832 
	C1369.460571,854.726929 1369.810181,853.409485 1370.496338,852.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1397.496338,795.046021 
	C1397.460693,796.245117 1397.088379,797.490173 1396.413574,798.889832 
	C1396.460571,797.726929 1396.810181,796.409485 1397.496338,795.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M633.860291,1604.139893 
	C634.778198,1605.051147 635.412659,1606.162720 636.098694,1607.609741 
	C635.292480,1606.743652 634.434692,1605.541992 633.860291,1604.139893 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1575.157349,720.148560 
	C1575.699341,718.905151 1576.460083,717.950623 1577.503174,716.874390 
	C1577.637207,718.409180 1579.283325,721.239258 1575.157349,720.148560 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M611.122559,1473.104736 
	C611.740967,1471.930298 612.563782,1471.043945 613.693542,1470.147705 
	C613.574463,1471.604858 615.087280,1474.664429 611.122559,1473.104736 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M638.898193,1400.994019 
	C637.956848,1400.536255 637.051147,1399.667725 636.023193,1398.510254 
	C638.512390,1396.617310 638.808411,1396.847900 638.898193,1400.994019 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M621.859497,1581.141357 
	C622.789795,1582.046387 623.435852,1583.153076 624.138062,1584.594238 
	C623.321167,1583.733521 622.448181,1582.538330 621.859497,1581.141357 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M609.060425,1556.025391 
	C609.931213,1556.987793 610.489624,1558.136475 611.099243,1559.615234 
	C608.815674,1559.687744 607.331360,1558.883057 609.060425,1556.025391 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M646.060364,1627.025391 
	C646.931213,1627.987793 647.489624,1629.136475 648.099182,1630.615234 
	C645.815674,1630.687744 644.331360,1629.883057 646.060364,1627.025391 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1388.496338,814.046021 
	C1388.460693,815.245117 1388.088501,816.490173 1387.413574,817.889832 
	C1387.460571,816.726929 1387.810181,815.409485 1388.496338,814.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1502.163330,1444.149048 
	C1502.720947,1442.853027 1503.504883,1441.850586 1504.570068,1440.684082 
	C1504.510132,1442.128540 1506.438354,1445.160767 1502.163330,1444.149048 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M519.818481,579.056641 
	C519.432251,580.009277 518.669312,580.944580 517.638977,582.023682 
	C515.953064,579.893616 516.098755,579.673462 519.818481,579.056641 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M563.911133,534.942749 
	C563.277954,536.124146 562.456604,537.024902 561.346313,538.038391 
	C561.945984,536.988098 562.834473,535.825073 563.911133,534.942749 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M562.042114,1505.224609 
	C562.994446,1505.639893 563.934814,1506.423462 564.985107,1507.495605 
	C562.813904,1508.958374 562.642761,1508.835938 562.042114,1505.224609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M628.848694,867.836914 
	C628.579468,868.689819 628.112244,869.270325 627.377686,869.948242 
	C626.898438,869.232605 626.686523,868.419495 626.474609,867.606445 
	C627.200012,867.592529 627.925354,867.578613 628.848694,867.836914 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1691.890137,700.945068 
	C1692.026367,700.033142 1692.547974,699.122498 1693.315796,698.011780 
	C1696.027832,700.044556 1693.850952,700.372070 1691.890137,700.945068 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1479.881226,875.881775 
	C1479.267822,876.770203 1478.473999,877.394104 1477.360840,878.066528 
	C1477.927856,877.282410 1478.814331,876.449829 1479.881226,875.881775 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1494.881226,867.881836 
	C1494.267822,868.770203 1493.473999,869.394104 1492.360840,870.066528 
	C1492.927856,869.282471 1493.814453,868.449829 1494.881226,867.881836 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1556.881348,834.881836 
	C1556.267822,835.770264 1555.473999,836.394104 1554.360840,837.066528 
	C1554.927856,836.282471 1555.814453,835.449890 1556.881348,834.881836 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M692.881348,443.881714 
	C692.269470,444.773590 691.477234,445.400909 690.363159,446.071594 
	C690.927979,445.282379 691.814514,444.449768 692.881348,443.881714 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1571.881226,826.881775 
	C1571.267822,827.770264 1570.473999,828.394104 1569.360840,829.066528 
	C1569.927856,828.282410 1570.814331,827.449829 1571.881226,826.881775 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M847.163940,792.847900 
	C846.315369,792.238281 845.740662,791.430847 845.166382,790.311218 
	C845.923828,790.882751 846.680786,791.766418 847.163940,792.847900 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M635.937378,1124.013916 
	C635.309998,1124.190308 634.960327,1124.189087 634.348511,1124.212402 
	C634.575806,1123.549438 635.065186,1122.862061 635.554565,1122.174683 
	C635.774780,1122.728638 635.994873,1123.282471 635.937378,1124.013916 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M654.061646,1399.986328 
	C654.678162,1399.749512 655.014954,1399.694946 655.606934,1399.612549 
	C655.416809,1400.328003 654.971436,1401.071533 654.526001,1401.814941 
	C654.277954,1401.266235 654.029907,1400.717407 654.061646,1399.986328 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M501.044495,1402.199463 
	C501.662476,1402.314209 502.268341,1402.778198 502.986206,1403.510010 
	C502.409576,1403.368042 501.720978,1402.958374 501.044495,1402.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M557.044556,1448.199463 
	C557.662415,1448.314087 558.268311,1448.778198 558.986145,1449.510010 
	C558.409607,1449.368042 557.721069,1448.958374 557.044556,1448.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M653.750305,1444.030884 
	C653.669189,1444.649780 653.237671,1445.262207 652.555298,1446.008301 
	C652.026245,1445.685303 651.747986,1445.228638 651.469727,1444.772095 
	C652.113159,1444.522949 652.756592,1444.273804 653.750305,1444.030884 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M508.982544,1451.064941 
	C509.819458,1451.388550 510.382324,1451.894409 511.044464,1452.673096 
	C510.331970,1452.379761 509.520264,1451.813477 508.982544,1451.064941 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M445.044495,1356.199463 
	C445.662476,1356.314087 446.268341,1356.778198 446.986206,1357.510010 
	C446.409576,1357.368164 445.720978,1356.958496 445.044495,1356.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M529.044495,1425.199463 
	C529.662415,1425.314209 530.268250,1425.778198 530.986084,1426.510010 
	C530.409546,1426.368164 529.721008,1425.958496 529.044495,1425.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M599.838135,1634.056396 
	C599.730530,1634.684448 599.268677,1635.296143 598.535095,1636.013428 
	C598.008057,1635.651245 597.752747,1635.183716 597.497498,1634.716064 
	C598.159668,1634.490723 598.821777,1634.265381 599.838135,1634.056396 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M591.838135,1643.056396 
	C591.730591,1643.684570 591.268799,1644.296265 590.535156,1645.013428 
	C590.008057,1644.651245 589.752747,1644.183716 589.497498,1643.716064 
	C590.159607,1643.490723 590.821777,1643.265259 591.838135,1643.056396 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M681.125000,1650.953613 
	C681.255432,1650.015259 681.777588,1649.026367 682.589355,1647.851807 
	C682.424866,1648.745117 681.970703,1649.824097 681.125000,1650.953613 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M694.121582,1628.955078 
	C694.257996,1628.025391 694.782593,1627.046753 695.601074,1625.894043 
	C695.433289,1626.781860 694.971558,1627.843994 694.121582,1628.955078 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M473.044495,1379.199463 
	C473.662476,1379.314087 474.268341,1379.778198 474.986206,1380.510010 
	C474.409607,1380.368042 473.721008,1379.958374 473.044495,1379.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1568.121094,1350.953613 
	C1568.251831,1350.013916 1568.774780,1349.023804 1569.587769,1347.848145 
	C1569.423096,1348.742798 1568.968262,1349.822998 1568.121094,1350.953613 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M516.944824,1460.090698 
	C517.801697,1460.395874 518.389282,1460.888062 519.081726,1461.654663 
	C518.349548,1461.378662 517.512512,1460.828247 516.944824,1460.090698 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M464.079987,1393.121582 
	C464.816589,1393.551758 465.530548,1394.377930 466.288025,1395.543823 
	C465.573425,1395.094849 464.815399,1394.306274 464.079987,1393.121582 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M645.950562,1391.087524 
	C646.809021,1391.392578 647.396973,1391.884521 648.089233,1392.651367 
	C647.355713,1392.375732 646.517944,1391.825073 645.950562,1391.087524 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M668.125000,1672.953613 
	C668.252869,1672.011841 668.772339,1671.019531 669.585327,1669.846680 
	C669.424744,1670.745239 668.970642,1671.824219 668.125000,1672.953613 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M585.044556,1471.199463 
	C585.662415,1471.314087 586.268250,1471.778198 586.986084,1472.510010 
	C586.409607,1472.368042 585.721069,1471.958374 585.044556,1471.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M665.171753,1677.952393 
	C665.295532,1677.025269 665.802063,1676.046021 666.601807,1674.893311 
	C666.448120,1675.779907 666.001282,1676.840088 665.171753,1677.952393 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M636.987183,1381.066162 
	C637.849548,1381.374634 638.435059,1381.869507 639.127136,1382.637817 
	C638.392578,1382.358276 637.551453,1381.805420 636.987183,1381.066162 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M389.044495,1310.199463 
	C389.662445,1310.314209 390.268341,1310.778198 390.986206,1311.510010 
	C390.409607,1311.368042 389.721008,1310.958374 389.044495,1310.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M522.247070,954.919556 
	C522.374084,954.023682 522.863037,953.088684 523.654785,952.020081 
	C523.507935,952.884460 523.058472,953.882446 522.247070,954.919556 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M532.247070,941.919556 
	C532.374084,941.023682 532.863098,940.088745 533.654785,939.020142 
	C533.507935,939.884460 533.058472,940.882446 532.247070,941.919556 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M535.247070,937.919556 
	C535.374146,937.023743 535.863159,936.088806 536.654785,935.020142 
	C536.507996,935.884460 536.058533,936.882507 535.247070,937.919556 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M538.249756,933.918701 
	C538.387451,933.013184 538.889832,932.067749 539.698242,930.981323 
	C539.541016,931.853088 539.077698,932.865967 538.249756,933.918701 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M541.204224,929.955261 
	C541.340088,929.055847 541.843018,928.107544 542.651672,927.022827 
	C542.495361,927.893066 542.033264,928.899658 541.204224,929.955261 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M448.117798,1099.955078 
	C448.254425,1099.024048 448.779877,1098.044434 449.599609,1096.890625 
	C449.431458,1097.779663 448.969055,1098.843140 448.117798,1099.955078 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M623.699219,855.784668 
	C624.300293,855.144043 625.296814,854.590637 626.646118,854.102051 
	C626.030884,854.735229 625.062683,855.303650 623.699219,855.784668 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1573.799561,740.044922 
	C1573.703369,740.675232 1573.255737,741.293579 1572.536865,742.016113 
	C1572.006226,741.657166 1571.746582,741.194092 1571.486938,740.730957 
	C1572.140625,740.498291 1572.794189,740.265625 1573.799561,740.044922 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1638.794556,735.045288 
	C1638.727051,735.675842 1638.302856,736.294739 1637.624023,737.041321 
	C1637.073364,736.710754 1636.777588,736.252502 1636.481689,735.794189 
	C1637.133667,735.540649 1637.785767,735.287170 1638.794556,735.045288 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1579.873047,733.068604 
	C1579.784180,733.696045 1579.333252,734.302917 1578.625732,735.039429 
	C1578.079834,734.701538 1577.790649,734.233948 1577.501343,733.766357 
	C1578.171143,733.526917 1578.841064,733.287476 1579.873047,733.068604 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1586.838013,725.057373 
	C1586.744141,725.686890 1586.293457,726.299866 1585.577393,727.027710 
	C1585.039673,726.676697 1584.767334,726.210754 1584.494995,725.744873 
	C1585.157104,725.510193 1585.819214,725.275513 1586.838013,725.057373 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M425.117859,1137.955078 
	C425.254517,1137.024048 425.779968,1136.044556 426.599670,1134.890625 
	C426.431488,1135.779663 425.969086,1136.843140 425.117859,1137.955078 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1655.835205,715.057495 
	C1655.756592,715.686523 1655.318481,716.299194 1654.624634,717.040527 
	C1654.076660,716.705994 1653.784302,716.242859 1653.492065,715.779663 
	C1654.153320,715.533508 1654.814575,715.287292 1655.835205,715.057495 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1599.873047,710.068604 
	C1599.784302,710.696106 1599.333374,711.302979 1598.625732,712.039490 
	C1598.079834,711.701538 1597.790649,711.233948 1597.501343,710.766357 
	C1598.171143,710.526917 1598.841064,710.287476 1599.873047,710.068604 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1661.797241,708.045044 
	C1661.714478,708.676208 1661.277710,709.295410 1660.576416,710.028625 
	C1660.036011,709.681458 1659.760010,709.220337 1659.484009,708.759216 
	C1660.137085,708.517212 1660.790161,708.275208 1661.797241,708.045044 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M361.044495,1287.199463 
	C361.662415,1287.314209 362.268280,1287.778320 362.986206,1288.510010 
	C362.409637,1288.368042 361.721039,1287.958374 361.044495,1287.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M498.894592,1245.003174 
	C498.178192,1244.526611 497.494263,1243.649048 496.785065,1242.428223 
	C497.482208,1242.924072 498.204651,1243.763306 498.894592,1245.003174 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M417.044464,1333.199463 
	C417.662415,1333.314209 418.268280,1333.778320 418.986176,1334.510010 
	C418.409607,1334.368042 417.721008,1333.958374 417.044464,1333.199463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M579.915283,520.952881 
	C579.601318,521.797913 579.102844,522.373108 578.330933,523.049683 
	C578.615173,522.328430 579.172913,521.505737 579.915283,520.952881 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M572.915161,526.952881 
	C572.603394,527.800903 572.106934,528.379150 571.333923,529.054321 
	C571.615173,528.328430 572.172852,527.505737 572.915161,526.952881 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M510.873352,589.068726 
	C510.784607,589.696289 510.333679,590.303223 509.626068,591.039734 
	C509.080078,590.701660 508.790771,590.234009 508.501404,589.766357 
	C509.171356,589.526917 509.841278,589.287537 510.873352,589.068726 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M504.835754,596.057617 
	C504.757111,596.686707 504.318970,597.299377 503.625122,598.040649 
	C503.076904,597.706055 502.784393,597.242920 502.491882,596.779785 
	C503.153320,596.533630 503.814758,596.287415 504.835754,596.057617 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M466.078949,646.149536 
	C465.898285,647.092224 465.310120,648.033997 464.422089,649.156616 
	C464.638641,648.274414 465.155029,647.211487 466.078949,646.149536 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M451.937073,667.137146 
	C451.807434,668.110718 451.273865,669.100952 450.444153,670.285400 
	C450.609680,669.371033 451.071411,668.262390 451.937073,667.137146 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1606.838013,702.057373 
	C1606.744141,702.686829 1606.293457,703.299866 1605.577393,704.027710 
	C1605.039673,703.676697 1604.767334,703.210754 1604.494995,702.744873 
	C1605.157104,702.510193 1605.819214,702.275574 1606.838013,702.057373 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M594.033325,1529.901855 
	C593.815186,1529.475342 593.907288,1529.051514 594.086060,1528.314453 
	C594.648987,1528.299072 595.125244,1528.597046 595.601562,1528.895020 
	C595.182190,1529.231445 594.762817,1529.567993 594.033325,1529.901855 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M407.840881,747.069092 
	C408.004364,747.640686 407.855591,748.225525 407.427460,748.935242 
	C407.274933,748.400879 407.401794,747.741577 407.840881,747.069092 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1645.452026,895.952026 
	C1645.096680,895.555969 1645.026611,895.112793 1645.001709,894.335144 
	C1645.560181,894.300964 1646.073242,894.601257 1646.586304,894.901550 
	C1646.303345,895.235962 1646.020264,895.570435 1645.452026,895.952026 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1128.114502,1664.132324 
	C1128.430908,1663.578125 1128.906738,1663.266724 1129.691406,1663.001221 
	C1129.424683,1663.489868 1128.849487,1663.932617 1128.114502,1664.132324 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1314.931885,445.842957 
	C1314.363647,445.992218 1313.782959,445.831207 1313.079102,445.391052 
	C1313.610352,445.252136 1314.264893,445.392426 1314.931885,445.842957 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M901.045044,931.447144 
	C901.446472,931.120911 901.892151,931.075073 902.668457,931.098022 
	C902.680603,931.647278 902.362061,932.127686 902.043457,932.608154 
	C901.725403,932.314636 901.407288,932.021057 901.045044,931.447144 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M707.057129,1606.978027 
	C706.929749,1606.406616 707.124146,1605.812744 707.604675,1605.087891 
	C707.720215,1605.623047 707.549561,1606.289307 707.057129,1606.978027 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M426.881714,709.079834 
	C427.033661,709.652832 426.870331,710.233093 426.427521,710.936768 
	C426.287476,710.402466 426.426910,709.744751 426.881714,709.079834 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M839.010803,387.101746 
	C838.638672,387.616852 838.117554,387.853912 837.298218,388.055786 
	C837.620605,387.621643 838.241211,387.222656 839.010803,387.101746 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1247.931885,1017.842590 
	C1247.363770,1017.991760 1246.783081,1017.830750 1246.079224,1017.390625 
	C1246.610474,1017.251709 1247.264893,1017.392029 1247.931885,1017.842590 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1256.920410,1022.881470 
	C1256.351440,1023.029907 1255.775024,1022.862976 1255.069458,1022.421997 
	C1255.597900,1022.287292 1256.255493,1022.426697 1256.920410,1022.881470 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1270.931885,1030.842407 
	C1270.363647,1030.991577 1269.783081,1030.830566 1269.079102,1030.390381 
	C1269.610352,1030.251465 1270.264771,1030.391846 1270.931885,1030.842407 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1286.931152,1039.840332 
	C1286.363281,1040.000366 1285.782227,1039.848022 1285.070679,1039.421753 
	C1285.599487,1039.274536 1286.258667,1039.401367 1286.931152,1039.840332 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1293.931885,1043.842407 
	C1293.363647,1043.991577 1292.783081,1043.830566 1292.079102,1043.390381 
	C1292.610352,1043.251465 1293.264771,1043.391846 1293.931885,1043.842407 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1300.931885,1047.842407 
	C1300.363647,1047.991577 1299.783081,1047.830566 1299.079102,1047.390381 
	C1299.610352,1047.251465 1300.264771,1047.391846 1300.931885,1047.842407 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1309.920410,1052.881104 
	C1309.351196,1053.029419 1308.774780,1052.862671 1308.069336,1052.421753 
	C1308.597778,1052.286987 1309.255493,1052.426392 1309.920410,1052.881104 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1263.931885,1026.842407 
	C1263.363647,1026.991577 1262.783081,1026.830566 1262.079102,1026.390381 
	C1262.610352,1026.251465 1263.264771,1026.391846 1263.931885,1026.842407 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1645.335938,1147.962769 
	C1645.034668,1147.552490 1645.022095,1147.104980 1645.088257,1146.329102 
	C1645.642090,1146.337158 1646.117432,1146.673462 1646.592651,1147.009766 
	C1646.270020,1147.315063 1645.947266,1147.620239 1645.335938,1147.962769 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1106.836914,1141.610352 
	C1106.664795,1141.712646 1106.355103,1141.627441 1105.954590,1141.293945 
	C1106.183838,1141.079346 1106.462402,1141.205200 1106.836914,1141.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1174.842773,1171.611816 
	C1174.673340,1171.707520 1174.371948,1171.617310 1173.985718,1171.279663 
	C1174.213135,1171.076172 1174.483032,1171.207397 1174.842773,1171.611816 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1180.359619,1143.849609 
	C1180.268188,1143.676758 1180.369629,1143.373657 1180.719482,1142.985596 
	C1180.919678,1143.219238 1180.781250,1143.492188 1180.359619,1143.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1115.836914,1145.610474 
	C1115.664673,1145.712646 1115.355103,1145.627563 1114.954590,1145.294067 
	C1115.183838,1145.079346 1115.462402,1145.205200 1115.836914,1145.610474 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1124.842773,1149.611816 
	C1124.673340,1149.707520 1124.371948,1149.617310 1123.985718,1149.279663 
	C1124.213135,1149.076172 1124.483032,1149.207397 1124.842773,1149.611816 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1177.359619,1151.849609 
	C1177.268188,1151.676758 1177.369751,1151.373657 1177.719482,1150.985596 
	C1177.919678,1151.219238 1177.781250,1151.492188 1177.359619,1151.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1131.836914,1152.610352 
	C1131.664795,1152.712646 1131.355103,1152.627441 1130.954590,1152.293945 
	C1131.183838,1152.079346 1131.462402,1152.205200 1131.836914,1152.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1140.836914,1156.610352 
	C1140.664795,1156.712646 1140.355103,1156.627563 1139.954590,1156.293945 
	C1140.183838,1156.079346 1140.462402,1156.205200 1140.836914,1156.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1149.842773,1160.611816 
	C1149.673340,1160.707520 1149.371948,1160.617310 1148.985718,1160.279663 
	C1149.213135,1160.076172 1149.483032,1160.207397 1149.842773,1160.611816 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1197.849731,1161.640381 
	C1197.676880,1161.731567 1197.373901,1161.630005 1196.985840,1161.280273 
	C1197.219238,1161.080444 1197.492310,1161.218994 1197.849731,1161.640381 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1156.836914,1163.610352 
	C1156.664795,1163.712646 1156.355103,1163.627563 1155.954590,1163.293945 
	C1156.183838,1163.079346 1156.462402,1163.205200 1156.836914,1163.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1165.836914,1167.610352 
	C1165.664795,1167.712524 1165.355103,1167.627441 1164.954590,1167.293945 
	C1165.183838,1167.079346 1165.462402,1167.205200 1165.836914,1167.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1099.842773,1138.611816 
	C1099.673340,1138.707520 1099.371948,1138.617310 1098.985718,1138.279663 
	C1099.213135,1138.076172 1099.483032,1138.207397 1099.842773,1138.611816 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M722.030518,1604.193848 
	C722.209167,1604.231934 722.376404,1604.575928 722.292969,1605.015625 
	C722.034668,1604.907593 722.026917,1604.703735 722.030518,1604.193848 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1183.359619,1135.849609 
	C1183.268188,1135.676758 1183.369751,1135.373657 1183.719482,1134.985596 
	C1183.919678,1135.219238 1183.781250,1135.492188 1183.359619,1135.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1090.836914,1134.610352 
	C1090.664795,1134.712646 1090.355103,1134.627441 1089.954590,1134.293945 
	C1090.183838,1134.079346 1090.462402,1134.205200 1090.836914,1134.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1081.836914,1130.610352 
	C1081.664795,1130.712646 1081.355103,1130.627441 1080.954590,1130.293945 
	C1081.183838,1130.079346 1081.462402,1130.205200 1081.836914,1130.610352 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1186.359619,1127.849609 
	C1186.268066,1127.676758 1186.369629,1127.373657 1186.719482,1126.985596 
	C1186.919678,1127.219238 1186.781250,1127.492188 1186.359619,1127.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1074.842773,1127.611694 
	C1074.673340,1127.707397 1074.371948,1127.617188 1073.985718,1127.279541 
	C1074.213135,1127.076172 1074.483032,1127.207397 1074.842773,1127.611694 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1189.359619,1119.849609 
	C1189.268188,1119.676758 1189.369751,1119.373657 1189.719482,1118.985596 
	C1189.919678,1119.219238 1189.781250,1119.492188 1189.359619,1119.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1056.359497,1114.849487 
	C1056.268188,1114.676758 1056.369873,1114.373657 1056.719727,1113.985596 
	C1056.919434,1114.219116 1056.780884,1114.492065 1056.359497,1114.849487 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1192.359619,1111.849609 
	C1192.268066,1111.676758 1192.369629,1111.373657 1192.719482,1110.985596 
	C1192.919678,1111.219238 1192.781250,1111.492188 1192.359619,1111.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1195.359497,1103.849609 
	C1195.268066,1103.676636 1195.369629,1103.373657 1195.719482,1102.985596 
	C1195.919678,1103.219238 1195.781250,1103.492188 1195.359497,1103.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1198.359619,1095.849609 
	C1198.268066,1095.676758 1198.369629,1095.373657 1198.719482,1094.985596 
	C1198.919678,1095.219238 1198.781250,1095.492188 1198.359619,1095.849609 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1201.359619,1087.849609 
	C1201.268188,1087.676758 1201.369751,1087.373657 1201.719482,1086.985596 
	C1201.919678,1087.219238 1201.781250,1087.492188 1201.359619,1087.849609 
z"
      />
    </svg>
  );
};

PatternsAndPrinciplesIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

PatternsAndPrinciplesIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default PatternsAndPrinciplesIllustration;
